import { en } from "./en";

export const te: typeof en = {
  // Navbar
  nav: {
    home: "హోమ్",
    product: "ఉత్పత్తి",
    industry: "పరిశ్రమ",
    gallery: "గ్యాలరీ",
    contribution: "భాగస్వామ్యం",
    dealer: "సేల్స్ పార్టనర్స్",
    team: "టీమ్",
    about: "మా గురించి",
    bookNow: "ఇప్పుడే బుక్ చేయండి",
    resources: "వనరులు",
    news: "వార్తలు",
    blog: "బ్లాగ్",
    evBlog: "ఈవీ బ్లాగ్",
    newsDesc: "పత్రికా ప్రకటనలు & ప్రకటనలు",
    blogDesc: "క్షేత్రం నుండి కథనాలు",
    evBlogDesc: "ఎలక్ట్రిక్ వాహన విశ్లేషణలు",
  },
  // Home
  home: {
    metaTitle: "భారతదేశంలో ఎలక్ట్రిక్ ట్రాక్టర్ తయారీదారు | స్వయంప్రతిపత్త ఎలక్ట్రిక్ ట్రాక్టర్లు | AutoNXT",
    // heroBadge: "భారతదేశపు మొట్టమొదటి ఎలక్ట్రిక్ ట్రాక్టర్ మార్గదర్శకుడు",
    heroTitle1: "రేపటి కోసం",
    heroTitleHighlight: "హరిత",
    heroTitle2: " సాంకేతికత.",
    heroDesc: "AutoNXT భారతదేశపు ప్రముఖ ఎలక్ట్రిక్ ట్రాక్టర్ తయారీదారు, వ్యవసాయ మరియు పారిశ్రామిక అనువర్తనాల కోసం AI-ఆధారిత ఎలక్ట్రిక్ మరియు స్వయంప్రతిపత్త ట్రాక్టర్లను తయారు చేస్తుంది. సున్నా-ఉద్గార వ్యవసాయ పరిష్కారాలు, అధునాతన బ్యాటరీ సాంకేతికతను అన్వేషించండి మరియు ఈ రోజు డెమో బుక్ చేయండి.",
    heroAutomation: {
      titlePart1: "భారతదేశపు ఎలక్ట్రిక్ & ",
      titleHighlight: "స్వయంప్రతిపత్త ట్రాక్టర్ తయారీదారు",
      subtitle:
        "AutoNXT వ్యవసాయం, పారిశ్రామిక లాజిస్టిక్స్ మరియు స్థిరమైన వ్యవసాయం కోసం AI-ఆధారిత ఎలక్ట్రిక్ ట్రాక్టర్లను డిజైన్ చేస్తుంది మరియు తయారు చేస్తుంది.",
      featureCards: [
        { title: "స్మార్ట్ టెక్నాలజీ", desc: "గరిష్ట సామర్థ్యం కోసం AI-ఆధారిత సిస్టమ్‌లు." },
        { title: "అధిక పనితీరు", desc: "శక్తి, ఖచ్చితత్వం మరియు ఉత్పాదకత కోసం రూపొందించబడింది." },
        { title: "నమ్మకమైన మరియు బలమైన", desc: "ప్రతి రకమైన భూమి మరియు పరిస్థితికి బలమైన నిర్మాణం." },
        { title: "స్థిరమైన భవిష్యత్తు", desc: "మెరుగైన రేపటి కోసం పర్యావరణ అనుకూల పరిష్కారాలు." },
      ],
      taglineBold: "నవీకరించండి. ఆటోమేట్ చేయండి. ఎత్తుకు ఎగరండి.",
      taglineNormal: "భవిష్యత్తు తెలివైనది. భవిష్యత్తు స్వయంప్రతిపత్తి.",
      bottomFeatures: [
        { title: "AI & ఆటోమేషన్", desc: "స్మార్ట్ ఆపరేషన్ల కోసం తెలివైన నియంత్రణ." },
        { title: "ఖచ్చితత్వం & నియంత్రణ", desc: "ఖచ్చితమైన పనితీరు కోసం అధునాతన సాంకేతికత." },
        { title: "గరిష్ట సామర్థ్యం", desc: "ఉత్పాదకతను పెంచండి మరియు డౌన్‌టైమ్‌ను తగ్గించండి." },
        { title: "భవిష్యత్తు కోసం సిద్ధం", desc: "రేపటి ప్రపంచం కోసం తాజా సాంకేతికత." },
      ],
    },
    heroDescs: [
      {
        titlePart1: "భారీ పరిశ్రమల కోసం",
        titleHighlight: "స్మార్ట్ సొల్యూషన్స్",
        normalText: "మా అత్యాధునిక ఆటోమేషన్ సిస్టమ్‌లతో మీ పారిశ్రామిక కార్యకలాపాలను మార్చుకోండి. నిర్మాణం నుండి తయారీ వరకు, మేము తెలివైన పరిష్కారాలను అందిస్తాము."
      },
      {
        titlePart1: "రేపటి కోసం",
        titleHighlight: "హరిత సాంకేతికత",
        normalText: "మా పర్యావరణ అనుకూల సాంకేతిక పరిష్కారాలతో హరిత విప్లవంలో భాగస్వామ్యం అవ్వండి. మెరుగైన ప్రపంచం కోసం స్వచ్ఛమైన ఇంధనం, స్మార్ట్ సిస్టమ్‌లు మరియు స్థిరమైన పద్ధతులు."
      },
      {
        titlePart1: "ఆధునిక వ్యవసాయం కోసం",
        titleHighlight: "ఎలక్ట్రిక్ ట్రాక్టర్లు",
        normalText: "మా అధునాతన ఎలక్ట్రిక్ ట్రాక్టర్లతో సున్నా-ఉద్గారాల వ్యవసాయాన్ని అనుభవించండి. వ్యవసాయ భవిష్యత్తు కోసం స్థిరమైన, శక్తివంతమైన మరియు తెలివైన పరిష్కారాలు."
      }
    ],
    exploreProducts: "ఉత్పత్తులను అన్వేషించండి",
    bookNow: "ఇప్పుడే బుక్ చేయండి",
    statsTitle: "భారతదేశపు అత్యుత్తమ సంస్థల నమ్మకం",
    videosTitle: "X45H2 పనితీరును వీక్షించండి.",
    videosDesc: "మా యూట్యూబ్ ఛానెల్ నుండి నేరుగా నిజమైన వీడియోలు — నీటితో నిండిన వరి పొలాల నుండి పారిశ్రామిక రవాణా వరకు.",
    viewChannel: "ఛానెల్‌ని వీక్షించండి",
    viewGallery: "పూర్తి గ్యాలరీని వీక్షించండి",
    fieldBannerTag: "పొలంలో",
    fieldBannerTitle: "సూర్యోదయం నుండి సూర్యాస్తమయం వరకు.",
    fieldBannerDesc: "ఒక ఛార్జ్. రోజంతా. ప్రతి సీజన్. ఆటోనెక్స్ట్ భారతీయ వ్యవసాయ శైలికి సరిపోయేలా నిర్మించబడింది.",
    fieldBannerImage: "/sun.webp",
    faqTitle: "తరచుగా అడిగే ప్రశ్నలు",
    ctaTitle: "ఎలక్ట్రిక్‌గా మారడానికి సిద్ధంగా ఉన్నారా?",
    ctaDesc: "సున్నా ఉద్గారాలతో మీ కార్యకలాపాలకు శక్తి ఇవ్వండి. పొలాల నుండి కర్మాగారాల వరకు, ఆటోనెక్స్ట్ అందుబాటులో ఉంది.",
    ourStory: "మా కథ",
    faqSub: "ప్రశ్న ఉందా? సమాధానం కనుగొనండి.",
    faqDesc: "మా ఎలక్ట్రిక్ ట్రాక్టర్ల గురించి తరచుగా అడిగే ప్రశ్నలు.",
    faqCategories: {
      all: "అన్నీ",
      technical: "సాంకేతిక వివరాలు",
      charging: "ఛార్జింగ్ & బ్యాటరీ",
      apps: "అప్లికేషన్లు & అనుకూలత",
      cost: "ధర & ఆర్థిక సహాయం",
      perf: "పనితీరు & సామర్థ్యం",
    },
    faqs: [
      {
        q: "డీజిల్ ట్రాక్టర్ల కంటే ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్లను ఎందుకు ఎంచుకోవాలి?",
        a: "ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్లు చాలా తక్కువ నిర్వహణ ఖర్చులను అందిస్తాయి — డీజిల్ కంటే గంటకు విద్యుత్ ఖర్చు 70% వరకు చౌకగా ఉంటుంది. ఇవి సున్నా ప్రత్యక్ష ఉద్గారాలను విడుదల చేస్తాయి, తక్కువ కదిలే భాగాలను కలిగి ఉంటాయి (దీని అర్థం తక్కువ నిర్వహణ ఖర్చులు), స్టార్టప్ నుండి తక్షణ పూర్తి టార్క్‌ను అందిస్తాయి మరియు శబ్దం లేకుండా పనిచేస్తాయి. 5 సంవత్సరాల కాలంలో, రైతులు సాధారణంగా డీజిల్ ట్రాక్టర్లతో పోలిస్తే ₹3–5 లక్షలు ఆదా చేస్తారు.",
      },
      {
        q: "ఒక సింగిల్ ఛార్జ్‌పై ట్రాక్టర్ ఎన్ని గంటలు పనిచేస్తుంది?",
        a: "మా ట్రాక్టర్లు పూర్తి పనిదినం కోసం రూపొందించబడ్డాయి. X45H2 ఒక ఛార్జ్‌పై 8–10 గంటల సాధారణ క్షేత్ర కార్యకలాపాలను అందిస్తుంది. లోతైన దున్నడం లేదా భారీ రవాణా వంటి పనుల కోసం 6–8 గంటల పనితీరును ఆశించవచ్చు. మా స్మార్ట్ బ్యాటరీ మేనేజ్‌మెంట్ సిస్టమ్ మీకు రియల్ టైమ్ పరిధి అంచనాలను అందిస్తుంది, తద్వారా మీరు ఎప్పుడూ ఇబ్బంది పడరు.",
      },
      {
        q: "ట్రాక్టర్ 0-100% ఛార్జ్ అవ్వడానికి ఎంత సమయం పడుతుంది?",
        a: "మా ప్రామాణిక AC ఛార్జర్ (ఉచితంగా ఇవ్వబడుతుంది) ఉపయోగించి, పూర్తి ఛార్జ్ కావడానికి సుమారు 6–8 గంటలు పడుతుంది — ఇది రాత్రిపూట ఛార్జింగ్‌కు అనువైనది. మా ఐచ్ఛిక DC ఫాస్ట్ ఛార్జర్‌తో, మీరు 3 గంటలలోపే 80% ఛార్జ్ చేరుకోవచ్చు. ప్రామాణిక భారతీయ విద్యుత్ ధరల ప్రకారం పూర్తి ఛార్జ్ కావడానికి సుమారు ₹150–200 ఖర్చవుతుంది.",
      },
      {
        q: "ఆటోనెక్స్ట్ ట్రాక్టర్లతో ఏ పరికరాలను ఉపయోగించవచ్చు?",
        a: "ఆటోనెక్స్ట్ ట్రాక్టర్లు రోటవేటర్లు, నాగళ్లు, సీడ్ డ్రిల్స్, కల్టివేటర్లు, హారోలు మరియు పోస్ట్-హోల్ డిగ్గర్లతో సహా అన్ని ప్రామాణిక 3-పాయింట్ హిచ్ పరికరాలకు అనుకూలంగా ఉంటాయి. PTO (పవర్ టేక్-ఆఫ్) చాలా ప్రామాణిక భారతీయ వ్యవసాయ పరికరాలకు అనుకూలంగా ఉంటుంది. నిర్దిష్ట పరికరాల అనుకూలత కోసం మా బృందం మీకు సలహా ఇవ్వగలదు.",
      },
      {
        q: "ట్రాక్టర్‌ను ఇంట్లోనే ఛార్జ్ చేయవచ్చా?",
        a: "అవును. మా ప్రామాణిక ఛార్జర్ ఏదైనా 15-amp సింగిల్-ఫేజ్ సాకెట్‌లోకి కనెక్ట్ అవుతుంది — ఇది సాధారణ గృహ పవర్ పాయింట్ లాంటిదే. దీని కోసం మీకు ప్రత్యేక ఛార్జింగ్ స్టేషన్ అవసరం లేదు. వేగవంతమైన ఛార్జింగ్ కోసం, మేము ప్రత్యేకంగా 32-amp సర్క్యూట్‌ను సిఫార్సు చేస్తున్నాము, ఇది చాలా వ్యవసాయ కుటుంబాలలో పంపు కనెక్షన్ల కోసం ఇప్పటికే అందుబాటులో ఉంటుంది.",
      },
      {
        q: "భారీ పనుల కోసం ట్రాక్టర్‌లో తగినంత శక్తి ఉందా?",
        a: "ఖచ్చితంగా. డీజిల్ ఇంజిన్‌ల వలె కాకుండా, ఎలక్ట్రిక్ మోటార్లు సున్నా RPM నుండి గరిష్ట టార్క్‌ను అందిస్తాయి. X45H2 మోటార్ ఆచరణాత్మక క్షేత్ర పనులలో 55HP డీజిల్ ట్రాక్టర్‌తో సమానమైన లాగుడు శక్తిని ఉత్పత్తి చేస్తుంది. డీజిల్ నుండి ఎలక్ట్రిక్‌కు మారిన రైతులు తడి వరి పొలాలు మరియు భారీ నేలల వంటి కఠినమైన పరిస్థితులలో మెరుగైన పనితీరును నివేదిస్తున్నారు.",
      },
      {
        q: "ఎన్ని సంవత్సరాల తర్వాత బ్యాటరీని మార్చాల్సి ఉంటుంది?",
        a: "మా లిథియం ఐరన్ ఫాస్ఫేట్ (LFP) బ్యాటరీ ప్యాక్‌లు 3,000+ ఛార్జ్ సైకిళ్లకు రేట్ చేయబడ్డాయి, ఇందులో 20% కంటే తక్కువ సామర్థ్యం క్షీణత ఉంటుంది — ఇది దాదాపు 8–10 సంవత్సరాల సాధారణ వ్యవసాయ వినియోగానికి సమానం. బ్యాటరీ 5 సంవత్సరాల / 3,000-సైకిల్ వారంటీతో వస్తుంది. వారంటీ తర్వాత, బ్యాటరీని మాడ్యులర్ యూనిట్‌గా మార్చుకోవచ్చు.",
      },
      {
        q: "ఎలక్ట్రిక్ ట్రాక్టర్లను ఉపయోగించడం వల్ల నాకు ఎంత ఆదా అవుతుంది?",
        a: "సగటున, సమానమైన శక్తి కలిగిన డీజిల్ ట్రాక్టర్‌తో పోలిస్తే ఆటోనెక్స్ట్ యజమానులు ఇంధనం మరియు నిర్వహణపై సంవత్సరానికి ₹60,000–₹90,000 ఆదా చేస్తారు. 5 సంవత్సరాలలో అది ₹3–4.5 లక్షల ప్రత్యక్ష పొదుపు అవుతుంది, ప్రభుత్వ రాయితీలు మరియు కార్బన్ క్రెడిట్‌లను పరిగణనలోకి తీసుకోకుండా. మా ఫైనాన్స్ కాలిక్యులేటర్ మీకు వ్యక్తిగతీకరించిన అంచనాను ఇవ్వగలదు.",
      },
      {
        q: "ట్రాక్టర్ రిమోట్ కంట్రోల్ ద్వారా పనిచేస్తుందా?",
        a: "మా కమర్షియల్ శ్రేణిలోని ఎంపిక చేసిన మోడల్‌లు ఐచ్ఛిక GPS-గైడెడ్ స్వయంప్రతిపత్త (అటానమస్) ఆపరేషన్ మరియు ఆటోనెక్స్ట్ NXT-OS యాప్ ద్వారా రిమోట్ మానిటరింగ్‌ను అందిస్తాయి. ప్రామాణిక శ్రేణి పూర్తి టెలిమాటిక్స్‌ను కలిగి ఉంటుంది — మీరు లొకేషన్, బ్యాటరీ ఆరోగ్యం మరియు వినియోగ డేటాను రిమోట్‌గా పర్యవేక్షించవచ్చు. పారిశ్రామిక మరియు విమానాశ్రయ అప్లికేషన్ల కోసం పూర్తి స్వయంప్రతిపత్త డ్రైవింగ్ అందుబాటులో ఉంది.",
      },
      {
        q: "ట్రాక్టర్ కొనుగోలు చేయడానికి ఏదైనా ఫైనాన్సింగ్ ఆప్షన్లు ఉన్నాయా?",
        a: "అవును. మేము ప్రముఖ గ్రామీణ బ్యాంకులు మరియు NBFCలతో భాగస్వామ్యం కలిగి ఉన్నాము, కనీసం 10% డౌన్ పేమెంట్‌తో ₹8,000/నెల నుండి ప్రారంభమయ్యే EMI ప్లాన్‌లను అందిస్తున్నాము. కిసాన్ క్రెడిట్ కార్డ్ (KCC) హోల్డర్లకు ప్రాధాన్యత వడ్డీ రేట్లు లభిస్తాయి. అదనంగా, బహుళ రాష్ట్ర ప్రభుత్వాలు వ్యవసాయ EVలపై ₹50,000–₹1.5 లక్షల వరకు EV సబ్సిడీలను అందిస్తున్నాయి. మీ కోసం ఉత్తమమైన ఆప్షన్‌ను అన్వేషించడానికి మా బృందాన్ని సంప్రదించండి.",
      },
    ],
    techTag: "సొంత సాంకేతికత",
    techHeading: "మొదటి నుండి నిర్మించబడింది.",
    techTabs: [
      {
        label: "మోటార్",
        title: "32 kW ఎలక్ట్రిక్ మోటార్",
        subtitle: "అధిక-సామర్థ్య డ్రైవ్ సిస్టమ్",
        desc: "X45H2 గరిష్ట టార్క్ మరియు ఖచ్చితత్వం కోసం రూపొందించబడిన అధిక-సామర్థ్య 32 kW ఎలక్ట్రిక్ మోటార్ ద్వారా శక్తిని పొందుతుంది. ఇది సున్నితమైన మరియు శక్తివంతమైన పనితీరును నిర్ధారిస్తుంది, భారీ వ్యవసాయ పనులకు అనువైనదిగా చేస్తుంది.",
        specs: [
          { label: "పవర్ అవుట్‌పుట్", value: "32 kW" },
          { label: "టార్క్", value: "గరిష్ట టార్క్" },
          { label: "పనితీరు", value: "ఖచ్చితత్వం" },
          { label: "అప్లికేషన్", value: "హెవీ-డ్యూటీ" },
        ],
      },
      {
        label: "బ్యాటరీ",
        title: "38.4 kWh బ్యాటరీ ప్యాక్",
        subtitle: "అధిక-సామర్థ్య శక్తి వ్యవస్థ",
        desc: "38.4 kWh అధిక-సామర్థ్య బ్యాటరీని కలిగి ఉన్న X45H2 నిరంతరంగా 8 గంటల పనితీరును అందిస్తుంది. వేగవంతమైన ఛార్జింగ్ మరియు సుదీర్ఘ జీవితకాలం కోసం ఆప్టిమైజ్ చేయబడింది, క్షేత్రంలో విశ్వసనీయతను నిర్ధారిస్తుంది.",
        specs: [
          { label: "సామర్థ్యం", value: "38.4 kWh" },
          { label: "రన్‌టైమ్", value: "8 గంటలు" },
          { label: "ఛార్జింగ్", value: "వేగవంతమైన ఛార్జ్" },
          { label: "జీవితకాలం", value: "పొడిగించబడినది" },
        ],
      },
    ],
    softwareTag: "డిజిటల్ పర్యావరణ వ్యవస్థ",
    softwareHeading: "ఎలక్ట్రిక్ ట్రాక్టర్ల కోసం ఫ్లీట్ మేనేజ్‌మెంట్ సాఫ్ట్‌వేర్",
    softwareDesc: "మీ ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్ ఫ్లీట్‌ను నిర్వహించడానికి, పర్యవేక్షించడానికి మరియు నిర్వహించడానికి పూర్తి డిజిటల్ సాధనాలు.",
    softwareTabs: [
      {
        label: "వెబ్ యాప్",
        subtitle: "వెబ్ ప్లాట్‌ఫారమ్",
        title: "NXT-ఫ్లీట్ డ్యాష్‌బోర్డ్",
        desc: "శక్తివంతమైన బ్రౌజర్ ఆధారిత ఫ్లీట్ మేనేజ్‌మెంట్ ప్లాట్‌ఫారమ్. ప్రతి ట్రాక్టర్‌ను నిజ సమయంలో పర్యవేక్షించండి, బ్యాటరీ ఆరోగ్యాన్ని ట్రాక్ చేయండి మరియు ఒకే డ్యాష్‌బోర్డ్ నుండి బహుళ పొలాలను నిర్వహించండి.",
        features: ["రియల్ టైమ్ GPS ఫ్లీట్ ట్రాకింగ్", "బ్యాటరీ & డయాగ్నోస్టిక్స్ పర్యవేక్షణ", "ఫ్లీట్ అనలిటిక్స్ & పనితీరు నివేదికలు", "బహుళ-ఫామ్ మేనేజ్‌మెంట్ పోర్టల్"],
        cta: "యాక్సెస్ అభ్యర్థించండి",
      },
      {
        label: "మొబైల్ యాప్",
        subtitle: "iOS & Android",
        title: "ఆటోనెక్స్ట్ సర్వీస్ యాప్",
        desc: "మీ ఫోన్ నుండే సర్వీస్ బుక్ చేసుకోండి, టెక్నీషియన్లను లైవ్‌లో ట్రాక్ చేయండి మరియు మీ ట్రాక్టర్ పూర్తి సర్వీస్ హిస్టరీని నిర్వహించండి. iOS మరియు Android లలో అందుబాటులో ఉంది.",
        features: ["సర్వీస్ అపాయింట్‌మెంట్‌లను బుక్ & షెడ్యూల్ చేయండి", "లైవ్ టెక్నీషియన్ లొకేషన్ ట్రాకింగ్", "పూర్తి సర్వీస్ హిస్టరీ & రికార్డులు", "స్పేర్ పార్ట్స్ ఆర్డరింగ్ & డెలివరీ"],
        cta: "యాప్‌ని డౌన్‌లోడ్ చేయండి",
      },
      {
        label: "టాబ్లెట్",
        subtitle: "అనలిటిక్స్ డ్యాష్‌బోర్డ్",
        title: "NXT-ఫ్లీట్ అనలిటిక్స్",
        desc: "టాబ్లెట్-ఆప్టిమైజ్ చేసిన ఇంటర్‌ఫేస్‌లో లోతైన ఫ్లీట్ అనలిటిక్స్. పొలంలో లేదా ఆఫీసులో మీ మొత్తం ఫ్లీట్‌లో పనితీరు ధోరణులు, బ్యాటరీ సైకిళ్లు మరియు కార్యాచరణ సామర్థ్యాన్ని ట్రాక్ చేయండి.",
        features: ["ఫ్లీట్-వైడ్ పనితీరు విశ్లేషణ", "బ్యాటరీ ఆరోగ్యం & సైకిల్ ట్రాకింగ్", "కార్యాచరణ సామర్థ్య నివేదికలు", "బహుళ-వినియోగదారు యాక్సెస్ నియంత్రణ"],
        cta: "యాక్సెస్ అభ్యర్థించండి",
      },
    ],
    stats: [
      { label: "ఆర్డర్‌లు చేయబడినవి", value: "270+", sub: "వివిధ పరిశ్రమలలో పంపిణీ చేయబడిన ట్రాక్టర్లు" },
      { label: "సంతృప్తి చెందిన పరిశ్రమలు", value: "8", sub: "మా పరిష్కారాలను విశ్వసించే పరిశ్రమలు" },
      { label: "ఆదా చేయబడిన చెట్లు", value: "70,650+", sub: "అన్ని ట్రాక్టర్లలో ప్రపంచ CO₂ తగ్గింపు" },
      { label: "ఆదా చేయబడిన ఖర్చు", value: "₹30Cr", sub: "నిర్వహణ ఖర్చుల తగ్గింపు" },
    ],
    trustedBy: "భారతదేశపు అగ్రగామి సంస్థల నమ్మకం",
    partners: [
      "BAIF డెవలప్‌మెంట్ రీసెర్చ్",
      "DKSM",
      "నోయిడా అంతర్జాతీయ విమానాశ్రయం",
      "జైవంత్ షుగర్స్ లిమిటెడ్",
      "రిలయన్స్ న్యూ ఎనర్జీ",
      "థర్మాక్స్",
    ],
    lineupTag: "మా శ్రేణి",
    lineupTitle: "ప్రతి వ్యవసాయ క్షేత్రం మరియు పరిశ్రమ కోసం ఎలక్ట్రిక్ ట్రాక్టర్లు",
    viewAllModels: "అన్ని మోడల్‌లను వీక్షించండి",
    viewDetails: "వివరాలను వీక్షించండి",
    products: [
      {
        name: "AutoNxt X45H2",
        type: "45HP ఎలక్ట్రిక్ ట్రాక్టర్",
        tag: "బెస్ట్ సెల్లర్",
        desc: "అన్ని రకాల వ్యవసాయ మరియు రవాణా పనులలో బహుముఖ ప్రజ్ఞ మరియు శక్తి. AI లోడ్ నిర్వహణ.",
        specs: [
          { label: "మోటార్", value: "32 kW" },
          { label: "బ్యాటరీ", value: "38.4 kWh" },
          { label: "రేంజ్", value: "50 కిమీ" },
        ],
      },
      {
        name: "AutoNxt X45C2",
        type: "45HP ఎలక్ట్రిక్ ట్రాక్టర్",
        tag: "అధిక సామర్థ్యం",
        desc: "సున్నా ఉద్గారాలతో 45HP భారీ-డ్యూటీ పనితీరు — అధిక సామర్థ్యం మరియు సుదీర్ఘ బ్యాటరీ లైఫ్.",
        specs: [
          { label: "మోటార్", value: "32 kW" },
          { label: "బ్యాటరీ", value: "38.4 kWh" },
          { label: "రేంజ్", value: "60 కిమీ" },
        ],
      },
      {
        name: "AutoNxt H55C2",
        type: "55HP ఎలక్ట్రిక్ ట్రాక్టర్",
        tag: "అధిక పనితీరు",
        desc: "63.89 kwh లిక్విడ్-కూల్డ్ LFP బ్యాటరీ, Carraro ట్రాన్స్మిషన్ మరియు 80 కిమీ రేంజ్‌తో కూడిన అధిక-పనితీరు గల 55HP ఎలక్ట్రిక్ ట్రాక్టర్.",
        specs: [
          { label: "మోటార్", value: "45 kW" },
          { label: "బ్యాటరీ", value: "63.89 kwh" },
          { label: "రేంజ్", value: "80 కిమీ" },
        ],
      },
    ],
    precisionTag: "సాంకేతికత",
    precisionTitle: "అధునాతన ఎలక్ట్రిక్ ట్రాక్టర్ సాంకేతికత",
    precisionDesc: "భారతీయ క్షేత్ర పరిస్థితులలో గరిష్ట సామర్థ్యం, భద్రత మరియు పనితీరు కోసం ప్రతి భాగం ఇంజనీర్ చేయబడింది.",
    featureImage: "/images/precision/image-tl.webp",
    featureImageAlt: "ఖచ్చిత ఇంజనీకరించడం",
    industryTag: "పారిశ్రామిక పరిష్కారాలు",
    industryHeading: "వ్యవసాయ మరియు పారిశ్రామిక అనువర్తనాల కోసం ఎలక్ట్రిక్ ట్రాక్టర్లు",
    industryDesc: "భారతదేశంలోని అత్యంత కఠినమైన పారిశ్రామిక వాతావరణాలలో నిరంతర పనిభారం కోసం ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్లు నిర్మించబడ్డాయి.",
    exploreAllIndustries: "అన్ని పరిశ్రమలను అన్వేషించండి",
    videoActionTag: "యాక్షన్‌లో ఆటోనెక్స్ట్",
    videoHeading: "X45H2 పనితీరును వీక్షించండి.",
    videoSub: "మా యూట్యూబ్ ఛానెల్ నుండి నేరుగా నిజమైన వీడియోలు — నీటితో నిండిన వరి పొలాల నుండి పారిశ్రామిక రవాణా వరకు.",
    videos: [
      "X45H2 ఉత్పత్తి వివరణ (ఇంగ్లీష్)",
      "నీటితో నిండిన పొలాల్లో రోటవేటర్ పడ్లింగ్",
      "మొదటి డెలివరీ — జైవంత్ షుగర్ మిల్లు",
      "45HP ఎలక్ట్రిక్ ట్రాక్టర్ పూర్తి పవర్ డెమో",
      "రవాణా, టిల్లర్, రీపర్ & వాటర్ వాష్",
      "X45H2 ఉత్పత్తి వివరణ — హిందీలో",
    ],
    readyToElectric: "ఎలక్ట్రిక్‌గా మారడానికి సిద్ధంగా ఉన్నారా?",
    readyToElectricDesc: "ఆటోనెక్స్ట్‌కు మారిన 5,000+ భారతీయ రైతులతో చేరండి. ఈరోజే మీ ట్రాక్టర్‌ను రిజర్వ్ చేసుకోండి.",
    liveTag: "లైవ్",
    visitingPass: {
      connectTag: "విజిట్ & కనెక్ట్",
      titlePre: "ఒక ",
      titleHighlight: "సందర్శన పాస్",
      titlePost: " లేదా యాప్ పొందండి",
      showroom: "ఫ్యాక్టరీ & షోరూమ్",
      bookPass: "సందర్శన పాస్ బుక్ చేయండి",
      visitorPass: "సందర్శకుల పాస్",
      hinjewadi: "హింజేవాడి ఫేజ్ 2, పూణే",
      namePlaceholder: "మీ పూర్తి పేరు",
      generatePass: "సందర్శన పాస్ సృష్టించండి",
      nameLabel: "పేరు",
      dateLabel: "తేదీ",
      purposeLabel: "ఉద్దేశ్యం",
      blankVal: "— — —"
    },
    mobileApp: {
      tag: "మొబైల్ అప్లికేషన్",
      titlePre: "ఆటోనెక్స్ట్",
      titleHighlight: "మీ ఫోన్‌లో",
      desc: "సర్వీస్ బుక్ చేసుకోండి, మీ ట్రాక్టర్‌ను ట్రాక్ చేయండి, ఫ్లీట్ ఆపరేషన్లను నిర్వహించండి మరియు అలర్ట్‌లతో అప్‌డేట్‌గా ఉండండి — అన్నీ మీ జేబు నుండే.",
      alert: "రియల్ టైమ్ అలర్ట్‌లు & నోటిఫికేషన్‌లు",
      gps: "లైవ్ ట్రాక్టర్ GPS ట్రాకింగ్",
      history: "సర్వీస్ బుకింగ్ & హిస్టరీ",
      appStore: "యాప్ స్టోర్",
      googlePlay: "గూగుల్ ప్లే",
      downloadOn: "డౌన్‌లోడ్ చేసుకోండి",
      getItOn: "పొందండి",
    },
    whyAutoNXT: {
      title: "రైతులు ఎందుకు ఎలక్ట్రిక్ ట్రాక్టర్లకు మారుతున్నారు?",
      bullets: [
        { title: "తక్కువ నిర్వహణ ఖర్చులు", desc: "డీజిల్ నుండి విద్యుత్‌కు మారడం ద్వారా ఇంధన బిల్లులపై 80% వరకు ఆదా చేయండి." },
        { title: "తక్కువ మెయింటెనెన్స్", desc: "70% తక్కువ కదిలే భాగాలు అంటే ఇంజిన్ ఆయిల్, ఫిల్టర్ మార్పులు లేదా పిస్టన్ వేర్ లేదు." },
        { title: "సున్నా డీజిల్ నిర్భరత", desc: "అస్థిర మరియు పెరుగుతున్న శిలాజ ఇంధన ధరల నుండి మీ వ్యవసాయ కార్యకలాపాలను రక్షించుకోండి." },
        { title: "నిశ్శబ్ద ఆపరేషన్", desc: "నిశ్శబ్ద ఎలక్ట్రిక్ మోటార్లు డ్రైవర్ అలసటను మరియు శబ్ద కాలుష్యాన్ని తగ్గిస్తాయి." },
        { title: "అధిక తక్షణ టార్క్", desc: "0 RPM నుండి అందుబాటులో ఉండే పీక్ టార్క్ అత్యుత్తమ టిల్లింగ్ మరియు టోయింగ్ పవర్‌ను అందిస్తుంది." }
      ]
    }
  },
  // Gallery
  gallery: {
    metaTitle: "AutoNxt ఎలక్ట్రిక్ ట్రాక్టర్ల గ్యాలరీ | ఫోటోలు & వీడియోలు",
    metaDescription: "వ్యవసాయం మరియు పారిశ్రామిక పనుల్లో AutoNxt ఎలక్ట్రిక్ ట్రాక్టర్ల ఫోటోలు మరియు వీడియోలను చూడండి.",
    sectionHeading: "గ్యాలరీ వర్గాలను బ్రౌజ్ చేయండి",
    title: "ఆటోనెక్స్ట్‌ను చూడండి",
    titleHighlight: "యాక్షన్‌లో.",
    desc: "పొలాలు, పరిశ్రమలు మరియు ఈవెంట్‌లలో ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్ల పూర్తి ఫోటో గ్యాలరీ, ఈవెంట్ కవరేజ్ మరియు నిజమైన వీడియోలను అన్వేషించండి.",
    photos: "ఫోటోలు",
    events: "ఈవెంట్‌లు",
    videos: "వీడియోలు",
    clickToView: "పూర్తి పరిమాణంలో చూడటానికి ఏదైనా ఫోటోపై క్లిక్ చేయండి",
    eventBannerTitle: "అధికారిక ప్రభుత్వ హ్యాండోవర్ వేడుక",
    eventBannerDesc: "జూన్ 29, 2025 — ప్రభుత్వ అధికారులు, పోలీసు ప్రతినిధులు మరియు మీడియా సమక్షంలో జరిగిన అధికారిక వేడుకలో ఆటోనెక్స్ట్ X45H2 ఎలక్ట్రిక్ ట్రాక్టర్‌ను అందజేసింది.",
    watchOnYouTube: "యూట్యూబ్‌లో చూడండి",
    moreOnYouTube: "యూట్యూబ్‌లో మరిన్ని",
    viewAllVideos: "యూట్యూబ్‌లో అన్ని వీడియోలను చూడండి",
    scheduleDemo: "డెమో షెడ్యూల్ చేయండి",
    seeInPerson: "వ్యక్తిగతంగా చూడాలనుకుంటున్నారా?",
    seeInPersonDesc: "మీ పొలంలో లేదా మా సమీప ఎక్స్‌పీరియన్స్ సెంటర్‌లో లైవ్ డెమోను షెడ్యూల్ చేయండి.",
    galleryBadge: "ఆటోనెక్స్ట్ గ్యాలరీ",
    youtubeTag: "YouTube",
    youtubeDesc: "ఉత్పత్తి వీడియోలు, ఫారమ్ డెమోలు, పరిశ్రమ అప్లికేషన్లు మరియు కంపెనీ అప్‌డేట్‌ల కోసం ఆటోనెక్స్ట్ YouTube ఛానెల్‌ని సబ్‌స్క్రైబ్ చేసుకోండి.",
  },
  // About
  about: {
    metaTitle: "AutoNxt గురించి | ఎలక్ట్రిక్ ట్రాక్టర్ & ఆటోమేషన్ రంగాగ్రగాములు",
    metaDescription: "AutoNxt Automation గురించి తెలుసుకోండి. మా లక్యం, వ్యవస్థాపకులు, టీమ్ మరియు అత్యాధునిక సాంకేతికత వివరాలు చూడండి.",
    tag: "ఆటోనెక్స్ట్ గురించి",
    heroTitle: "సాంకేతికత వ్యవసాయం చేసే విధానంలో",
    heroHighlight: "విప్లవాత్మక మార్పులు",
    heroTitle2: "తీసుకురాగలదని మేము నమ్ముతున్నాము.",
    heroDesc: "సమాజంపై సుదీర్ఘమైన, శాశ్వతమైన ప్రభావాన్ని చూపే ఆలోచనలపై పనిచేస్తూ, మెరుగైన భవిష్యత్తును సృష్టించాలనే సంకల్పం ఉన్న ఇంజనీర్ల చిన్న బృందంగా మేము ప్రారంభించాము. ఈరోజు ఆటోనెక్స్ట్ భారతదేశపు ఎలక్ట్రిక్ వ్యవసాయ విప్లవంలో ముందంజలో ఉంది.",
    missionTag: "మా మిషన్",
    missionTitle: "రైతులను శక్తివంతం చేయడం. మన గ్రహాన్ని రక్షించడం.",
    missionDesc: "రైతులను శక్తివంతం చేస్తూ మన పర్యావరణాన్ని రక్షించే స్థిరమైన, సమర్థవంతమైన మరియు శక్తివంతమైన ఎలక్ట్రిక్ ట్రాక్టర్లను అందించడం ద్వారా వ్యవసాయంలో విప్లవాత్మక మార్పులు తీసుకురావడం.",
    processTag: "మా ఇంజనీరింగ్ ప్రక్రియ",
    processTitle: "అత్యున్నత ప్రమాణాలతో నిర్మించబడింది.",
    journeyTag: "మా ప్రయాణం",
    journeyTitle: "భావన నుండి మార్కెట్ లీడర్ వరకు.",
    teamTag: "మా బృందం",
    teamTitle: "మా బృందాన్ని కలవండి",
    teamDesc: "వ్యవసాయ పరిశ్రమలో విప్లవాత్మక మార్పులు తీసుకురావడానికి మా నిపుణుల బృందం కట్టుబడి ఉంది.",
    advisorsTag: "మా సలహాదారులు",
    advisorsTitle: "మా విజన్‌కు మార్గదర్శకత్వం వహిస్తున్న పరిశ్రమ ప్రముఖులు.",
    ctaTitle: "మా ప్రయాణంలో భాగస్వామ్యం కావాలనుకుంటున్నారా?",
    ctaDesc: "భారతదేశంలో స్థిరమైన వ్యవసాయ భవిష్యత్తును నిర్మించడంలో మాతో చేరండి.",
    bookDemo: "డెమో బుక్ చేయండి",
    ourImpact: "మా ప్రభావం",
    connect: "కనెక్ట్ అవ్వండి",
  },
  chat: {
    welcome: "👋 ఆటోనెక్స్ట్ AI కు స్వాగతం\n\nఎలక్ట్రిక్ ట్రాక్టర్‌లు మరియు స్మార్ట్ వ్యవసాయం గురించి తెలుసుకోవడానికి నేను మీకు సహాయం చేస్తాను.\n\nమీరు **తెలుగు**, **హిందీ**, **English**, లేదా **मराठी** లో అడగవచ్చు — ఏ భాషలో అడిగితే ఆ భాషలో సమాధానం ఇస్తాను.\n\nక్రింద **Talk with agent** (ఫోన్) లేదా **Schedule meeting** (Zoom) ఎంచుకోండి — లేదా టైప్ చేయండి: \"ఏజెంట్‌తో మాట్లాడండి\", \"మీటింగ్ షెడ్యూల్\"।",
    callPromptNow: "ఆటోనెక్స్ట్ టీమ్‌కు ఇప్పుడే కాల్ చేయండి",
    callPromptScheduled: "కాల్ షెడ్యూల్ చేయి",
    meetingOpenMessage: "మా సేల్స్ టీమ్‌తో **Zoom** కాల్ షెడ్యూల్ చేయడానికి క్రింద ఫారమ్ పూరించండి.",
    bookingOpenMessage: "మీ ట్రాక్టర్ బుకింగ్ చేయడంలో నేను మీకు సహాయపడతాను.",
    callSupport: "టెలిఫోన్ సహాయం & అమ్మకాలు",
    callDescription: "మీ నంబర్ నమోదు చేయండి. మా ఏజెంట్ వ్యాపార వేళల్లో లేదా మీకు నచ్చిన సమయంలో వెంటనే కాల్ చేస్తారు.",
    callTypeSupport: "సాంకేతిక సహాయం",
    callTypeSales: "అమ్మకాలు & డీలర్‌షిప్",
    meetingHeading: "జూమ్ మీట్‌ని షెడ్యూల్ చేయండి",
    meetingLanguageLabel: "ప్రాధాన్యత కలిగిన భాష:",
    salesMeetingInfo: "సమావేశాలు ఉత్పత్తి నిపుణుడితో ZOOM Meet ద్వారా నిర్వహించబడతాయి (ఉదయం 10 - సాయంత్రం 5).",
    scheduleMeeting: "సమావేశ షెడ్యూల్‌ను నిర్ధారించు",
    bookingHeader: "మీ ఆటోనెక్స్ట్ ట్రాక్టర్‌ను ప్రీ-బుక్ చేసుకోండి",
    inputPlaceholder: "ఏదైనా అడగండి...",
    clearSession: "సెషన్ తొలగించండి",
    talkWithAgent: "ఏజెంట్‌తో మాట్లాడండి",
    assistantSubtitle: "స్మార్ట్ వ్యవసాయ సహాయకుడు",
  },

  // Common
  common: {
    readMore: "మరింత చదవండి",
    learnMore: "మరింత తెలుసుకోండి",
    getInTouch: "సంప్రదించండి",
    subscribe: "అప్‌డేట్‌ల కోసం సబ్‌స్క్రైబ్ చేయండి",
    copyright: "© 2025 ఆటోనెక్స్ట్ ఆటోమేషన్ ప్రైవేట్ లిమిటెడ్. అన్ని హక్కులు ప్రత్యేకించబడినవి.",
    madeIn: "భారతదేశంలో తయారైంది 🇮🇳 భారతీయ వ్యవసాయం మరియు పరిశ్రమల కోసం",
    careers: "ఉద్యోగాలు",
    privacyPolicy: "గోప్యతా విధానం",
    termsConditions: "నిబంధనలు & షరతులు",
    accountDeletion: "ఖాతా తొలగింపు",
    fleetSolutions: "ఫ్లీట్ సొల్యూషన్స్",
    batterySystems: "బ్యాటరీ సిస్టమ్స్",
    motors: "NXT-డ్రైవ్ మోటార్లు",
    slogan: "పరిశ్రమ, మౌలిక సదుపాయాలు మరియు వ్యవసాయం కోసం తదుపరి తరం విద్యుత్ యంత్రాల తయారీ.",
    cancel: "రద్దు చేయి",
    loadingModel: "3D మోడల్ లోడ్ అవుతోంది...",
    dragToRotate: "↺ తిప్పడానికి లాగండి",
    exploreAll: "అన్నీ చూడండి",
    collapseList: "జాబితాను మూసివేయి",
  },
  // Book
  book: {
    title: "డెమో బుక్ చేయండి",
    desc: "ఆటోనెక్స్ట్ X45H2 ఎలక్ట్రిక్ ట్రాక్టర్‌ను ప్రత్యక్షంగా అనుభవించండి. మీ వివరాలను పూరించండి, మా బృందం మిమ్మల్ని సంప్రదిస్తుంది.",
  },
  // News
  news: {
    metaTitle: "AutoNxt వార్తలు & ప్రెస్ రిలీజ్‌లు | ఎలక్ట్రిక్ ట్రాక్టర్ అప్‌డేట్‌లు",
    metaDescription: "AutoNxt Automation నుండి తాజా వార్తలు, ప్రకటనలు మరియు మీడియా కవరేజ్‌తో సమాచారంతో ఉండండి.",
    tag: "వార్తలు & ప్రెస్",
    title: "వార్తలలో",
    titleHighlight: "ఆటోనెక్స్ట్.",
    desc: "ఆటోనెక్స్ట్ ఆటోమేషన్ నుండి తాజా వార్తలు, ప్రకటనలు మరియు మీడియా కవరేజ్‌తో అప్‌డేట్‌గా ఉండండి.",
    featured: "ప్రధాన కథనం",
    allNews: "అన్ని వార్తలు",
    ctaTitle: "మీడియా విచారణలు",
    ctaDesc: "ప్రెస్ కిట్‌లు, ఇంటర్వ్యూలు మరియు భాగస్వామ్య ప్రకటనల కోసం, ఆటోనెక్స్ట్ కम్యూనికేషన్స్ బృందాన్ని సంప్రదించండి.",
    contactPress: "ప్రెస్ బృందాన్ని సంప్రదించండి",
    searchPlaceholder: "వార్తలు వెతకండి...",
    allCategories: "అన్ని వర్గాలు",
    readArticle: "వ్యాసం చదవండి",
    noArticlesFound: "వ్యాసాలు కనుగొనబడలేదు",
    noArticlesDesc: "మీ వెతుకును మార్చండి లేదా వేరే వర్గం ఎంచుకోండి.",
    authorLabel: "రచయిత",
    pressInquiries: "పత్రికా & మీడియా విచారణలు",
    pressDesc: "పత్రికా ప్రకటనలు, అధిక-రిజల్యూషన్ చిత్రాలు మరియు మీడియా ఇంటర్వ్యూల కోసం, దయచేసి మా PR బృందాన్ని సంప్రదించండి.",
    contactPr: "PR బృందాన్ని సంప్రదించండి",
    liveCovers: "లైవ్ కవరేజ్",
    pressMedia: "ప్రెస్ మరియు మీడియా",
    latestUpdates: "తాజా అప్డేట్లు",
  },
  // Blog
  blog: {
    metaTitle: "ఫీల్డ్ స్టోరీలు & ఫార్మింగ్ బ్లాగ్ | AutoNxt ఎలక్ట్రిక్ ట్రాక్టర్లు",
    metaDescription: "ఎలక్ట్రిక్ ట్రాక్టర్లు, సుస్థిర వ్యవసాయం మరియు భారతదేశంలో వ్యవసాయ భవిష్యత్తుపై AutoNxt వ్యాసాలు.",
    tag: "ఆటోనెక్స్ట్ బ్లాగ్",
    title: "వ్యవసాయ భవిష్యత్తుపై",
    titleHighlight: "అవగాహన.",
    desc: "ఎలక్ట్రిక్ ట్రాక్టర్లు, స్థిరమైన వ్యవసాయం మరియు భారతదేశంలో వ్యవసాయ భవిష్యత్తు గురించి ఆటోనెక్స్ట్ బృందం నుండి కథనాలు, లోతైన విశ్లేషణలు.",
    featured: "ప్రధాన పోస్ట్",
    allPosts: "అన్ని పోస్ట్‌లు",
    readFull: "పూర్తి పోస్ట్ చదవండి",
    writeFor: "ఆటోనెక్స్ట్ కోసం రాయాలనుకుంటున్నారా?",
    writeDesc: "పొలం నుండి నిజమైన కథనాలను పంచుకోవడానికి మేము రైతులు, ఇంజనీర్లు మరియు అగ్రి-టెక్ నిపుణులతో కలిసి పనిచేస్తాము.",
    searchPlaceholder: "వ్యాసాలు వెతకండి...",
    allCategories: "అన్ని వర్గాలు",
    readArticle: "వ్యాసం చదవండి",
    noArticlesFound: "వ్యాసాలు కనుగొనబడలేదు",
    noArticlesDesc: "మీ వెతుకును మార్చండి లేదా వేరే వర్గం ఎంచుకోండి.",
    editorsPick: "ఎడిటర్ ఛాయిస్",
    newBadge: "కొత్త",
    readAction: "చదవండి",
    authorLabel: "రచయిత",
  },
  // EV Blog
  evBlog: {
    metaTitle: "ఎలక్ట్రిక్ వాహన సమాచారం & టెక్ బ్లాగ్ | AutoNxt",
    metaDescription: "భారతీయ మరియు ప్రపంచ వ్యవసాయంలో ఎలక్ట్రిక్ వాహనాలపై సాంకేతిక విశ్లేషణ మరియు మార్కెట్ అంచనాలు.",
    tag: "EV నాలెడ్జ్ హబ్",
    title: "అంతా ఎలక్ట్రిక్.",
    titleHighlight: "అంతా వ్యవసాయం.",
    desc: "భారతీయ మరియు ప్రపంచ వ్యవసాయంలో ఎలక్ట్రిక్ వాహనాలపై లోతైన సాంకేతిక విశ్లేషణలు, మార్కెట్ విశ్లేషణలు, విధాన విచ్ఛేదనలు మరియు భవిష్యత్తు అంచనాలు.",
    ctaTitle: "EV వార్తలతో అప్‌డేట్‌గా ఉండండి",
    ctaDesc: "ఎలక్ట్రిక్ వ్యవసాయం, బ్యాటరీ సాంకేతికత మరియు విధాన అప్‌డేట్‌లపై తాజా విశ్లేషణలను మీ ఇన్‌బాక్స్‌కు పొందండి.",
    searchPlaceholder: "వ్యాసాలు వెతకండి...",
    allCategories: "అన్ని వర్గాలు",
    readArticle: "వ్యాసం చదవండి",
    noArticlesFound: "వ్యాసాలు కనుగొనబడలేదు",
    noArticlesDesc: "మీ వెతుకును మార్చండి లేదా వేరే వర్గం ఎంచుకోండి.",
    evRevolution: "EV విప్లవం",
  },
  productPage: {
    metaTitle: "AutoNxt ఎలక్ట్రిక్ ట్రాక్టర్ల లైనప్ | హై-పెర్ఫార్మెన్స్ EV ట్రాక్టర్లు",
    metaDescription: "వ్యవసాయం మరియు పారిశ్రామిక రవాణా కోసం తయారు చేసిన AutoNxt ఎలక్ట్రిక్ ట్రాక్టర్ల లైనప్‌ను కనుగొనండి.",
    badge: "ఎలక్ట్రిక్ శ్రేణి 2025",
    title: "ఎలక్ట్రిక్",
    titleHighlight: "ట్రాక్టర్లు.",
    desc: "స్థిరమైన, శక్తివంతమైన మరియు సమర్థవంతమైన ఎలక్ట్రిక్ ట్రాక్టర్లతో వ్యవసాయంలో విప్లవాత్మక మార్పులు — ప్రతి పొలం, ప్రతి భూభాగం కోసం నిర్మించబడింది.",
    hpRange: "HP పరిధి",
    charge: "ఛార్జ్",
    availableNow: "ఇప్పుడు అందుబాటులో ఉంది",
    implementLabel: "పరికరాలు",
    filterTabs: {
      all: "అన్ని ఉత్పత్తులు",
      tractors: "ట్రాక్టర్లు",
      attachments: "పరికరాలు"
    },
    chargingTime: "3–6 గంటలు",
    modelsCount: "3 ట్రాక్టర్లు",
    viewDetails: "వివరాలను వీక్షించండి",
    book: "బుక్ చేయండి",
    viewGallery: "గ్యాలరీని వీక్షించండి",
    scheduleTestDrive: "టెస్ట్ డ్రైవ్ షెడ్యూల్ చేయండి",
    seeIndustries: "పరిశ్రమలను చూడండి",
    models: "మోడల్స్",
    flagshipModel: "ఫ్లాగ్‌షిప్ మోడల్",
    zeroEmissions: "సున్నా ఉద్గారాలు",
    electric100: "100% ఎలక్ట్రిక్",
    ourProducts: "మా ఉత్పత్తులు",
    exploreAll: "పూర్తి శ్రేణిని అన్వేషించండి",
    exploreDesc: "చిన్న పొలాల మోడళ్ల నుండి భారీ వాణిజ్య మోడళ్ల వరకు — ప్రతి పనికి అనుకూలమైన పరికరాలతో.",
    implementsTitle: "పరికరాలు & జోడింపులు",
    coreTech: "ప్రధాన సాంకేతికత",
    builtDifferent: "విభిన్నంగా నిర్మించబడింది.",
    fieldBannerTag: "జూన్ 2025 · హ్యాండోవర్ వేడుక",
    fieldBannerTitle: "పొలంలో ట్రాక్టర్లు.",
    readyToPower: "పొలాలకు శక్తినివ్వడానికి సిద్ధంగా ఉన్నారా?",
    experienceTag: "ఆటోనెక్స్ట్‌ను అనుభవించండి",
    features: {
      zeroEmissions: "సున్నా ఉద్గారాలు",
      zeroEmissionsDesc: "100% ఎలక్ట్రిక్ డ్రైవ్‌ట్రెయిన్",
      instantTorque: "తక్షణ టార్క్",
      instantTorqueDesc: "ప్రతి భూభాగంలో సున్నా RPM నుండి",
      fastCharging: "ఫాస్ట్ ఛార్జింగ్",
      fastChargingDesc: "3-4 గంటల్లో పూర్తిగా ఛార్జ్ అవుతుంది",
      warranty: "5 సంవత్సరాల వారంటీ",
      warrantyDesc: "భారతదేశ సేవా నెట్‌వర్క్ మద్దతుతో"
    },
    specs: {
      power: "శక్తి",
      battery: "బ్యాటరీ",
      range: "రేంజ్",
      runtime: "రన్ టైమ్",
      charging: "ఛార్జింగ్",
      lifting: "లిఫ్టింగ్ సామర్థ్యం",
      torque: "గరిష్ట టార్క్",
    },
    tractorsList: {
      x45h2: {
        badge: "ఫ్లాగ్‌షిప్",
        type: "45HP ఎలక్ట్రిక్ ట్రాక్టర్",
        desc: "పెద్ద ఎత్తున వ్యవసాయ కార్యకలాపాల కోసం అధునాతన బ్యాటరీ సాంకేతికత మరియు అత్యుత్తమ పనితీరుతో కూడిన మా ప్రతిష్టాత్మక 45HP ఎలక్ట్రిక్ ట్రాక్టర్.",
        specs: {
          power: "32 kW",
          battery: "38.4 kWh",
          range: "50 కిమీ",
          charging: "ఆఫ్-బోర్డ్ - DC ఫాస్ట్ ఛార్జింగ్ 60kW - 45 నిమిషాలు"
        }
      },
      h55c2: {
        badge: "అధిక పనితీరు",
        type: "55HP ఎలక్ట్రిక్ ట్రాక్టర్",
        desc: "45 kW PMSM మోటార్, 63.89 kwh LFP లిక్విడ్-కూల్డ్ బ్యాటరీ, Carraro ట్రాన్స్మిషన్ మరియు 80 కిమీ రేంజ్‌తో పెద్ద-స్థాయి వ్యవసాయం మరియు పారిశ్రామిక కార్యకలాపాల కోసం అధిక-పనితీరు గల 55HP ఎలక్ట్రిక్ ట్రాక్టర్.",
        specs: {
          power: "45 kW",
          battery: "63.89 kwh LFP",
          range: "80 కిమీ",
          charging: "AC ఫాస్ట్ 13.2 kW / DC ఫాస్ట్ 40kW డ్యూయల్ గన్"
        }
      },
      x45c2: {
        badge: "అధిక సామర్థ్యం",
        type: "45HP వాణిజ్య ఎలక్ట్రిక్ ట్రాక్టర్",
        desc: "వాటర్-కూల్డ్ PMSM మోటార్, 60 కిమీ రేంజ్, స్మార్ట్ టెలిమాటిక్స్ మరియు ఆన్‌బోర్డ్ ఫాస్ట్ ఛార్జింగ్‌తో వాణిజ్య వ్యవసాయానికి అధిక-సామర్థ్యంగల 45HP ఎలక్ట్రిక్ ట్రాక్టర్.",
        specs: {
          power: "32 kW",
          battery: "38.4 kWh LFP",
          range: "60 కిమీ",
          charging: "AC స్లో 6.6 kW / AC ఫాస్ట్ 13.2 kW"
        }
      }
    },
    implementsList: {
      bucket: {
        badge: "హెవీ డ్యూటీ",
        name: "18 అడుగుల గ్రాబర్ బకెట్",
        desc: "సమర్ధవంతమైన మెటీరియల్ హ్యాండ్లింగ్ మరియు తవ్వకం కార్యకలాపాల కోసం రూపొందించిన హెవీ-డ్యూటీ 18 అడుగుల గ్రాబర్ బకెట్ అట్టాచ్మెంట్. కఠినమైన నిర్మాణ మరియు వ్యవసాయ వాతావరణాల్లో గరిష్ఠ నాణ్యత మరియు పనితీరం కోసం ఉత్తమ మ్యాటిరియల్స్ మరియు అద్వాన్స్డ్ ఇంజినీరింగ్తో తయారు చేయబడింది."
      },
      catcher: {
        badge: "ఖచ్చితత్వం",
        name: "18 అడుగుల క్యాచర్",
        desc: "వ్యవసాయ మరియు పరిశ్రమ అనుప్రయోగాలల్లో సర్వోత్తమ పనితీరం కోసం అద్వాన్స్డ్ హైడ్రాలిక్ నియంత్రణలు మరియు మన్నగి నిర్మాణంతో సమర్ధవంతమైన మెటీరియల్ సేకరణ మరియు నిర్వహణ కోసం ఖచ్చితంగా ఇంజనీర్ చేయబడిన 18 అడుగుల క్యాచర్ అట్టాచ్మెంట్. వరి కోత, మెటీరియల్ వింఛన మరియు ప్రత్యేక సేకరణ పనులకు ఆదర్శం. ఉత్తమ మ్యాటిరియల్స్ మరియు అత్యాధునిక ఇంజినీరింగ్తో తయారు చేయబడింది."
      },
      loader: {
        badge: "గరిష్ట లోడ్",
        name: "18 అడుగుల లోడర్ బకెట్",
        desc: "లోడింగ్ మరియు మెటీరియల్ రవాణా కార్యకలాపాలల్లో గరిష్ఠ సామర్ధ్యం కోసం రూపొందించిన హెవీ-డ్యూటీ 18 అడుగుల లోడర్ బకెట్. అత్యంత కఠినమైన నిర్మాణ, ఖనన మరియు వ్యవసాయ పనుల కోసం ఉత్తమ శక్తి మ్యాటిరియల్స్ మరియు అద్వాన్స్డ్ హైడ్రాలిక్ సిస్టమ్స్తో తయారు చేయబడింది. మెటీరియల్ నిలుపుదల మరియు సమర్ధవంతమైన లోడింగ్ చక్రాల కోసం అనుకూలిత బకెట్ జ్యామితి."
      }
    },
    techSpecsList: {
      battery: {
        title: "LFP బ్యాటరీ ప్యాక్",
        desc: "అధిక-సాంద్రత గల లిథియం ఐరన్ ఫాస్ఫేట్ సెల్స్. 2,000+ ఛార్జ్ సైకిళ్లు. దశాబ్ద కాలం పాటు పొలంలో మన్నిక కోసం IP67 వాటర్‌ప్రూఫ్.",
        stat: "2,000+",
        statLabel: "ఛార్జ్ సైకిళ్లు"
      },
      motor: {
        title: "NXT-డ్రైవ్ మోటార్",
        desc: "ఆక్సియల్ ఫ్లక్స్ పర్మనెంట్ మాగ్నెట్ మోటార్. 96% గరిష్ట సామర్థ్యం. తక్షణ టార్క్ డెలివరీ. స్థానిక సేవతో భారతదేశంలోనే తయారు చేయబడింది.",
        stat: "96%",
        statLabel: "గరిష్ట సామర్థ్యం"
      }
    }
  },
  bookPage: {
    metaTitle: "డెమోను బుక్ చేయండి & AutoNxt ని సంప్రదించండి | ఎలక్ట్రిక్ ట్రాక్టర్లు",
    metaDescription: "AutoNxt ఎలక్ట్రిక్ ట్రాక్టర్ టెస్ట్ డ్రైవ్ లేదా ప్రి-బుకింగ్ చేసుకోండి. సుస్థిరమైన స్మార్ట్ వ్యవసాయంలోకి మారండి.",
    tag: "ఆటోనెక్స్ట్‌ను సంప్రదించండి",
    title: "భవిష్యత్తును ",
    titleHighlight: "నిర్మిద్దాం.",
    desc: "మా ఎలక్ట్రిక్ ట్రాక్టర్ల గురించి ప్రశ్నలు ఉన్నాయా లేదా డెమో షెడ్యూల్ చేయాలనుకుంటున్నారా? ఆటోనెక్స్ట్ బృందంతో కనెక్ట్ అవ్వండి మరియు స్థిరమైన రవాణా భవిష్యత్తును కనుగొనండి.",
    stats: {
      support: "మద్దతు",
      supportVal: "24/7",
      locations: "లొకేషన్లు",
      locationsVal: "భారతదేశం వ్యాప్తంగా",
      response: "ప్రతిస్పందన",
      responseVal: "< 24 గంటలు"
    },
    form: {
      send: "సందేశం పంపండి",
      desc: "క్రింది ఫారమ్‌ను పూరించండి మరియు మా బృందం త్వరలో మిమ్మల్ని సంప్రదిస్తుంది.",
      name: "పూర్తి పేరు",
      email: "ఈమెయిల్ చిరునామా",
      phone: "ఫోన్ నంబర్",
      location: "ప్రాధాన్యత కలిగిన స్థానం",
      model: "ట్రాక్టర్ మోడల్",
      date: "ప్రాధాన్యత కలిగిన తేదీ",
      subject: "విషయం",
      message: "మీ సందేశం",
      submitting: "సమర్పిస్తోంది...",
      submitBtn: "బుకింగ్ సమర్పించు",
      success: "బుకింగ్ విజయవంతంగా సమర్పించబడింది! మేము త్వరలో మిమ్మల్ని సంప్రదిస్తాము.",
      help: "మీ వ్యవసాయ అవసరాలు / ప్రశ్నలను వివరించండి...",
      submitCall: "నాకు ఇప్పుడే కాల్ చేయండి",
      scheduleCall: "కాల్ అభ్యర్థనను షెడ్యూల్ చేయి",
      city: "నగరం / జిల్లా",
      topic: "సమావేశ విషయం / ప్రశ్నలు"
    },

    contactInfo: {
      title: "సంప్రదించండి",
      call: "మాకు కాల్ చేయండి",
      email: "మాకు ఈమెయిల్ చేయండి",
      visit: "మమ్మల్ని సందర్శించండి",
      visitVal: "704 & 705 అమ్ఫోటెక్ ఐటీ పార్క్, థానే, మహారాష్ట్ర",
      hours: "పని వేళలు",
      hoursVal: "సోమ - శని, ఉదయం 9 - సాయంత్రం 6 IST"
    },
    cta: {
      tag: "టెస్ట్ డ్రైవ్",
      title: "ఆవిష్కరణను అనుభవించండి",
      desc: "మీ సమీప లొకేషన్‌లో లైవ్ ఎలక్ట్రిక్ ట్రాక్టర్ డెమోను షెడ్యూల్ చేయండి.",
      btn: "టెస్ట్ డ్రైవ్ బుక్ చేయండి"
    }
  },
  // Tractor Detail Page
  tractorDetailPage: {
    texts: {
      allTractors: "అన్ని ట్రాక్టర్లు",
      comingSoon: "త్వరలో వస్తోంది",
      availableNow: "ఇప్పుడు అందుబాటులో ఉంది",
      reserveNow: "ఇప్పుడే బుక్ చేయండి",
      registerInterest: "ఆసక్తిని నమోదు చేసుకోండి",
      bookTestDrive: "టెస్ట్ డ్రైవ్ బుక్ చేయండి",
      technicalSpecs: "సాంకేతిక వివరాలు",
      fullSpecs: "పూర్తి వివరాలు — ",
      keyFeatures: "ప్రధాన ఫీచర్లు",
      whatSetsApart: "ఈ ట్రాక్టర్‌ను ప్రత్యేకంగా నిలిపేది ఏమిటి",
      coreTech: "ప్రధాన సాంకేతికత",
      applications: "అప్లికేషన్లు",
      whereWorksBest: "ఎక్కడ బాగా పనిచేస్తుంది",
      costComparison5Year: "5 సంవత్సరాల ఖర్చుల పోలిక",
      dieselTractor45HP: "డీజిల్ ట్రాక్టర్ (45HP)",
      dieselFuelMaint: "సంవత్సరానికి ₹8–12 లక్షల ఇంధనం · ₹1.5 లక్షల సర్వీస్",
      electricFuelMaint: "సంవత్సరానికి ₹1.2–2 లక్షల విద్యుత్ · ₹40 వేల సర్వీస్",
      dieselSavingsNote: "డీజిల్‌తో పోలిస్తే 5 సంవత్సరాలలో ₹35–50 లక్షలు ఆదా చేయండి",
      basedOnUsageNote: "రోజుకు 8 గంటలు, సంవత్సరానికి 300 రోజుల పని ఆధారంగా",
      getTractor: "ట్రాక్టర్‌ను పొందండి",
      registerTractor: "ట్రాక్టర్ కోసం నమోదు చేసుకోండి",
      ctaDescAvailable: "మీ యూనిట్‌ను రిజర్వ్ చేసుకోండి, టెస్ట్ డ్రైవ్‌ను బుక్ చేసుకోండి లేదా కస్టమ్ కొటేషన్ కోసం మా ఉత్పత్తి బృందంతో మాట్లాడండి.",
      ctaDescUpcoming: "మీ ఆసక్తిని నమోదు చేసుకోండి మరియు ట్రాక్టర్ ప్రారంభించినప్పుడు ప్రాధాన్యత డెలివరీ నోటిఫికేషన్‌ను పొందండి.",
      compareAllModels: "అన్ని మోడళ్లను పోల్చండి",
    },
    tractors: {
      x45h2: {
        name: "ఆటోనెక్్స X45H2",
        type: "45HP ఎలక్ట్రిక్ ట్రాక్టర్",
        badge: "ఫ్లాగ్‌షిప్",
        badgeColor: "bg-primary",
        tagline: "భారతదేశపు అత్యంత శక్తివంతమైన ఎలక్ట్రిక్ ట్రాక్టర్",
        desc: "X45H2 అనేది ఆటోనెక్స్ట్ యొక్క ప్రతిష్టాత్మక వ్యవసాయ మరియు పారిశ్రామిక ఎలక్ట్రిక్ ట్రాక్టర్. పెద్ద పొలాలు, చక్కెర మిల్లులు, సిమెంట్ ప్లాంట్లు మరియు నిర్మాణ స్థలాలలో భారీ కార్యకలాపాల కోసం నిర్మించబడింది — ఇది 45HP తక్షణ ఎలక్ట్రిక్ టార్క్, 8+ గంటల రన్‌టైమ్ మరియు సున్నా ప్రత్యక్ష ఉద్గారాలను అందిస్తుంది. భారతదేశపు iCAT-ధృవీకరించబడిన ఎలక్ట్రిక్ ట్రాక్టర్, ఇప్పుడు భారతదేశం వ్యాప్తంగా వాणीజ్యపరంగా అందుబాటులో ఉంది.",
        image: "/3dmodel/x45h2.glb",
        glbSrc: "/3dmodel/x45h2.glb",
        status: "available",
        specs: [
          { label: "మోటార్ పవర్", value: "45 HP (32 kW)" },
          { label: "బ్యాటరీ సామర్థ్యం", value: "38.4 kWh LFP" },
          { label: "రన్‌టైమ్", value: "10 గంటలు / 10 ఎకరాలు" },
          { label: "ఛార్జ్ సమయం", value: "4 గంటలు (సింగిల్ ఫేజ్) / 2 గంటలు (త్రీ ఫేజ్)" },
          { label: "గరిష్ట టార్క్", value: "280 Nm" },
          { label: "బరువు", value: "2,200 కిలోలు" },
          { label: "లిఫ్టింగ్ సామర్థ్యం", value: "5–8 టన్నులు" },
          { label: "గరిష్ట వేగం", value: "25 కిమీ/గం" },
          { label: "PTO పవర్", value: "540 RPM" },
          { label: "శీతలీకరణ", value: "లిక్విడ్-కూల్డ్ బ్యాటరీ" },
          { label: "IP రేటింగ్", value: "IP67" },
          { label: "వారంటీ", value: "5 సంవత్సరాలు" },
        ],
        features: [
          {
            title: "రిమోట్ ఫ్లీట్ టెలిమాటిక్స్",
            desc: "ఏ పరికరం నుండైనా ఆటోనెక్స్ట్ క్లౌడ్ ప్లాట్‌ఫారమ్ ద్వారా రియల్ టైమ్ GPS ట్రాకింగ్, బ్యాటరీ స్థితి, మోటార్ ఆరోగ్యం మరియు జియో-ఫెన్సింగ్ యాక్సెస్ చేయవచ్చు."
          },
          {
            title: "AI-సహాయక లోడ్ నిర్వహణ",
            desc: "ఇంటెలిజెంట్ పవర్ డిస్ట్రిబ్యూషన్ సిస్టమ్ లోడ్ మరియు భూభాగం ఆధారంగా టార్క్ అవుట్‌పుట్ మరియు రీజెన్ బ్రేకింగ్‌ను స్వయంచాలకంగా ఆప్టిమైజ్ చేస్తుంది."
          },
        ],
        battery: [
          { label: "రసాయన శాస్త్రం", value: "లిథియం ఐరన్ ఫాస్ఫేట్ (LFP)" },
          { label: "సామర్థ్యం", value: "38.4 kWh" },
          { label: "సెల్ సైకిల్ లైఫ్", value: "2,000+" },
          { label: "IP రేటింగ్", value: "IP67" },
          { label: "శీతలీకరణ", value: "యాక్టివ్ లిక్విడ్ కూలింగ్" },
        ],
        motor: [
          { label: "రకం", value: "పర్మనెంట్ మాగ్నెట్ సింక్రోనస్ మోటార్" },
          { label: "గరిష్ట శక్తి", value: "32 kW (45 HP)" },
          { label: "గరిష్ట టార్క్", value: "280 Nm" },
          { label: "గరిష్ట సామర్థ్యం", value: "96%" },
        ],
        applications: [
          "భారీ స్థాయి వరి మరియు గోధుమ వ్యవసాయం",
          "చెరకు రవాణా మరియు క్రషింగ్ కార్యకలాపాలు",
          "బయోమాస్ బేలింగ్ మరియు రవాణా",
          "సిమెంట్ ప్లాంట్ మెటీరియల్ హ్యాండ్లింగ్",
          "నిర్మాణ స్థల నేల తయారీ",
          "విమానాశ్రయ గ్రౌండ్ సపోర్ట్ ఆపరేషన్లు",
          "మెటల్ ప్లాంట్ అంతర్గత లాజిస్టిక్స్",
        ],
        highlights: [
          "భారతదేశపు iCAT-ధృవీకరించబడిన ఎలక్ట్రిక్ ట్రాక్టర్",
          "మొదటి వాణిజ్య డెలివరీ: జైవంท์ షుగర్స్ లిమిటెడ్, కరాడ్ (మార్చి 2024)",
          "ఇప్పుడు అందుబాటులో ఉంది — ఉత్పత్తి యూనిట్లు డెలివరీకి సిద్ధంగా ఉన్నాయి",
          "FAME-III మరియు రాష్ట్ర EV సబ్సిడీలకు అర్హత కలిగి ఉంది",
          "6 సంవత్సరాల సమగ్ర వారంటీ",
          "మేడ్ ఇన్ ఇండియా — థానే, మహారాష్ట్ర",
        ],
      },
      h55c2: {
        name: "AutoNxt H55C2",
        type: "55HP ఎలక్ట్రిక్ ట్రాక్టర్",
        badge: "అధిక పనితీరు",
        badgeColor: "bg-accent",
        tagline: "డిమాండింగ్ వ్యవసాయ & పారిశ్రామిక కార్యకలాపాల కోసం అధిక-పనితీరు ఎలక్ట్రిక్ పవర్",
        desc: "H55C2 పెద్ద-స్థాయి వ్యవసాయం మరియు పారిశ్రామిక కార్యకలాపాలకు ఆటోనెక్స్ట్ యొక్క అత్యంత శక్తివంతమైన సున్నా-ఉద్గారాల ఎలక్ట్రిక్ డ్రైవ్‌ట్రెయిన్‌ను తీసుకొస్తుంది. 45 kW PMSM మోటార్ మరియు 63.89 kwh LFP లిక్విడ్-కూల్డ్ బ్యాటరీతో, ఇది 410 NM టార్క్ మరియు రేటెడ్ లోడ్‌తో 80 కిమీ రేంజ్ అందిస్తుంది.",
        image: "/3dmodel/h55c2.glb",
        glbSrc: "/3dmodel/h55c2.glb",
        status: "available",
        specs: [
          { label: "మోటార్ పవర్", value: "45 kW (55 HP సమానం)" },
          { label: "బ్యాటరీ సామర్థ్యం", value: "63.89 kwh (LFP లిక్విడ్ కూల్డ్)" },
          { label: "రేంజ్", value: "రేటెడ్ లోడ్‌తో 80 కిమీ" },
          { label: "ఛార్జర్", value: "AC ఫాస్ట్ 13.2 kW + DC ఫాస్ట్ 40 kW" },
          { label: "గరిష్ట టార్క్", value: "410 NM" },
          { label: "బరువు", value: "~2.8 టన్నులు" },
          { label: "లిఫ్టింగ్ సామర్థ్యం", value: "2800 కిలోలు" },
          { label: "గరిష్ట వేగం", value: "35 కిమీ/గంట" },
          { label: "PTO పవర్", value: "24.5 kW / 32.8 HP" },
          { label: "శీతలీకరణ", value: "వాటర్ కూల్డ్ మోటార్" },
          { label: "ట్రాన్స్మిషన్", value: "Constant Mesh (Carraro)" },
          { label: "బ్యాటరీ వారంటీ", value: "5 సంవత్సరాలు / 1500 ఛార్జింగ్ సైకిళ్ళు" },
        ],
        features: [
          {
            title: "లిక్విడ్-కూల్డ్ LFP బ్యాటరీ ప్యాక్",
            desc: "63.89 kwh LFP బ్యాటరీ లిక్విడ్ కూలింగ్‌తో భారీ లోడ్ మరియు తీవ్రమైన ఉష్ణోగ్రతల్లో కూడా స్థిరమైన విద్యుత్ సరఫరాను అందిస్తుంది."
          },
          {
            title: "రిమోట్ ఫ్లీట్ టెలిమాటిక్స్",
            desc: "ఆటోనెక్స్ట్ క్లౌడ్ ప్లాట్‌ఫారమ్ ద్వారా రియల్ టైమ్ జీపీఎస్ ట్రాకింగ్, బ్యాటరీ స్థితి, మోటార్ ఆరోగ్యం మరియు జియో-ఫెన్సింగ్ — ఎక్కడి నుండైనా యాక్సెస్ చేయవచ్చు."
          },
        ],
        battery: [
          { label: "కెమిస్ట్రీ", value: "లిథియం ఐరన్ ఫాస్ఫేట్ (LFP)" },
          { label: "సామర్థ్యం", value: "63.89 kwh (లిక్విడ్ కూల్డ్)" },
          { label: "సెల్ సైకిల్ లైఫ్", value: "1,500+ ఛార్జింగ్-డిశ్చార్జ్ సైకిళ్ళు" },
          { label: "IP రేటింగ్", value: "IP67" },
          { label: "శీతలీకరణ", value: "యాక్టివ్ లిక్విడ్ కూలింగ్" },
        ],
        motor: [
          { label: "రకం", value: "PMSM (పర్మనెంట్ మాగ్నెట్ సింక్రోనస్ మోటార్)" },
          { label: "గరిష్ట శక్తి", value: "45 kW (55 HP సమానం)" },
          { label: "గరిష్ట టార్క్", value: "410 NM" },
          { label: "గరిష్ట సామర్థ్యం", value: "96%" },
        ],
        applications: [
          "పెద్ద-స్థాయి వాణిజ్య వ్యవసాయం",
          "భారీ నేల దున్నడం మరియు లోతైన దున్నడం",
          "పారిశ్రామిక మెటీరియల్ హ్యాండ్లింగ్ మరియు లాజిస్టిక్స్",
          "18 టన్నుల పేలోడ్ వరకు భారీ రవాణా",
          "నిర్మాణ స్థల కార్యకలాపాలు",
          "మునిసిపల్ మరియు ప్రభుత్వ ఫ్లీట్ కార్యకలాపాలు",
        ],
        highlights: [
          "ఆటోనెక్స్ట్ శ్రేణిలో అత్యంత శక్తివంతమైన ఎలక్ట్రిక్ ట్రాక్టర్",
          "63.89 kwh లిక్విడ్-కూల్డ్ LFP బ్యాటరీ — రేటెడ్ లోడ్‌తో 80 కిమీ పరిధి",
          "Carraro ట్రాన్స్మిషన్‌తో 410 NM పీక్ టార్క్",
          "డ్యూయల్ ఛార్జింగ్: AC ఫాస్ట్ 13.2 kW + DC ఫాస్ట్ 40 kW DUAL Gun",
          "2800 కిలోల హైడ్రాలిక్ లిఫ్టింగ్ సామర్థ్యం",
          "5-సంవత్సరాల బ్యాటరీ వారంటీ 1500 ఛార్జ్ సైకిళ్ళతో",
          "భారతదేశంలో తయారైంది — థానే, మహారాష్ట్ర",
        ],
      },
      x45c2: {
        name: "AutoNxt X45C2",
        type: "45HP ఎలక్ట్రిక్ ట్రాక్టర్",
        badge: "అధిక సామర్థ్యం",
        badgeColor: "bg-emerald-700",
        tagline: "వాణిజ్య గ్రేడ్ హై-ఎఫిషియెన్సీ ఎలక్ట్రిక్ ట్రాక్టర్",
        desc: "X45C2 అనేది ఆటోనెక్స్ట్ యొక్క అధిక-సామర్థ్యంగల వాణిజ్య వ్యవసాయ మరియు పారిశ్రామిక ఎలక్ట్రిక్ ట్రాక్టర్. 32 kW PMSM మోటార్, 38.4 kWh LFP04 ప్రిజ్మాటిక్ బ్యాటరీ ప్యాక్ మరియు Carraro కాన్స్టెంట్ మెష్ ట్రాన్స్మిషన్‌తో, ఇది 223 NM పీక్ టార్క్ మరియు రేటెడ్ లోడ్‌తో 60 కిమీ రేంజ్ అందిస్తుంది. ఆన్‌బోర్డ్ 6.6 kW AC స్లో మరియు ఐచ్ఛిక 13.2 kW AC ఫాస్ట్ ఛార్జింగ్ నిరంతర వాణిజ్య ఆపరేషన్‌ను అనుమతిస్తుంది.",
        image: "/3dmodel/x45.glb",
        glbSrc: "/3dmodel/x45.glb",
        status: "available",
        specs: [
          { label: "మోటార్ పవర్", value: "32 kW (45 HP సమానం)" },
          { label: "బ్యాటరీ సామర్థ్యం", value: "38.4 kWh (LFP04 ప్రిజ్మాటిక్ సెల్స్)" },
          { label: "రేంజ్", value: "రేటెడ్ లోడ్‌తో 60 కిమీ" },
          { label: "ఛార్జర్", value: "AC స్లో 6.6 kW (ఆన్‌బోర్డ్) + AC ఫాస్ట్ 13.2 kW (ఆఫ్-బోర్డ్, ఐచ్ఛికం)" },
          { label: "గరిష్ట టార్క్", value: "223 NM" },
          { label: "బరువు", value: "~2.3 టన్నులు" },
          { label: "లిఫ్టింగ్ సామర్థ్యం", value: "1800 కిలోలు" },
          { label: "గరిష్ట వేగం", value: "35 కిమీ/గం" },
          { label: "PTO పవర్", value: "24.5 kW / 32.8 HP" },
          { label: "శీతలీకరణ", value: "వాటర్ కూల్డ్ మోటార్" },
          { label: "ట్రాన్స్మిషన్", value: "Constant Mesh (Carraro)" },
          { label: "వారంటీ", value: "మోటార్ 3+2 సంవత్సరాలు, బ్యాటరీ 5 సంవత్సరాలు / 1500 సైకిల్స్" },
        ],
        features: [
          {
            title: "LFP04 ప్రిజ్మాటిక్ బ్యాటరీ ప్యాక్",
            desc: "తీవ్రమైన వాతావరణంలో స్థిరమైన విద్యుత్ సరఫరా కోసం 38.4 kWh సామర్థ్యం మరియు 1500+ దీర్ఘకాల ఛార్జింగ్ సైకిళ్లతో అధునాతన LFP04 ప్రిజ్మాటిక్ బ్యాటరీ కెమిస్ట్రీ."
          },
          {
            title: "రిమోట్ ఫ్లీట్ టెలిమాటిక్స్",
            desc: "ఆటోనెక్స్ట్ క్లౌడ్ ప్లాట్‌ఫారమ్ ద్వారా రియల్ టైమ్ GPS ట్రాకింగ్, బ్యాటరీ స్థితి, మోటార్ ఆరోగ్యం మరియు జియో-ఫెన్సింగ్ — ఏ పరికరం నుండి అయినా యాక్సెస్ చేయవచ్చు."
          },
        ],
        battery: [
          { label: "కెమిస్ట్రీ", value: "లిథియం ఐరన్ ఫాస్ఫేట్ (LFP04 ప్రిజ్మాటిక్)" },
          { label: "సామర్థ్యం", value: "38.4 kWh" },
          { label: "సెల్ సైకిల్ లైఫ్", value: "1500 ఛార్జింగ్-డిశ్చార్జ్ సైకిల్స్" },
          { label: "వారంటీ", value: "5 సంవత్సరాలు / 1500 ఛార్జింగ్-డిశ్చార్జ్ సైకిల్స్ (ఏది ముందైతే అది)" },
          { label: "ఆన్‌బోర్డ్ ఛార్జర్", value: "అవును — 6.6 kW (ఇన్‌బిల్ట్)" },
          { label: "IP రేటింగ్", value: "IP67" },
        ],
        motor: [
          { label: "రకం", value: "PMSM (Permanent Magnet Synchronous Motor)" },
          { label: "మోటార్ పవర్", value: "32 kW (45 HP సమానం)" },
          { label: "గరిష్ట టార్క్", value: "223 NM" },
          { label: "రేటెడ్ RPM", value: "1800 RPM" },
          { label: "శీతలీకరణ", value: "వాటర్ కూల్డ్ మోటార్" },
        ],
        applications: [
          "వాణిజ్య వ్యవసాయం మరియు భారీ నేల దున్నడం",
          "పారిశ్రామిక మెటీరియల్ హ్యాండ్లింగ్ మరియు లాజిస్టిక్స్",
          "10 టన్నుల రేటెడ్ లోడ్ వరకు రవాణా మరియు పేలోడ్ హ్యాండ్లింగ్",
          "తోటల పెంపకం, ద్రాక్షతోటలు మరియు వరుస పంటల నిర్వహణ",
          "పారిశ్రామిక ప్లాంట్ అంతర్గత లాజిస్టిక్స్",
          "మునిసిపల్ మరియు ప్రభుత్వ ఫ్లీట్ కార్యకలాపాలు",
        ],
        highlights: [
          "32 kW PMSM మోటార్‌తో అధిక-సామర్థ్యంగల 45HP వాణిజ్య ఎలక్ట్రిక్ ట్రాక్టర్",
          "38.4 kWh LFP04 ప్రిజ్మాటిక్ బ్యాటరీ — రేటెడ్ లోడ్‌తో 60 కిమీ రేంజ్",
          "Carraro కాన్స్టెంట్ మెష్ ట్రాన్స్మిషన్‌తో 223 NM పీక్ టార్క్",
          "ద్వంద్వ ఛార్జింగ్: ఆన్‌బోర్డ్ AC స్లో 6.6 kW + ఆఫ్-బోర్డ్ AC ఫాస్ట్ 13.2 kW",
          "1800 కిలోల హైడ్రాలిక్ లిఫ్టింగ్ సామర్థ్యం, 10 టన్నుల పేలోడ్",
          "5 సంవత్సరాల బ్యాటరీ వారంటీ / 1500 ఛార్జ్-డిశ్చార్జ్ సైకిళ్ళు",
          "భారతదేశంలో తయారు చేయబడింది — థానే, మహారాష్ట్ర",
        ],
      },
    }
  },
  // Industry Page
  industryPage: {
    metaTitle: "పరిశ్రమ ఆధారంగా ఎలక్ట్రిక్ ట్రాక్టర్లు | AutoNxt",
    metaDescription: "వివిధ రంగాలలో AutoNxt ఎలక్ట్రిక్ వాహనాలను అన్వేషించండి: వ్యవసాయం, నిర్మాణం, విమానాశ్రయాలు, బయోమాస్, లోహం మరియు రక్షణ.",
    texts: {
      indSol: "పారిశ్రామిక పరిష్కారాలు",
      heroTitlePre: "భారతదేశపు అత్యంత ",
      heroTitleHighlight: "కఠినమైన",
      heroTitlePost: " పరిశ్రమలకు శక్తినిస్తోంది.",
      heroDesc: "కఠినంగా నిర్మించబడిన, సున్నా-ఉద్గార ఎలక్ట్రిక్ ట్రాక్టర్ పరిష్కారాలు — భారతదేశపు అత్యంత కఠినమైన వాతావరణాల కోసం రూపొందించబడ్డాయి.",
      industriesLabel: "పరిశ్రమలు",
      applicationsLabel: "అప్లికేషన్లు",
      certifiedLabel: "ధృవీకరించబడినవి",
      ourSolutions: "మా పరిష్కారాలు",
      solHeading: "ఆరు పరిశ్రమలు. ఒకే EV ప్లాట్‌ఫారమ్.",
      solDesc: "భారతదేశంలోని అత్యంత కఠినమైన వాతావరణాలలో నిరంతర పనిభారం కోసం ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్లు నిర్మించబడ్డాయి.",
      learnMore: "మరింత తెలుసుకోండి",
      ourTractors: "మా ట్రాక్టర్లు",
      tractorsHeading: "ప్రతి పనికి సరైన ట్రాక్టర్.",
      tractorsDesc: "పారిశ్రామిక మరియు వ్యవసాయ పనుల కోసం ప్రత్యేకంగా నిర్మించబడిన మా ఎలక్ట్రిక్ ట్రాక్టర్ల శ్రేణి నుండి ఎంచుకోండి.",
      electricTractor: "ఎలక్ట్రిక్ ట్రాక్టర్",
      viewDetails: "వివరాలను వీక్షించండి",
      dontSeeSector: "మీ రంగం కనిపించడం లేదా?",
      ctaDesc: "మా ప్లాట్‌ఫారమ్ అపరిమితంగా అనుకూలమైనది. కస్టమ్ పారిశ్రామిక భాగస్వామ్యం కోసం మా పరిష్కారాల బృందంతో మాట్లాడండి.",
      talkToUs: "మాతో మాట్లాడండి",
    },
    industries: [
      {
        title: "బయోమాస్",
        slug: "biomass",
        short: "బయోమాస్",
        desc: "పచ్చని భవిష్యత్తు కోసం సున్నా ఉద్గారాలు మరియు తక్కువ నిర్వహణ ఖర్చులతో బయోమాస్ సేకరణ, ప్రాసెసింగ్ మరియు రవాణాలో విప్లవాత్మక మార్పులు.",
        detail: "బయోమాస్ కార్యకలాపాలలో ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్లు సామర్థ్యాన్ని పునర్నిర్వచిస్తాయి. బయోమాస్ సేకరణ, ప్రాసెసింగ్ మరియు రవాణా కోసం రూపొందించబడిన మా ట్రాక్టర్లు ప్రతి సైకిల్‌లో విశ్వసనీయత మరియు స్థిరత్వాన్ని అందిస్తాయి.",
        bg: "bg-lime-700",
        img: "/images/doubletrolleysidedroneview.webp",
      },
      {
        title: "సిమెంట్ తయారీ",
        short: "సిమెంట్",
        slug: "cement",
        desc: "సిమెంట్ ప్లాంట్లలో మెటీరియల్ హ్యాండ్లింగ్, రవాణా మరియు సైట్ నిర్వహణను ఆప్టిమైజ్ చేయండి — పనికిరాని సమయాన్ని తగ్గిస్తుంది, ఉత్పాదకతను పెంచుతుంది.",
        detail: "సిమెంట్ తయారీలో ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్ల శక్తిని అనుభవించండి. మా ట్రాక్టర్లు సున్నా ఉద్గారాలు మరియు అధునాతన ఫీచర్లతో మెటీరియల్ హ్యాండ్లింగ్, రవాణా మరియు సైట్ నిర్వహణను ఆప్టిమైజ్ చేస్తాయి.",
        bg: "bg-orange-700",
        img: "/images/cement_industry.webp",
      },
      {
        title: "నిర్మాణ రంగం",
        short: "నిర్మాణ రంగం",
        slug: "construction",
        desc: "సైట్ తయారీ, మెటీరియల్ హ్యాండ్లింగ్ మరియు పరికరాల రవాణా కోసం అసమానమైన బహుముఖ ప్రజ్ఞ మరియు శక్తి — పర్యావరణ అనుకూల నిర్మాణం వైపు అడుగులు.",
        detail: "ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్లు నిర్మాణ రంగ భవిష్యత్తు. అసమానమైన బహుముఖ ప్రజ్ఞ మరియు శక్తితో, ఇవి సైట్ తయారీ, మెటీరియల్ హ్యాండ్లింగ్ మరియు పరికరాల రవాణాలో అద్భుతంగా పనిచేస్తాయి.",
        bg: "bg-yellow-700",
        img: "/images/construction_industry.webp",
      },
      {
        title: "రక్షణ రంగం",
        short: "రక్షణ రంగం",
        slug: "defence",
        desc: "మిలిటరీ లాజిస్టిక్స్, బేస్ మెయింటెనెన్స్ మరియు ఆల్-టెర్రైన్ కార్యకలాపాల కోసం రిమోట్ ఆపరేషన్ ఆప్షన్లతో కూడిన అత్యున్నత పనితీరు మరియు కఠినమైన మన్నిక.",
        detail: "రక్షణ రంగ అవసరాల కోసం ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్లు అత్యున్నత పనితీరును మరియు కఠినమైన మన్నికను అందిస్తాయి. లాజిస్టిక్స్ మద్దతు నుండి బేస్ నిర్వహణ వరకు, ఇవి అత్యంత కఠినమైన మిలిటరీ వాతావరణంలో రాణిస్తాయి.",
        bg: "bg-slate-700",
        img: "/images/implements.webp",
      },
      {
        title: "విమానాశ్రయ కార్యకలాపాలు",
        short: "విమానాశ్రయం",
        slug: "airport",
        desc: "లగేజ్ హ్యాండ్లింగ్ నుండి రన్‌వే నిర్వహణ వరకు — సున్నితమైన, హరిత విమానాశ్రయ కార్యకలాపాల కోసం సున్నా-ఉద్గార, అటానమస్-సిద్ధంగా ఉన్న ట్రాక్టర్లు.",
        detail: "ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్లు విమానాశ్రయ కార్యకలాపాలను పునర్నిర్వచిస్తాయి. లగేజ్ హ్యాండ్లింగ్ నుండి రన్‌వే నిర్వహణ వరకు, మా ట్రాక్టర్లు సున్నా ఉద్గారాలను మరియు అధునాతన స్వయంప్రతిపత్త నావిగేషన్ ఫీచర్లను అందిస్తాయి.",
        bg: "bg-sky-700",
        img: "/images/facility/garage-entry.webp",
      },
      {
        title: "మెటల్ తయారీ",
        short: "మెటల్",
        slug: "metal",
        desc: "మెటీరియల్ హ్యాండ్లింగ్ నుండి లాజిస్టిక్స్ వరకు, మా ట్రాక్టర్లు పర్యావరణ ప్రభావాన్ని తగ్గిస్తూ మెటల్ తయారీ కార్యకలాపాలను సులభతరం చేస్తాయి.",
        detail: "మెటల్ తయారీలో ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్లు సామర్థ్యాన్ని పునర్నిర్వచిస్తాయి. మెటీరియల్ హ్యాండ్లింగ్ నుండి లాజిస్టిక్స్ వరకు, మా ట్రాక్టర్లు పర్యావరణ ప్రభావాన్ని తగ్గిస్తూ కార్యకలాపాలను సులభతరం చేస్తాయి.",
        bg: "bg-slate-600",
        img: "/images/videos/loaders-grabbers-thumbnail.webp",
      },
    ],
    tractors: [
      {
        img: "/images/products/x45h2.webp",
        name: "AutoNxt X45H2",
        slug: "x45h2",
        hp: "45HP",
        status: "available",
        statusLabel: "ఇప్పుడు అందుబాటులో ఉంది",
        desc: "వ్యవసాయం మరియు నిర్మాణానికి అనువైన శక్తివంతమైన 45HP ట్రాక్టర్. సాంప్రదాయ 35–55 HP డీజిల్ ట్రాక్టర్ల పనితీరుకు సరిపోలుతూ, విస్తృత శ్రేణి వ్యవసాయ మరియు రవాణా కార్యకలాపాలకు సరిగ్గా సరిపోతుంది.",
        specs: [
          { label: "మోటార్", value: "32 kW" },
          { label: "బ్యాటరీ", value: "38.4 kWh" },
          { label: "రేంజ్", value: "50 కిమీ" },
        ],
        accentBg: "bg-primary/5",
        accentBorder: "border-primary/20",
        tagColor: "bg-emerald-500",
      },
      {
        img: "/images/products/h55c2.webp",
        name: "AutoNxt H55C2",
        slug: "h55c2",
        hp: "55HP Equivalent",
        status: "available",
        statusLabel: "ఇప్పుడు అందుబాటులో ఉంది",
        desc: "63.89 kwh లిక్విడ్-కూల్డ్ LFP బ్యాటరీ, Carraro ట్రాన్స్మిషన్, 410 NM టార్క్ మరియు 80 కిమీ రేంజ్‌తో కూడిన అధిక-పనితీరు గల 55HP సమానమైన ఎలక్ట్రిక్ ట్రాక్టర్. భారీ వ్యవసాయ మరియు పారిశ్రామిక కార్యకలాపాల కోసం నిర్మించబడింది.",
        specs: [
          { label: "మోటార్", value: "45 kW" },
          { label: "బ్యాటరీ", value: "63.89 kwh" },
          { label: "రేంజ్", value: "80 కిమీ" },
        ],
        accentBg: "bg-accent/5",
        accentBorder: "border-accent/20",
        tagColor: "bg-accent",
      },
      {
        img: "/images/products/x45h2.webp",
        name: "AutoNxt X45C2",
        slug: "x45c2",
        hp: "45HP",
        status: "available",
        statusLabel: "ఇప్పుడు అందుబాటులో ఉంది",
        desc: "మధ్యస్థ స్థాయి కార్యకలాపాల కోసం అధునాతన ఫీచర్లతో కూడిన అధిక సామర్థ్యం గల 45HP ఎలక్ట్రిక్ ట్రాక్టర్. విశ్వసనీయత మరియు సున్నా-ఉద్గారాల స్థిరత్వం యొక్క ఖచ్చితమైన సమతుల్యత.",
        specs: [
          { label: "మోటార్", value: "32 kW" },
          { label: "బ్యాటరీ", value: "38.4 kWh" },
          { label: "రేంజ్", value: "60 కిమీ" },
        ],
        accentBg: "bg-primary/5",
        accentBorder: "border-primary/20",
        tagColor: "bg-emerald-500",
      },
    ]
  },
  // Industry Detail Page
  industryDetailPage: {
    texts: {
      industryNotFound: "పరిశ్రమ కనుగొనబడలేదు",
      backToIndustries: "← పరిశ్రమలకు తిరిగి వెళ్ళండి",
      allIndustries: "అన్ని పరిశ్రమలు",
      overview: "అవలోకనం",
      challenge: "సవాలు",
      theAutoNxtSolution: "ఆటోనెక్స్ట్ పరిష్కారం",
      keyApplications: "ప్రధాన అప్లికేషన్లు",
      whatAutoNxtDoes: "ఇక్కడ ఆటోనెక్స్ట్ ఏమి చేస్తుంది",
      whyAutoNxt: "ఆటోనెక్స్ట్‌ను ఎందుకు ఎంచుకోవాలి",
      builtFor: "కోసం నిర్మించబడింది ",
      electricMotor: "ఎలక్ట్రిక్ మోటార్",
      torque0Rpm: "సున్నా RPM నుండి తక్షణ పూర్తి టార్క్",
      batteryRange: "బ్యాటరీ రేంజ్",
      perChargeDuty: "నిరంతర డ్యూటీ సైకిల్‌లో ప్రతి ఛార్జ్‌కు",
      chargeTime: "ఛార్జ్ సమయం",
      acChargingStandard: "ప్రామాణిక పారిశ్రామిక సరఫరా నుండి AC ఛార్జింగ్",
      fleetSupport: "ఫ్లీట్ మద్దతు",
      remoteDiagnostics: "రిమోట్ డయాగ్నోస్టిక్స్ మరియు టెలిమాటిక్స్",
      recommendedModels: "సిఫార్సు చేయబడిన మోడల్స్",
      rightTractorFor: "కోసం సరైన ట్రాక్టర్ ",
      viewFullSpecs: "పూర్తి వివరాలను వీక్షించండి",
      readyToGoElectric: "లో ఎలక్ట్రిక్‌గా మారడానికి సిద్ధంగా ఉన్నారా ",
      ctaDesc: "మా పారిశ్రామిక పరిష్కారాల బృందంతో మాట్లాడండి. ఫ్లీట్ అవసరాలు, ఛార్జింగ్ అవస్థాపన మరియు TCO పొదుపులను అంచనా వేయడానికి మేము మీకు సహాయం చేస్తాము.",
      bookConsultation: "సంప్రదింపులను బుక్ చేయండి",
    },
    industries: {
      biomass: {
        title: "బయోమాస్",
        badge: "బయోమాస్",
        tagline: "సున్నా-ఉద్గార బయోమాస్ సేకరణ & ప్రాసెసింగ్",
        desc: "భారతదేశం ఏటా 500 మిలియన్ టన్నుల వ్యవసాయ బయోమాస్‌ను ఉత్పత్తి చేస్తుంది. ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్లు బయోమాస్ సేకరణ, బేలింగ్, రవాణా మరియు ప్రాసెసింగ్ యొక్క ప్రత్యేక అవసరాల కోసం ప్రత్యేకంగా రూపొందించబడ్డాయి — నిల్వ మరియు ప్రాసెసింగ్ సదుపాయాల లోపల అధిక రన్‌టైమ్, తక్కువ టన్ను ఖర్చు మరియు సున్నా ఉద్గారాలను అందిస్తాయి.",
        bg: "bg-lime-700",
        image: "/images/doubletrolleysidedroneview.webp",
        applications: [
          {
            title: "బయోమాస్ రవాణా",
            desc: "సుదీర్ఘమైన అధిక టార్క్ సామర్థ్యంతో బయోమాస్ ట్రైలర్లను లాగండి — వేడి పెరగడం లేదు, క్లోజ్డ్ బయోమాస్ బేలలో డీజిల్ పొగ ఉండదు."
          },
          {
            title: "బేలింగ్ కార్యకలాపాలు",
            desc: "స్థిరమైన PTO అవుట్‌పుట్‌తో రౌండ్ మరియు స్క్వేర్ బేలర్లను నడపండి. ఇంజన్ ఆగిపోకుండా లోడ్ మార్పులను తట్టుకోవడానికి ఎలక్ట్రిక్ టార్క్ కర్వ్ అనువైనది."
          },
          {
            title: "ప్లాంట్ అంతర్గత రవాణా",
            desc: "డీజిల్ పొగలు ఆరోగ్యానికి హానికరంగా ఉండే ప్రాసెసింగ్ ప్లాంట్ల లోపల బయోమాస్ బేల్స్‌ను తరలించండి. ఆటోనెక్స్ట్ యొక్క సున్నా-ఉద్గారాల ఆపరేషన్ క్లోజ్డ్ వాతావరణాలకు సురక్షితమైనది."
          },
          {
            title: "క్షేత్ర సేకరణ",
            desc: "ఛార్జ్ అయిన ప్రతిసారీ 8+ గంటల రన్‌టైమ్‌తో మల్టిపుల్-పాస్ ఫీల్డ్ కలెక్షన్. స్మార్ట్ టెలిమాటిక్స్ ఫీల్డ్ కవరేజీని ట్రాక్ చేస్తుంది మరియు సేకరణ మార్గాలను ఆప్టిమైజ్ చేస్తుంది."
          },
        ],
        benefits: [
          "5 సంవత్సరాల కాలంలో డీజిల్‌తో పోలిస్తే 70% తక్కువ నిర్వహణ ఖర్చు",
          "సున్నా పొగలు — ఇండోర్ బయోమాస్ నిల్వ మరియు ప్రాసెసింగ్‌కు సురక్షితమైనది",
          "ఛార్జ్‌కు 8–10 గంటల నిరంతర ఆపరేషన్",
          "వాణిజ్య వ్యవసాయ వినియోగం కోసం iCAT ధృవీకరించబడింది",
          "ఫాస్ట్ ఛార్జింగ్ సదుపాయం పనులను వేగవంతం చేస్తుంది",
          "ఆటోనెక్స్ట్ టెలిమాటిక్స్ పోర్టల్ ద్వారా రిమోట్ ఫ్లీట్ పర్యవేక్షణ",
        ],
        challenges: "బయోమాస్ కార్యకలాపాలు సుదీర్ఘమైన షిఫ్ట్‌లలో నడుస్తాయి, తరచుగా షెడ్‌ల లోపల డీజిల్ పొగలు తీవ్రమైన గాలి నాణ్యత మరియు అగ్ని ప్రమాదాలను సృష్టిస్తాయి. అధిక ఇంధన ఖర్చులు లాభాలను తగ్గిస్తాయి మరియు పంట కాలంలో అనుకోని నిర్వహణ పనులు సరఫరా గొలుసును దెబ్బతీస్తాయి.",
        solution: "ఆటోనెక్స్ట్ X45H2 సున్నా పొగలతో 45HP తక్షణ ఎలక్ట్రిక్ టార్క్‌ను అందిస్తుంది, బయోమాస్ ప్రాసెసింగ్ సదుపాయాల లోపల ఉపయోగించడానికి సురక్షితమైనదిగా చేస్తుంది. 8+ గంటల రన్‌టైమ్ మరియు 4 గంటల ఛార్జ్ సైకిల్‌తో, సదుపాయాలు రాత్రిపూట ఛార్జింగ్‌ని ఉపయోగించి ఒకే ట్రాక్టర్‌తో రెండు షిఫ్ట్‌లను నడపవచ్చు.",
        models: [
          { name: "ఆటోనెక్స్ట్ X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "బయోమాస్ రవాణా మరియు బేలింగ్ కోసం ప్రాథమిక ఎంపిక", slug: "x45h2" },
          { name: "ఆటోనెక్స్ట్ H55C2", hp: "55 HP", img: "/images/products/h55c2.webp", note: "భారీ బయోమాస్ సేకరణ మరియు పారిశ్రామిక కార్యకలాపాలకు అధిక-పనితీరు గల ఎంపిక", slug: "h55c2" },
        ],
      },
      cement: {
        title: "సిమెంట్ తయారీ",
        badge: "సిమెంట్",
        tagline: "శుభ్రమైన, నిశ్శబ్దమైన సిమెంట్ ప్లాంట్ కార్యకలాపాలు",
        desc: "సిమెంట్ ప్లాంట్లు దుమ్ము, శబ్దం మరియు ఇంధనంపై ఎక్కువగా ఆధారపడే వాతావరణాలు. ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్లు అంతర్గత లాజిస్టిక్స్‌ను మారుస్తాయి — ముడి పదార్థాల హ్యాండ్లింగ్ నుండి క్లింకర్ రవాణా వరకు — ఉద్గారాలను తగ్గిస్తూ, ఇంధన ఖర్చులను భారీగా తగ్గిస్తాయి.",
        bg: "bg-orange-700",
        image: "/images/cement_industry.webp",
        applications: [
          {
            title: "ముడి పదార్థాల లాజిస్టిక్స్",
            desc: "ప్లాంట్ కారిడార్లలో సున్నపురాయి, మట్టి మరియు ఇతర పదార్థాలను రవాణా చేయండి. డీజిల్ ఇంజిన్ల గాలి కదలికలతో పోలిస్తే ఎలక్ట్రిక్ ఆపరేషన్ దుమ్ము తిరిగి లేవడాన్ని తగ్గిస్తుంది."
          },
          {
            title: "క్లింకర్ రవాణా",
            desc: "అధిక ఉష్ణోగ్రత మండలాల్లో వేడెక్కడం వంటి ఆందోళనలు లేకుండా స్థిరమైన అధిక-టార్క్ సామర్థ్యంతో కిల్‌న్లు, కూలర్లు మరియు సైలోల మధ్య క్లింకర్‌ను తరలించండి."
          },
        ],
        benefits: [
          "క్లోజ్డ్ ప్లాంట్ కారిడార్లలో డీజిల్ పొగలను నివారిస్తుంది",
          "తక్కువ శబ్దం 24/7 ప్లాంట్ వాతావరణంలో కార్మికుల అలసటను తగ్గిస్తుంది",
          "హైడ్రాలిక్ ఆయిల్ లీకేజీలు ఉండవు — సిమెంట్ నిల్వ ప్రాంతాల దగ్గర ఇది చాలా ముఖ్యం",
          "భారీ పారిశ్రామిక వినియోగం కోసం iCAT ధృవీకరించబడింది",
          "OTA సాఫ్ట్‌వేర్ అప్‌డేట్‌లు పనితీరును అత్యుత్తమంగా ఉంచుతాయి",
          "ప్లాంట్ మేనేజ్‌మెంట్ సిస్టమ్స్‌తో ఫ్లీట్ టెలిమాటిక్స్ అనుసంధానం",
        ],
        challenges: "సిమెంట్ ప్లాంట్లు కేవలం అంతర్గత లాజిస్టిక్స్ కోసమే నెలకు వేల లీటర్ల డీజిల్‌ను వినియోగిస్తాయి. అధిక ఉష్ణోగ్రతలు డీజిల్ ఇంజన్లు వేడెక్కడానికి కారణమవుతాయి. ఉద్గారాల నిబంధనలు కఠినతరం అవుతున్నాయి, మరియు ప్లాంట్లు పెట్టుబడిదారులకు ESG ప్రగతిని ప్రదర్శించాల్సి ఉంటుంది.",
        solution: "ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్లు పొగలను విడుదల చేయవు మరియు అధిక ఉష్ణోగ్రత వాతావరణంలో తక్కువ వేడిని కలిగి ఉంటాయి. మాడ్యులర్ బ్యాటరీ ఆర్కిటెక్చర్‌తో, పూర్తి ట్రాక్టర్‌ను నిలిపివేయకుండా బ్యాటరీ ప్యాక్‌లను సర్వీస్ చేయవచ్చు, ఇది 24/7 ప్లాంట్ పనులకు ఎలాంటి అంతరాయం కలిగించదు.",
        models: [
          { name: "ఆటోనెక్స్ట్ X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "క్లింకర్ రవాణా మరియు భారీ రవాణా కోసం సిఫార్సు చేయబడింది", slug: "x45h2" },
        ],
      },
      construction: {
        title: "నిర్మాణ రంగం",
        badge: "నిర్మాణ రంగం",
        tagline: "భారతదేశ నిర్మాణ రంగానికి స్థిరమైన శక్తి",
        desc: "భారతదేశ నిర్మాణ రంగం ప్రతి సంవత్సరం మిలియన్ల కొద్దీ చదరపు మీటర్ల విస్తీర్ణాన్ని జోడిస్తోంది. ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్లు సైట్ తయారీ, మెటీరియల్ రవాణా మరియు పరికరాల అమరికకు సున్నా-ఉద్గార, అధిక-టార్క్ పనితీరును అందిస్తాయి — సైట్ కార్బన్ ఫుట్‌ప్రింట్‌ను తగ్గిస్తూ ఇంధన ఖర్చులను ఆదా చేస్తాయి.",
        bg: "bg-yellow-700",
        image: "/images/construction_industry.webp",
        applications: [
          {
            title: "మెటీరియల్ రవాణా",
            desc: "స్థిరమైన, అధిక-టార్క్ ఎలక్ట్రిక్ డ్రైవ్‌ట్రెయిన్‌తో నిర్మాణ స్థలాలలో ఇసుక, కంకర, ఇటుకలు మరియు స్టీల్‌ను రవాణా చేయండి."
          },
        ],
        benefits: [
          "గ్రీన్ బిల్డింగ్ సైట్ ఉద్గారాల ప్రమాణాలకు అనుగుణంగా ఉంటుంది (GRIHA / IGBC)",
          "తక్కువ శబ్దం — నివాస ప్రాంతాల పని వేళల పరిమితులకు లోబడి ఉంటుంది",
          "ఎగుడుదిగుడు మరియు రాళ్ల నేలల కోసం రేట్ చేయబడిన కఠినమైన చాసిస్",
          "వాలులపై లోడ్ ఉన్న రవాణా కోసం తక్షణ టార్క్ అనువైనది",
          "సైట్‌లో ఇంధన నిల్వ ప్రమాదం లేదు — అగ్ని ప్రమాదాలను తగ్గిస్తుంది",
        ],
        challenges: "నిర్మాణ స్థలాలు ముఖ్యంగా పట్టణ నివాస ప్రాంతాల సమీపంలో డీజిల్ ఉద్గారాలపై పెరుగుతున్న నిబంధనల ఒత్తిడిని ఎదుర్కొంటున్నాయి. ఇంధన రవాణా సంక్లిష్టమైనది మరియు దొంగతనాలకు గురయ్యే అవకాశం ఉంది. డీజిల్ ఇంజన్లు దుమ్ము మరియు బహిరంగ సైట్లలో తీవ్రమైన ఉష్ణోగ్రతలతో ఇబ్బంది పడతాయి.",
        solution: "ఆటోనెక్స్ట్ X45H2 యొక్క సీల్డ్ ఎలక్ట్రిక్ డ్రైవ్‌ట్రెయిన్‌పై దుమ్ము ప్రభావం చూపదు. దీనికి ఇంధన సరఫరా అవసరం లేదు మరియు సైట్ యొక్క తాత్కాలిక విద్యుత్ సరఫరా లేదా ప్రత్యేక ఛార్జింగ్ స్టేషన్ నుండి రాత్రిపూట బ్యాటరీని ఛార్జ్ చేయవచ్చు.",
        models: [
          { name: "ఆటోనెక్స్ట్ X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "నిర్మాణ స్థల రవాణా మరియు నేల తయారీకి ప్రాథమిక ఎంపిక", slug: "x45h2" },
        ],
      },
      defence: {
        title: "రక్షణ రంగం",
        badge: "రక్షణ రంగం",
        tagline: "నిశ్శబ్దం. కఠినం. సిద్ధంగా ఉంది.",
        desc: "రక్షణ మరియు పారామిలిటరీ కార్యకలాపాలకు ఒత్తిడిలో విశ్వసనీయంగా ఉండే, కఠినమైన వాతావరణంలో పనిచేసే మరియు తక్కువ శబ్దం, తక్కువ వేడిని విడుదల చేసే పరికరాలు అవసరం. ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్లు బేస్ లాజిస్టిక్స్, ఎయిర్‌ఫీల్డ్ సపోర్ట్ మరియు అన్ని రకాల భూభాగాల ఉపయోగం కోసం రూపొందించబడ్డాయి.",
        bg: "bg-slate-700",
        image: "/images/implements.webp",
        applications: [
          {
            title: "బేస్ లాజిస్టిక్స్",
            desc: "బేస్ సదుపాయాల మధ్య సామాగ్రి, మందుగుండు సామగ్రి నిల్వ యూనిట్లు మరియు పరికరాలను ఎలాంటి శబ్దం లేకుండా తరలించండి, ఇది భద్రతా సరిహద్దులను రాజీ చేయదు."
          },
        ],
        benefits: [
          "దాదాపు నిశ్శబ్దమైన ఎలక్ట్రిక్ ఆపరేషన్ శబ్దం స్థాయిని తగ్గిస్తుంది",
          "పొగ గొట్టం నుండి వేడి ఉద్గారాలు లేవు — మెరుగైన కార్యాచరణ భద్రత",
          "తక్కువ శ్రేణి బేస్ లాజిస్టిక్స్ కోసం ఇంధన ఆధారపడటాన్ని నివారిస్తుంది",
          "కఠినమైన మరియు రోడ్డు లేని భూభాగాల కోసం రేట్ చేయబడిన చాసిస్",
          "తక్కువ నిర్వహణ భారం — ఇంజన్ ఆయిల్, ఫిల్టర్లు లేదా ఇంజెక్టర్లు లేవు",
        ],
        challenges: "రక్షణ లాజిస్టిక్స్‌కు సంక్లిష్టమైన ఇంధన సరఫరా లేకుండా, విభిన్న భూభాగాలలో నిశ్శబ్దంగా పనిచేసే పరికరాలు అవసరం. డీజిల్ జనరేటర్లు మరియు ట్రాక్టర్లు శబ్దం మరియు వేడిని ఉత్పత్తి చేస్తాయి, ఇవి భద్రతకు ముప్పు కలిగిస్తాయి.",
        solution: "ఆటోనెక్స్ట్ ఎలక్ట్రిక్ పవర్‌ట్రెయిన్ కార్యకలాపాలు నిశ్శబ్దంగా ఉంటాయి మరియు ఎలాంటి వేడిని విడుదల చేయవు, బేస్ సరిహద్దు కార్యకలాపాలకు అనువైనవిగా చేస్తాయి. మాడ్యులర్ బ్యాటరీ ప్యాక్‌ను ఫీల్డ్ జనరేటర్ లేదా స్థానిక గ్రిడ్ కనెక్షన్ ద్వారా ఛార్జ్ చేయవచ్చు.",
        models: [
          { name: "ఆటోనెక్స్ట్ X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "రక్షణ బేస్ లాజిస్టిక్స్ కోసం ప్రాథమిక సిఫార్సు", slug: "x45h2" },
        ],
      },
      airport: {
        title: "విమానాశ్రయ కార్యకలాపాలు",
        badge: "విమానాశ్రయం",
        tagline: "భారతీయ విమానాశ్రయాల కోసం క్లీనర్ గ్రౌండ్ ఆపరేషన్లు",
        desc: "విమానాశ్రయాలు గ్రౌండ్-లెవల్ ఉద్గారాలను తగ్గించడానికి తీవ్రమైన ఒత్తిడిని ఎదుర్కొంటున్నాయి. ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్లు లగేజ్ హ్యాండ్లింగ్, రన్‌వే నిర్వహణ, కార్గో రవాణా మరియు సరిహద్దు కార్యకలాపాలకు అనువైనవి — సున్నితమైన టెర్మినల్ వాతావరణంలో గాలి నాణ్యతను దెబ్బతీసే డీజిల్ వాహనాల స్థానంలో ఇవి పనిచేస్తాయి.",
        bg: "bg-sky-700",
        image: "/images/facility/garage-entry.webp",
        applications: [
          {
            title: "లగేజ్ & కార్గో లాగుడు",
            desc: "ప్రయాణీకులు మరియు సిబ్బందికి సమీపంలో ఎలాంటి పొగలు లేకుండా టెర్మినల్స్, విమానాలు మరియు కార్గో బేల మధ్య లగేజ్ ట్రైలర్లను మరియు కార్గో డాలీలను లాగండి."
          },
        ],
        benefits: [
          "DGCA మరియు ICAO గ్రౌండ్ ఉద్గారాల ప్రమాణాలకు అనుగుణంగా ఉంటుంది",
          "నిశ్శబ్ద ఆపరేషన్ ATC కమ్యూనికేషన్ వాతావరణాన్ని మెరుగుపరుస్తుంది",
          "సున్నా పొగలు — విమాన ఇంధన నిల్వల సమీపంలో చాలా ముఖ్యం",
          "UDAN గ్రీన్ గ్రౌండ్ ఆపరేషన్స్ గ్రాంట్‌లకు అర్హత కలిగి ఉంది",
          "విమానాశ్రయ కార్యాచరణ కేంద్రాలతో ఫ్లీట్ టెలిమాటిక్స్ అనుసంధానం",
        ],
        challenges: "విమానాశ్రయాలు గ్రౌండ్-లెవల్ ఉద్గారాలపై కఠినమైన DGCA మరియు ICAO మార్గదర్శకాలను ఎదుర్కొంటున్నాయి. ఇంధన నిల్వల సమీపంలో డీజిల్ వాహనాలు అగ్ని ప్రమాదాలను కలిగిస్తాయి. డీజిల్ పరికరాల నుండి వచ్చే శబ్దం టెర్మినల్ సమీప ప్రాంతాలలో ATC మరియు ప్రయాణీకుల కమ్యూనికేషన్‌కు అంతరాయం కలిగిస్తుంది.",
        solution: "ఆటోనెక్స్ట్ యొక్క సున్నా-ఉద్గార, దాదాపు నిశ్శబ్ద ఎలక్ట్రిక్ ట్రాక్టర్లు విమానాశ్రయ వాతావరణానికి అనువైనవి. వాటిని రాత్రిపూట హ్యాంగర్లలో ఛార్జ్ చేయవచ్చు మరియు ఆటోనెక్స్ట్ టెలిమాటిక్స్ ప్లాట్‌ఫారమ్ ద్వారా పర్యవేక్షించవచ్చు, ఇది విమానాశ్రయ AODB సిస్టమ్స్‌తో అనుసంధానం కాగలదు.",
        models: [
          { name: "ఆటోనెక్స్ట్ X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "లగేజ్ లాగుడు మరియు రన్‌వే నిర్వహణ కోసం సిఫార్సు చేయబడింది", slug: "x45h2" },
        ],
      },
      metal: {
        title: "మెటల్ తయారీ",
        badge: "మెటల్",
        tagline: "మెటల్ ప్లాంట్ల కోసం భారీ-డ్యూటీ ఎలక్ట్రిక్ లాజిస్టిక్స్",
        desc: "స్టీల్ మిల్లుల నుండి అల్యూమినియం స్మెల్టర్లు మరియు మెటల్ ఫ్యాబ్రికేషన్ ప్లాంట్ల వరకు మెటల్ తయారీ సదుపాయాలకు తీవ్రమైన అంతర్గత లాజిస్టిక్స్ అవసరం. ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్లు అధిక స్థిరమైన టార్క్‌తో భారీ మెటీరియల్ రవాణాను నిర్వహిస్తాయి, అదే సమయంలో క్లోజ్డ్ ఫ్యాక్టరీ వాతావరణంలో డీజిల్ పొగలను నివారిస్తాయి.",
        bg: "bg-slate-600",
        image: "/images/videos/loaders-grabbers-thumbnail.webp",
        applications: [
          {
            title: "కాయిల్ & షీట్ రవాణా",
            desc: "భారీ ట్రైలర్ లోడ్లకు అవసరమైన స్థిరమైన అధిక టార్క్‌తో ప్లాంట్ లాజిస్టిక్స్ కారిడార్లలో స్టీల్ కాయిల్స్, అల్యూమినియం షీట్లు మరియు మెటల్ బిల్లెట్లను రవాణా చేయండి."
          },
        ],
        benefits: [
          "క్లోజ్డ్ స్మెల్టింగ్ మరియు రోలింగ్ వాతావరణంలో డీజిల్ పొగలను నివారిస్తుంది",
          "భారీ మెటల్ ట్రైలర్ లోడ్ల కోసం స్థిరమైన అధిక టార్క్",
          "అధిక దుమ్ము వాతావరణాల కోసం IP-రేటెడ్ బ్యాటరీ రక్షణ",
          "మెటల్ ప్రాసెసింగ్ రసాయనాల సమీపంలో అగ్ని ప్రమాదాన్ని తగ్గిస్తుంది",
          "ప్లాంట్ స్థాయి పవర్ మేనేజ్‌మెంట్ సిస్టమ్స్‌తో అనుకూలమైనది",
        ],
        challenges: "మెటల్ ప్లాంట్లు తీవ్రమైన వేడి, దుమ్ము మరియు కఠినమైన గాలి నాణ్యత అవసరాలను ఎదుర్కొంటాయి. క్లోజ్డ్ ప్రదేశాలలో డీజిల్ పొగలు తీవ్రమైన వృత్తిపరమైన ఆరోగ్య ప్రమాదాన్ని కలిగిస్తాయి. విపరీతమైన ఉష్ణోగ్రతలు సాధారణ యాంత్రిక డ్రైవ్‌ట్రెయిన్‌లను కూడా దెబ్బతీస్తాయి.",
        solution: "ఆటోనెక్స్ట్ X45H2 యొక్క సీల్డ్ ఎలక్ట్రిక్ పవర్‌ట్రెయిన్‌పై దుమ్ము ప్రభావం చూపదు మరియు పొగలను విడుదల చేయదు. అధిక ఉష్ణోగ్రత గల మెటల్ ప్లాంట్ వాతావరణంలో, లిక్విడ్-కూల్డ్ బ్యాటరీ ప్యాక్ డీజిల్ ఇంజన్లను ఇబ్బంది పెట్టే వేడెక్కడం సమస్యలు లేకుండా సరైన ఉష్ణోగ్రతను నిర్వహిస్తుంది.",
        models: [
          { name: "ఆటోనెక్స్ట్ X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "మెటల్ ప్లాంట్ రవాణా మరియు లాజిస్టిక్స్ కోసం ప్రాథమిక ఎంపిక", slug: "x45h2" },
        ],
      },
    }
  },
  // Careers Page
  careersPage: {
    texts: {
      careersBadge: "ఆటోనెక్స్ట్‌లో ఉద్యోగాలు",
      heroTitle1: "వ్యవసాయ ",
      heroTitleHighlight: "భవిష్యత్తును",
      heroTitle2: " నిర్మిద్దాం.",
      heroDesc: "భారతీయ వ్యవసాయాన్ని ఎలక్ట్రిక్‌గా మారుస్తున్న ఇంజనీర్లు, వ్యవసాయ శాస్త్రవేత్తలు మరియు వ్యాపార రూపకర్తల బృందంలో చేరండి.",
      openRolesLabel: "అందుబాటులో ఉన్న ఉద్యోగాలు",
      locationsLabel: "లొకేషన్లు",
      teamSizeLabel: "బృందం పరిమాణం",
      positionsCount: " ఉద్యోగాలు",
      locationsVal: "థానే · ముంబై",
      teamSizeVal: "150+ మంది వ్యక్తులు",
      whyJoinUs: "మాతో ఎందుకు చేరాలి",
      workOnProblems: "ప్రాముఖ్యత గల సమస్యలపై పని చేయండి.",
      whyJoinUsDesc: "లక్షలాది మంది రైతులకు వ్యవసాయాన్ని స్థిరమైనదిగా మరియు ఆర్థికంగా లాభదాయకమైనదిగా మార్చడం — భారతదేశపు అత్యంత క్లిష్టమైన సవాలుపై ఆటోనెక్స్ట్ పని చేస్తోంది.",
      openPositions: "అందుబాటులో ఉన్న ఉద్యోగాలు",
      rolesAvailable: " ఉద్యోగాలు ఇప్పుడు అందుబాటులో ఉన్నాయి",
      applyViaEmail: "ఈమెయిల్ ద్వారా దరఖాస్తు చేసుకోండి",
      dontSeeRole: "మీకు సరిపోయే ఉద్యోగం కనిపించడం లేదా?",
      dontSeeRoleDesc: "మేము ఎల్లప్పుడూ అసాధారణమైన ప్రతిభ కోసం చూస్తాము. మీ CVని మాకు పంపండి మరియు ఆటోనెక్స్ట్ మిషన్‌లో మీరు ఎలా భాగస్వామ్యం కాగలరో మాకు తెలియజేయండి.",
      sendOpenApp: "ఓపెన్ అప్లికేషన్ పంపండి",
    },
    perks: [
      { title: "లక్ష్యంతో కూడిన పని", desc: "భారతీయ వ్యవసాయంలో ఉద్గారాల తగ్గింపుకు సహాయపడండి — మీరు నిర్మించే ప్రతి ఉత్పత్తి నిజమైన పర్యావరణ ప్రభావాన్ని కలిగి ఉంటుంది.", color: "text-primary", bg: "bg-primary/10", border: "border-primary/20" },
      { title: "స్టార్టప్ వేగం", desc: "ఫ్లాట్ స్ట్రక్చర్, వేగవంతమైన నిర్ణయాలు మరియు మొదటి రోజు నుండి ముఖ్యమైన సాంకేతిక మరియు వ్యాపార సవాళ్లను అధిగమించే అవకాశం.", color: "text-accent", bg: "bg-accent/10", border: "border-accent/20" },
      { title: "క్షేత్ర అనుభవం", desc: "మా ఇంజనీర్లు క్రమం తప్పకుండా మహారాష్ట్ర, పంజాబ్ మరియు ఆంధ్రప్రదేశ్ పొలాలను సందర్శిస్తారు — మీరు పరిష్కరించే సమస్యను మీరు దగ్గరగా అర్థం చేసుకుంటారు.", color: "text-emerald-600", bg: "bg-emerald-50", border: "border-emerald-200" },
      { title: "ఈక్విటీ & వృద్ధి", desc: "పోటీతత్వ పరిహారం, కీలక పాత్రల కోసం ESOPలు మరియు ఆటోనెక్స్ట్ జాతీయంగా విస్తరిస్తున్నప్పుడు స్పష్టమైన వృద్ధి మార్గం.", color: "text-rose-600", bg: "bg-rose-50", border: "border-rose-200" },
    ],
    roles: [
      {
        title: "సీనియర్ ఎంబెడెడ్ సిస్టమ్స్ ఇంజనీర్",
        dept: "ఇంజనీరింగ్",
        location: "థానే, మహారాష్ట్ర",
        type: "పూర్తి సమయం",
        desc: "ఆటోనెక్స్ట్ ఎలక్ట్రిక్ పవర్‌ట్రెయిన్, BMS మరియు CAN బస్ కమ్యూనికేషన్ సిస్టమ్స్ కోసం ఫర్మ్‌వేర్‌ను రూపొందించండి మరియు అభివృద్ధి చేయండి. C/C++ మరియు రియల్ టైమ్ OS లో బలమైన అనుభవం అవసరం.",
      },
      {
        title: "మెకానికల్ డిజైన్ ఇంజనీర్ – డ్రైవ్‌ట్రెయిన్",
        dept: "ఇంజనీరింగ్",
        location: "థానే, మహారాష్ట్ర",
        type: "పూర్తి సమయం",
        desc: "ట్రాక్టర్ డ్రైవ్‌ట్రెయిన్‌లు, గేర్‌బాక్స్‌లు మరియు ఇంప్లిమెంట్ కప్లింగ్ సిస్టమ్స్ యొక్క మెకానికల్ డిజైన్‌ను నడిపించండి. SolidWorks లో నైపుణ్యం మరియు హ్యాండ్స్-ఆన్ ఫ్యాబ్రికేషన్ అనుభవం ప్రాధాన్యత.",
      },
      {
        title: "వ్యవసాయ క్షేత్ర ఇంజనీర్",
        dept: "ఆపరేషన్స్",
        location: "పాన్-ఇండియా (ప్రయాణం)",
        type: "పూర్తి సమయం",
        desc: "ఆటోనెక్స్ట్ ట్రాక్టర్లను మోహరించడానికి, క్షేత్ర పనితీరు డేటాను సేకరించడానికి మరియు భారతదేశం వ్యాప్తంగా సాంకేతిక మద్దతును అందించడానికి రైతులు మరియు వ్యవసాయ-పారిశ్రామిక క్లయింట్లతో నేరుగా పని చేయండి.",
      },
      {
        title: "బిజినెస్ డెవలప్‌మెంట్ మేనేజర్ – వ్యవసాయ రంగం",
        dept: "సేల్స్",
        location: "పూణే / నాసిక్",
        type: "పూర్తి సమయం",
        desc: "భారీ పొలాలు, చక్కెర మిల్లులు మరియు వ్యవసాయ-పారిశ్రామిక క్లయింట్లతో సంబంధాలను నిర్మించండి మరియు నిర్వహించండి. ట్రాక్టర్ అమ్మకాలు, లీజింగ్ భాగస్వామ్యాలు మరియు ప్రభుత్వ సేకరణ టెండర్లను నడపండి.",
      },
      {
        title: "IoT & టెలిమాటిక్స్ ఇంజనీర్",
        dept: "ఇంజనీరింగ్",
        location: "థానే, మహారాష్ట్ర",
        type: "పూర్తి సమయం",
        desc: "ఆటోనెక్స్ట్ ఫ్లీట్ టెలిమాటిక్స్ ప్లాట్‌ఫారమ్‌ను అభివృద్ధి చేయండి — GPS ట్రాకింగ్, రిమోట్ డయాగ్నోస్టిక్స్, OTA అప్‌డేట్‌లు మరియు ఇన్-ఫీల్డ్ సెన్సార్ల నుండి క్లౌడ్ డ్యాష్‌బోర్డ్‌లకు డేటా పైప్‌లైన్లు.",
      },
      {
        title: "మార్కెటింగ్ & కంటెంట్ స్ట్రాటజిస్ట్",
        dept: "మార్కెటింగ్",
        location: "ముంబై / రిమోట్",
        type: "పూర్తి సమయం",
        desc: "ఆటోనెక్స్ట్ డిజిటల్ ఉనికిని విస్తరించండి — కంటెంట్ మార్కెటింగ్, సోషల్ మీడియా, కేస్ స్టడీస్ మరియు SEO. అగ్రి-టెక్ లేదా సస్టైనబిలిటీ రంగాలలో అనుభవం అదనపు ప్రయోజనం.",
      },
    ]
  },
  // Contribution Page
  contributionPage: {
    metaTitle: "పర్యావరణం & ESG సహకారం | AutoNxt ఎలక్ట్రిక్ ట్రాక్టర్లు",
    metaDescription: "AutoNxt ఎలక్ట్రిక్ ట్రాక్టర్ల ESG ప్రభావం, కార్బన్ ఉద్గారాల తగ్గింపు మరియు పర్యావరణ సహకారాన్ని కనుగొనండి.",
    texts: {
      contribBadge: "మా సహకారం",
      heroTitlePre: "భారత్ కోసం ",
      heroTitleHighlight: "నిర్మించబడింది.",
      heroTitlePost: " గ్రహం కోసం నిర్మించబడింది.",
      heroDesc: "ఆటోనెక్స్ట్ కేవలం ఒక వాహన తయారీదారు మాత్రమే కాదు. ఇది స్వచ్ఛమైన గాలి, పచ్చని నగరాలు మరియు స్వతంత్ర ఎలక్ట్రిక్ భవిష్యత్తు పట్ల భారతదేశం యొక్క నిబద్ధత.",
      co2Label: "CO₂ పొదుపు",
      treesLabel: "చెట్లతో సమానం",
      initiativesLabel: "కార్యక్రమాలు",
      keyInitiatives: "ప్రధాన కార్యక్రమాలు",
      ourJourney: "మా ప్రయాణం",
      joinMovement: "ఉద్యమంలో చేరండి",
      joinDesc: "భారతదేశపు క్లీన్ ఎనర్జీ పరివర్తనను వేగవంతం చేయడానికి ఆటోనెక్స్ట్‌తో భాగస్వామ్యం కండి. కలిసి, మేము మార్పును నడిపిస్తాము.",
      partnerBtn: "మాతో భాగస్వామి కండి",
    },
    impacts: [
      { value: "1,500+", label: "టన్నుల CO₂ ఆఫ్సెట్", desc: "ఆటోనెక్స్ట్ EVs భారతీయ రహదారులపై నివారించిన జీవితకాల కార్బన్ ఉత్సర్గాలు." },
      { value: "270+", label: "వాహనాలు విద్యుదీకరించబడ్డాయి", desc: "పెట్రోల్ మరియు డీజిల్ వాహనాల స్థానంలో స్వచ్ఛమైన ఆటోనెక్స్ట్ ఇలెక్ట్రిక్ పర్యాయాలు చేరాయి." },
      { value: "70,650+", label: "చెట్ల సమతుల్యం", desc: "ప్రతి సంవత్సరం కార్బన్ శోషణలో సమతుల్య పర్యావరణ ప్రయోజనం." },
    ],
    initiatives: [
      {
        title: "ప్రాజెక్ట్ స్వచ్ఛ గతి",
        desc: "15 రాష్ట్ర ప్రభుత్వాల భాగస్వామ్యంతో 2028 నాటికి 50,000 ప్రజా రవాణా వాహనాలను విద్యుద్దీకరించే మా ప్రధాన కార్యక్రమం.",
        badge: "క్రియాశీలకంగా ఉంది",
      },
      {
        title: "FAME ఇండియా భాగస్వామ్యాలు",
        desc: "భారతదేశపు FAME II పథకానికి అనుగుణంగా మునిసిపాలిటీలు, అగ్రిగేటర్లు మరియు వ్యక్తిగత కొనుగోలుదారులకు సబ్సిడీతో కూడిన EV పరిష్కారాలను అందించడం.",
        badge: "ప్రభుత్వ మద్దతు",
      },
      {
        title: "ఆత్మనిర్భర్ మొబిలిటీ",
        desc: "మోటార్ల నుండి బ్యాటరీ మేనేజ్‌మెంట్ సిస్టమ్స్ వరకు 100% స్వదేశీంగా రూపొందించబడింది మరియు తయారు చేయబడింది — భారతదేశం వ్యాప్తంగా 5,000+ నైపుణ్యం కలిగిన ఉద్యోగాలను సృష్టిస్తోంది.",
        badge: "మేక్ ఇన్ ఇండియా",
      },
    ],
    stats: [
      { label: "ఆదా అయిన ఖర్చు", value: "₹30Cr" },
      { label: "పరిశ్రమలు", value: "8 విశ్వసించే" },
      { label: "చొరవలు", value: "3 సక్రియం" },
    ],
    timeline: [
      { year: "2019", event: "స్థాపన — ఆటోనెక్స్ట్ ఆటోమేషన్ प्रा. లి. మహారాష్ట్రలోని పుణేలో స్థాపించబడింది. స్వచ్ఛమైన విద్యుత్ గతిశీలతకు పునాది వేయడానికి మొదటి పరిశోధన మరియు అభివృద్ధి (R&D) ప్రయోగశాల నెలకొల్పబడింది." },
      { year: "2020", event: "మొదటి ప్రోటోటైప్ — మొదటి EV ప్రోటోటైప్ విజయవంతంగా పూర్తి వుప్పటించి పరీక్షించబడింది. SIDBI నుంచి బీజ నిధులు సురక్షించబడ్డాయి, ఇది ముందు R&Dకి అవకాశం కలిగించింది." },
      { year: "2021", event: "ధ్రువీకరణ మరియు భాగస్వామ్యాలు — FAME II (ఇలెక్ట్రిక్ వాహనాల వేగవంతమైన అడాప్షన్ మరియు తయారీ) ధ్రువీకరణం పొందఫడింది. EV అడాప్షన్ ప్రోత్సాహించడానికి 3 రాష్ట్ర ప్రభుత్వాలతో భాగస్వామ్య ఒప్పందాలు స్వాక్షరం చేయబడ్డాయి." },
      { year: "2022", event: "వాణిజ్య ఉత్పత్తి — పూర్తి వాణిజ్య స్థాయిలో ఉత్పత్తి ప్రారంభమైంది. ఫ్లీట్ ఆపరేటర్లకు 500 వాహనాలు సరఫరా చేయబడ్డాయి, ఇది వాణిజ్య ఇలెక్ట్రిక్ మార్కెట్లోకి ఆటోనెక్స్ట్ ప్రవేశాన్ని గురుతు చేసింది." },
      { year: "2023", event: "వేగవంతమైన వృద్ధి — సీరీజ్ B నిధులు విజయవంతంగా సంపాదించబడ్డాయి. భారతదేశంలోని 12 నగరాలకు కార్యకలాపాలు విస్తరించాయి. రహదారిపై 5,000+ వాహనాల మైలురాయి సాధించబడింది." },
      { year: "2024", event: "సాధనలు — సౌర చార్జింగ్ నెట్వర్క్ అధికారికంగా ప్రారంభించబడింది. రక్షణ రంగం ఒప్పందం స్వాక్షరం చేయబడింది. ఆటోనెక్స్ట్ భారతదేశంలో 10,000+ నియోజించబడిన వాహనాల చారిత్రిక సీమాను దాటింది." },
      { year: "2025+", event: "వైశ్విక విస్తరణ — అంతర్జాతీయ విస్తరణ ప్రారంభమైంది. సోలిడ్-స్టేట్ బ్యాటరీ పైలట్ ప్రాజెక్ట్ ప్రారంభమైంది, ఈది ఆటోనెక్స్ట్ స్వచ్ఛ శక్తి ప్రయాణంలో తదుపరి సరహద్దును సూచిస్తోంది." },
    ]
  },
  legalAppAffiliation: {
    bannerTitle: "AUTONXT-Attendance కోసం అధికారిక పేజీ",
    bannerDesc:
      "ఈ పేజీ AutoNxt Automation Pvt. Ltd. ద్వారా ప్రచురించబడింది, Google Playలో autonxtdeveloper డెవలపర్ ఖాతా కింద AUTONXT-Attendance మొబైల్ యాప్‌ను అభివృద్ధి చేసిన డెవలపర్.",
    appNameLabel: "యాప్ పేరు",
    appNameValue: "AUTONXT-Attendance",
    developerLabel: "డెవలపర్",
    developerValue: "AutoNxt Automation Pvt. Ltd.",
    playDeveloperLabel: "Google Play డెవలపర్",
    playDeveloperValue: "autonxtdeveloper",
    packageIdLabel: "ప్యాకేజీ ID",
    packageIdValue: "com.autonxt.attendance.app2",
    websiteLabel: "వెబ్‌సైట్",
    websiteValue: "autonxt.in",
  },
  // Privacy Page
  privacyPage: {
    metaTitle: "గోప్యతా విధానం — AUTONXT-Attendance | AutoNxt",
    texts: {
      legalBadge: "చట్టపరమైనది",
      policyTitle: "గోప్యతా విధానం — AUTONXT-Attendance",
      metaDescription:
        "AUTONXT-Attendance (com.autonxt.attendance.app2) గోప్యతా విధానం, AutoNxt Automation Pvt. Ltd. (autonxtdeveloper) ద్వారా.",
      effectiveDate: "అమలులోకి వచ్చిన తేదీ: 18 జూన్ 2025 · ఆటోనెక్స్ట్ ఆటోమేషన్ ప్రైవేట్ లిమిటెడ్.",
      policyIntro: 'ఆటోనెక్స్ట్ ఆటోమేషన్ ప్రైవేట్ లిమిటెడ్ ("ఆటోనెక్స్ట్", "మేము", "మా" లేదా "మాకు"), AUTONXT-Attendance మొబైల్ యాప్ (ప్యాకేజీ: com.autonxt.attendance.app2, Google Play డెవలపర్: autonxtdeveloper) యొక్క డెవలపర్, మా మొబైల్ యాప్ వినియోగదారులు, వెబ్‌సైట్ (autonxt.in) సందర్శకులు మరియు సేవల వినియోగదారుల గోప్యతను రక్షించడానికి కట్టుబడి ఉంది.',
      backToHome: "హోమ్‌కు తిరిగి వెళ్ళండి",
      accountDeletionLink: "ఖాతా తొలగింపు అభ్యర్థించండి",
      copyright: "© 2025 ఆటోనెక్స్ట్ ఆటోమేషన్ ప్రైవేట్ లిమిటెడ్. అన్ని హక్కులు ప్రత్యేకించబడినవి.",
    },
    sections: [
      {
        title: "1. మేము సేకరించే సమాచారం",
        body: `మీరు ఆటోనెక్స్ట్ వెబ్‌సైట్‌ను సందర్శించినప్పుడు, విచారణను సమర్పించినప్పుడు లేదా డెమోను బుక్ చేసినప్పుడు, మేము క్రింది సమాచారాన్ని సేకరించవచ్చు:\n• వ్యక్తిగత గుర్తింపు సమాచారం: పేరు, ఈమెయిల్ చిరునామా, ఫోన్ నంబర్ మరియు సంస్థ పేరు.\n• వినియోగ డేటా: విశ్లేషణాత్మక సాధనాల ద్వారా స్వయంచాలకంగా సేకరించబడిన పేజీల సందర్శనలు, గడిపిన సమయం, బ్రౌజర్ రకం మరియు IP చిరునామా.\n• కమ్యూనికేషన్ రికార్డులు: మా సంప్రదింపు లేదా బుకింగ్ ఫారమ్‌ల ద్వారా మీరు సమర్పించే ఏదైనా సందేశాలు, ప్రశ్నలు లేదా అభిప్రాయాలు.\n\nమేము చెల్లింపు కార్డ్ వివరాలను నేరుగా సేకరించము; ఏవైనా లావాదేవీలు ధృవీకరించబడిన పేమెంట్ గేట్‌వేల ద్వారా ప్రాసెస్ చేయబడతాయి.`,
      },
      {
        title: "2. మీ సమాచారాన్ని మేము ఎలా ఉపయోగిస్తాము",
        body: `సేకరించిన సమాచారాన్ని మేము క్రింది ప్రయోజనాల కోసం ఉపయోగిస్తాము:\n• మీ విచారణలకు ప్రతిస్పందించడానికి మరియు ఉత్పత్తి సమాచారం లేదా కొటేషన్లను అందించడానికి.\n• డెమో బుకింగ్‌లు, టెస్ట్-డ్రైవ్ అభ్యర్థనలు మరియు కొనుగోలు ఆర్డర్‌లను ప్రాసెస్ చేయడానికి.\n• సంబంధిత ఉత్పత్తి అప్‌డేట్‌లు, వార్తలు మరియు ఆఫర్‌లను పంపడానికి — మీరు అటువంటి కమ్యూనికేషన్‌లను స్వీకరించడానికి అంగీకరించిన చోట మాత్రమే.\n• సమగ్రమైన, అనామక విశ్లేషణల ద్వారా మా వెబ్‌సైట్ యొక్క కార్యాచరణను మరియు కంటెంట్‌ను మెరుగుపరచడానికి.\n• సమాచార సాంకేతిక చట్టం, 2000 తో సహా వర్తించే భారతీయ చట్టం ప్రకారం చట్టపరమైన బాధ్యతలకు కట్టుబడి ఉండటానికి.`,
      },
      {
        title: "3. డేటా భాగస్వామ్యం మరియు బహిర్గతం",
        body: `ఆటోనెక్స్ట్ ఆటోమేషన్ ప్రైవేట్ లిమిటెడ్ మీ వ్యక్తిగత డేటాను మూడవ పక్షాలకు విక్రయించదు, అద్దెకు ఇవ్వదు లేదా వ్యాపారం చేయదు. మేము క్రింది పరిమిత పరిస్థితులలో డేటాను పంచుకోవచ్చు:\n• రహస్య ఒప్పందాల ప్రకారం మా తరపున మాత్రమే డేటాను ప్రాసెస్ చేసే అధీకృత సేవా భాగస్వాములతో (ఉదా. CRM, ఈమెయిల్ మరియు క్లౌడ్ హోస్టింగ్ ప్రొవైడర్లు).\n• చట్టం లేదా కోర్టు ఉత్తర్వుల ప్రకారం అవసరమైనప్పుడు ప్రభుత్వ అధికారులు లేదా నియంత్రణ సంస్థలతో.\n• విలీనం, సముపార్జన లేదా ఆస్తి విక్రయం జరిగినప్పుడు, ఆ సందర్భంలో ఏదైనా బదిలీకి ముందు వినియోగదారులకు తెలియజేయబడుతుంది.`,
      },
      {
        title: "4. డేటా నిలుపుదల",
        body: `సమాచారం సేకరించబడిన ప్రయోజనాన్ని నెరవేర్చడానికి లేదా వర్తించే చట్టం ప్రకారం అవసరమైనంత కాలం మాత్రమే మేము మీ వ్యక్తిగత డేటాను ఉంచుకుంటాము. విచారణ రికార్డులు సాధారణంగా గరిష్టంగా 3 సంవత్సరాల వరకు ఉంచబడతాయి. మీరు software-admin@autonxt.in ని సంప్రదించడం ద్వారా ఎప్పుడైనా మీ డేటాను తొలగించాలని అభ్యర్థించవచ్చు.`,
      },
      {
        title: "5. కుకీలు మరియు ట్రాకింగ్",
        body: `మా వెబ్‌సైట్ మీ బ్రౌజింగ్ అనుభవాన్ని మెరుగుపరచడానికి మరియు విశ్లేషణ డేటాను సేకరించడానికి కుకీలు మరియు సారూప్య ట్రాకింగ్ సాంకేతికతలను ఉపయోగిస్తుంది. వీటిలో ఇవి ఉన్నాయి:\n• అవసరమైన కుకీలు: వెబ్‌సైట్ సరిగ్గా పనిచేయడానికి అవసరం.\n• విశ్లేషణాత్మక కుకీలు: సందర్శకులు సైట్‌తో ఎలా వ్యవహరిస్తారో అర్థం చేసుకోవడానికి మాకు సహాయపడతాయి (ఉదా. Google Analytics).\n• మార్కెటింగ్ కుకీలు: సంబంధిత కంటెంట్‌ను అందించడానికి మరియు ప్రచారాల ప్రభావాన్ని కొలవడానికి ఉపయోగిస్తారు.\n\nమీరు మీ బ్రౌజర్ సెట్టింగ్‌ల ద్వారా ఎప్పుడైనా కుకీలను నిలిపివేయవచ్చు; అయితే, కొన్ని సైట్ ఫీచర్లు ఆశించిన విధంగా పనిచేయకపోవచ్చు.`,
      },
      {
        title: "6. డేటా భద్రత",
        body: `అనధికార యాక్సెస్, మార్పు, బహిర్గతం లేదా నాశనం నుండి మీ వ్యక్తిగత డేటాను రక్షించడానికి మేము తగిన సాంకేతిక మరియు సంస్థాగత చర్యలను అమలు చేస్తాము. మా వెబ్‌సైట్ అన్ని డేటా ప్రసారాల కోసం HTTPS ఎన్‌క్రిప్షన్‌ను ఉపయోగిస్తుంది. ఈ చర్యలు ఉన్నప్పటికీ, ఏ ఇంటర్నెట్ ప్రసారమూ పూర్తిగా సురక్షితం కాదు మరియు మేము సంపూర్ణ భద్రతకు హామీ ఇవ్వలేము.`,
      },
      {
        title: "7. మీ హక్కులు",
        body: `మీకు క్రింది హక్కులు ఉన్నాయి:\n• మీ గురించి మేము కలిగి ఉన్న వ్యక్తిగత డేటాను యాక్సెస్ చేయడం.\n• తప్పు లేదా అసంపూర్ణ డేటాను సవరించాలని అభ్యర్థించడం.\n• చట్టపరమైన నిలుపుదల బాధ్యతలకు లోబడి, మీ వ్యక్తిగత డేటాను తొలగించాలని అభ్యర్థించడం.\n• మార్కెటింగ్ కమ్యూనికేషన్‌ల కోసం సమ్మతిని ఎప్పుడైనా ఉపసంహరించుకోవడం.\n• సంబంధిత డేటా రక్షణ అధికార సంస్థకు ఫిర్యాదు చేయడం.\n\nఈ హక్కులలో దేనినైనా ఉపయోగించుకోవడానికి, software-admin@autonxt.in ని సంప్రదించండి లేదా +91 9067404606 కి కాల్ చేయండి.`,
      },
      {
        title: "8. మూడవ పక్ష లింకులు",
        body: `మా వెబ్‌సైట్‌లో లింక్డ్‌ఇన్, యూట్యూబ్ మరియు ఇతర భాగస్వామ్య ప్లాట్‌ఫారమ్‌లతో సహా మూడవ పక్ష వెబ్‌సైట్‌లకు లింకులు ఉండవచ్చు. ఈ సైట్ల గోప్యతా పద్ధతులకు మేము బాధ్యత వహించము మరియు వాటి సంబంధిత గోప్యతా విధానాలను సమీక్షించవలసిందిగా మిమ్మల్ని ప్రోత్సహిస్తాము.`,
      },
      {
        title: "9. ఈ విధానంలో మార్పులు",
        body: `ఈ గోప్యతా విధానాన్ని ఎప్పుడైనా నవీకరించే హక్కు ఆటోనెక్స్ట్ ఆటోమేషన్ ప్రైవేట్ లిమిటెడ్‌కు ఉంది. ఏవైనా మార్పులు నవీకరించబడిన అమలు తేదీతో ఈ పేజీలో ప్రచురించబడతాయి. ఈ విధానాన్ని క్రమానుగతంగా సమీక్షించవలసిందిగా మేము మిమ్మల్ని ప్రోత్సహిస్తాము.`,
      },
      {
        title: "10. మమ్మల్ని సంప్రదించండి",
        body: `ఈ గోప్యతా విధానానికి సంబంధించిన ఏవైనా ప్రశ్నలు, ఆందోళనలు లేదా అభ్యర్థనల కోసం, దయచేసి సంప్రదించండి:\n\nఆటోనెక్స్ట్ ఆటోమేషన్ ప్రైవేట్ లిమిటెడ్.\n704 & 705, అమ్ఫోటెక్ ఐటీ పార్క్, రోడ్ 8, వాగ్లే ఎస్టేట్ రోడ్,\nపద్వాల్ నగర్, థానే వెస్ట్, థానే, మహారాష్ట్ర 400604\nఫోన్: +91 9067404606\nఈమెయిల్: software-admin@autonxt.in`,
      },
    ]
  },
  // Terms Page
  termsPage: {
    metaTitle: "నిబంధనలు మరియు షరతులు | AutoNxt",
    metaDescription: "AutoNxt Automation నిబంధనలు మరియు ఉపయోగ నిబంధనలు.",
    texts: {
      legalBadge: "చట్టపరమైనది",
      termsTitle: "నిబంధనలు & షరతులు",
      effectiveDate: "అమలులోకి వచ్చిన తేదీ: 1 జనవరి 2025 · ఆటోనెక్స్ట్ ఆటోమేషన్ ప్రైవేట్ లిమిటెడ్.",
      termsIntro: "ఆటోనెక్స్ట్ వెబ్‌సైట్‌ను ఉపయోగించే ముందు దయచేసి ఈ నిబంధనలు మరియు షరతులను జాగ్రత్తగా చదవండి. ఈ సైట్‌ను యాక్సెస్ చేయడం ద్వారా, మీరు ఈ నిబంధనలను చదివారని, అర్థం చేసుకున్నారని మరియు వాటికి కట్టుబడి ఉండటానికి అంగీకరిస్తున్నారని అంగీకరిస్తున్నారు.",
      backToHome: "హోమ్‌కు తిరిగి వెళ్ళండి",
      copyright: "© 2025 ఆటోనెక్స్ట్ ఆటోమేషన్ ప్రైవేట్ లిమిటెడ్. అన్ని హక్కులు ప్రత్యేకించబడినవి.",
    },
    sections: [
      {
        title: "1. నిబంధనల అంగీకారం",
        body: `ఆటోనెక్స్ట్ వెబ్‌సైట్ (autonxt.in) మరియు ఏదైనా అనుబంధ సేవలను యాక్సెస్ చేయడం లేదా ఉపయోగించడం ద్వారా, మీరు ఈ నిబంధనలు మరియు షరతులకు కట్టుబడి ఉండటానికి అంగీకరిస్తున్నారు. మీరు ఈ నిబంధనలకు అంగీకరించకపోతే, మీరు మా వెబ్‌సైట్ లేదా సేవలను ఉపయోగించకూడదు. ఈ నిబంధనలు ఆటోనెక్స్ట్ ఆటోమేషన్ ప్రైవేట్ లిమిటెడ్ యొక్క సందర్శకులు, వినియోగదారులు మరియు కస్టమర్లందరికీ వర్తిస్తాయి.`,
      },
      {
        title: "2. ఆటోనెక్స్ట్ గురించి",
        body: `ఆటోనెక్స్ట్ ఆటోమేషన్ ప్రైవేట్ లిమిటెడ్ అనేది కంపెనీల చట్టం, 2013 ప్రకారం విలీనం చేయబడిన సంస్థ, దీని నమోదిత కార్యాలయం ఇక్కడ ఉంది:\n\n704 & 705, అమ్ఫోటెక్ ఐటీ పార్క్, రోడ్ 8, వాగ్లే ఎస్టేట్ రోడ్,\nపద్వాల్ నగర్, థానే వెస్ట్, థానే, మహారాష్ట్ర 400604\nCIN: [U29301MH2016PTC XXXXXX]\nGSTIN: [27XXXXX]`,
      },
      {
        title: "3. వెబ్‌సైట్ ఉపయోగం",
        body: `మీరు ఈ వెబ్‌సైట్‌ను చట్టబద్ధమైన ప్రయోజనాల కోసం మాత్రమే మరియు ఇతరుల హక్కులను ఉల్లంఘించని రీతిలో ఉపయోగించడానికి అంగీకరిస్తున్నారు. మీరు ఈ క్రింది పనులను చేయకూడదు:\n• వర్తించే స్థానిక, జాతీయ లేదా అంతర్జాతీయ చట్టం లేదా నిబంధనలను ఉల్లంఘించే విధంగా సైట్‌ను ఉపయోగించడం.\n• అయాచిత ప్రచార సామగ్రి లేదా స్పామ్‌ను పంపడం.\n• వెబ్‌సైట్ లేదా దాని అనుబంధ వ్యవస్థలలోని ఏ భాగానికైనా అనధికార యాక్సెస్ పొందడానికి ప్రయత్నించడం.\n• మా ఎక్స్‌ప్రెస్ లిఖితపూర్వక సమ్మతి లేకుండా ఈ వెబ్‌సైట్‌లోని ఏ భాగాన్నైనా పునరుత్పత్తి చేయడం, నకిలీ చేయడం లేదా తిరిగి విక్రయించడం.\n\nఈ నిబంధనలను ఉల్లంఘించే ఏ వినియోగదారునికైనా వెబ్‌సైట్ యాక్సెస్‌ను తాత్కాలికంగా నిలిపివేయడానికి లేదా పరిమితం చేయడానికి ఆటోనెక్స్ట్ హక్కును కలిగి ఉంది.`,
      },
      {
        title: "4. ఉత్పత్తి సమాచారం మరియు ధర",
        body: `ఈ వెబ్‌సైట్‌లో చూపబడిన అన్ని ఉత్పత్తి వివరాలు, పనితీరు గణాంకాలు మరియు ధరలు సూచనాత్మకమైనవి మరియు నోటీసు లేకుండా మారవచ్చు. తుది ధర, డెలివరీ సమయాలు మరియు వారంటీ నిబంధనలు ఆర్డర్ సమయంలో లిఖితపూర్వకంగా ధృవీకరించబడతాయి. ఏదైనా ఉత్పత్తి, ఆఫర్ లేదా స్పెసిఫికేషన్‌ను ఎప్పుడైనా ఉపసంహరించుకునే లేదా సవరించే హక్కు ఆటోనెక్స్ట్‌కు ఉంది.`,
      },
      {
        title: "5. డెమో బుకింగ్‌లు మరియు విచారణలు",
        body: `ఈ వెబ్‌సైట్ ద్వారా డెమో బుకింగ్ లేదా ఉత్పత్తి విచారణను సమర్పించడం వల్ల అది బైండింగ్ ఒప్పందం లేదా కొనుగోలు ఆర్డర్‌గా మారదు. అన్ని బుకింగ్‌లు లభ్యత మరియు ఆటోనెక్స్ట్ ప్రతినిధి ధృవీకరణకు లోబడి ఉంటాయి. తన విచక్షణ మేరకు ఏ బుకింగ్ అభ్యర్థననైనా తిరస్కరించే హక్కు ఆటోనెక్స్ట్‌కు ఉంది.`,
      },
      {
        title: "6. మేధో సంపత్తి",
        body: `టెక్స్ట్, ఇమేజ్‌లు, గ్రాఫిక్స్, లోగోలు, వీడియోలు మరియు సాఫ్ట్‌వేర్‌లతో సహా ఈ వెబ్‌సైట్‌లోని అన్ని కంటెంట్ ఆటోనెక్స్ట్ ఆటోమేషన్ ప్రైవేట్ లిమిటెడ్ లేదా దాని లైసెన్సర్‌ల మేధో సంపత్తి మరియు వర్తించే భారతీయ మరియు అంతర్జాతీయ మేధో సంపత్తి చట్టాల ద్వారా రక్షించబడుతుంది. ఆటోనెక్స్ట్ నుండి ముందస్తు లిఖితపూర్వక అనుమతి లేకుండా మీరు ఏ కంటెంట్‌ను ఉపయోగించకూడదు, పునరుత్పత్తి చేయకూడదు లేదా పంపిణీ చేయకూడదు.`,
      },
      {
        title: "7. నిరాకరణలు మరియు బాధ్యత పరిమితి",
        body: `ఈ వెబ్‌సైట్ మరియు దాని కంటెంట్ ఎలాంటి వారెంటీలు లేకుండా యథాతథంగా అందించబడ్డాయి. వెబ్‌సైట్ లోపాలు లేకుండా ఉంటుందని, అంతరాయం కలగదని లేదా వైరస్‌లు లేదా ఇతర హానికరమైన భాగాలు లేకుండా ఉంటుందని ఆటోనెక్స్ట్ హామీ ఇవ్వదు.\n\nవర్తించే చట్టం ప్రకారం గరిష్టంగా అనుమతించబడిన మేరకు, ఈ వెబ్‌సైట్ లేదా మా ఉత్పత్తులు మరియు సేవల ఉపయోగం వల్ల ఉత్పన్నమయ్యే ఏ విధమైన పరోక్ష, యాదృచ్ఛిక, ప్రత్యేక లేదా పరిణామాత్మక నష్టాలకు ఆటోనెక్స్ట్ బాధ్యత వహించదు.`,
      },
      {
        title: "8. మూడవ పక్ష లింకులు",
        body: `ఈ వెబ్‌సైట్‌లో మూడవ పక్షాల ద్వారా నిర్వహించబడే బాహ్య వెబ్‌సైట్‌ల లింకులు ఉండవచ్చు. ఈ లింకులు సౌకర్యం కోసం మాత్రమే అందించబడ్డాయి. ఆటోనెక్స్ట్ ఏ లింక్డ్ మూడవ పక్ష వెబ్‌సైట్‌ల కంటెంట్ లేదా పద్ధతులను ఆమోదించదు మరియు వాటికి బాధ్యత వహించదు.`,
      },
      {
        title: "9. వర్తించే చట్టం మరియు అధికార పరిధి",
        body: `ఈ నిబంధనలు మరియు షరతులు భారతదేశ చట్టాల ప్రకారం నిర్వహించబడతాయి మరియు వివరించబడతాయి. ఈ నిబంధనల వల్ల ఉత్పన్నమయ్యే ఏవైనా వివాదాలు మహారాష్ట్రలోని థానే కోర్టుల ప్రత్యేక అధికార పరిధికి లోబడి ఉంటాయి.`,
      },
      {
        title: "10. సవరణలు",
        body: `ఈ నిబంధనలు మరియు షరతులను ఎప్పుడైనా సవరించే హక్కు ఆటోనెక్స్ట్‌కు ఉంది. నవీకరించబడిన నిబంధనలు సవరించిన అమలు తేదీతో ఈ పేజీలో పోస్ట్ చేయబడతాయి. ఏవైనా మార్పుల తర్వాత వెబ్‌సైట్‌ను ఉపయోగించడం కొనసాగించడం అంటే మీరు సవరించిన నిబంధనలను అంగీకరించినట్లే.`,
      },
      {
        title: "11. సంప్రదించండి",
        body: `ఈ నిబంధనలు మరియు షరతులకు సంబంధించి ఏవైనా ప్రశ్నల కోసం:\n\nఆటోనెక్స్ట్ ఆటోమేషన్ ప్రైవేట్ లిమిటెడ్.\n704 & 705, అమ్ఫోటెక్ ఐటీ పార్క్, రోడ్ 8, వాగ్లే ఎస్టేట్ రోడ్,\nపద్వాల్ నగర్, థానే వెస్ట్, థానే, మహారాష్ట్ర 400604\nఫోన్: +91 9067404606\nఈమెయిల్: sales@autonxt.in`,
      },
    ]
  },
  accountDeletionPage: {
    metaTitle: "ఖాతా & డేటా తొలగింపు — AUTONXT-Attendance | AutoNxt",
    texts: {
      legalBadge: "వినియోగదారు డేటా",
      pageTitle: "ఖాతా & డేటా తొలగింపు — AUTONXT-Attendance",
      pageSubtitle: "మీ AUTONXT-Attendance యాప్ ఖాతా మరియు సంబంధిత వ్యక్తిగత డేటాను తొలగించమని అభ్యర్థించండి.",
      metaDescription:
        "AUTONXT-Attendance (com.autonxt.attendance.app2) ఖాతాను తొలగించండి. AutoNxt Automation Pvt. Ltd. (autonxtdeveloper) అధికారిక ఖాతా తొలగింపు పేజీ.",
      effectiveDate: "అమలు తేదీ: 18 జూన్ 2025 · ఆటోనెక్స్ట్ ఆటోమేషన్ ప్రైవేట్ లిమిటెడ్.",
      pageIntro:
        'ఆటోనెక్స్ట్ ఆటోమేషన్ ప్రైవేట్ లిమిటెడ్. ("ఆటోనెక్స్ట్"), AUTONXT-Attendance మొబైల్ యాప్ (ప్యాకేజీ: com.autonxt.attendance.app2, Google Play డెవలపర్: autonxtdeveloper) యొక్క డెవలపర్, యాప్ వినియోగదారులు తమ ఖాతా మరియు సంబంధిత వ్యక్తిగత డేటాను తొలగించాలనుకునే వారికి ఈ పేజీని అందిస్తుంది.',
      requestTitle: "AUTONXT-Attendance ఖాతా తొలగింపును ఎలా అభ్యర్థించాలి",
      requestButton: "తొలగింపు అభ్యర్థన ఈమెయిల్ చేయండి",
      requestMailto:
        "mailto:software-admin@autonxt.in?subject=AUTONXT-Attendance%20-%20Account%20Deletion%20Request&body=Please%20delete%20my%20AUTONXT-Attendance%20app%20account%20and%20associated%20data.%0A%0AApp%3A%20AUTONXT-Attendance%20(com.autonxt.attendance.app2)%0ARegistered%20email%20/%20phone%3A%20%0AEmployee%20ID%20(if%20any)%3A%20%0AAccount%20username%20(if%20any)%3A%20%0AReason%20(optional)%3A%20",
      processingNote:
        "మేము సాధారణంగా ధృవీకరించిన తొలగింపు అభ్యర్థనలను 30 రోజులలోపు ప్రాసెస్ చేస్తాము. మీ ఖాతా మరియు అర్హత గల డేటా తొలగించబడిన తర్వాత మీకు నిర్ధారణ ఈమెయిల్ వస్తుంది.",
      deletedTitle: "తొలగించబడే డేటా",
      retainedTitle: "ఉంచబడే డేటా",
      privacyLinkTitle: "గోప్యతా విధానం",
      privacyLinkDesc: "మేము డేటాను ఎలా సేకరిస్తాము మరియు ఉపయోగిస్తాము అనే దాని గురించి మా పూర్తి గోప్యతా విధానాన్ని చదవండి.",
      privacyLinkButton: "గోప్యతా విధానం చూడండి",
      backToHome: "హోమ్‌కు తిరిగి వెళ్ళండి",
      copyright: "© 2025 ఆటోనెక్స్ట్ ఆటోమేషన్ ప్రై. Ltd. All rights reserved.",
    },
    steps: [
      "మీ AutoNxt యాప్ ఖాతాకు లింక్ చేయబడిన ఈమెయిల్ చిరunaal నుండి software-admin@autonxt.in కు ఈమెయిల్ పంపండి.",
      "Subject line: AutoNxt App - Account Deletion Request ఉపయోగించండి.",
      "మీ నమోదైన ఈమెయిల్ చిరunaal, phone number మరియు account username (అ applicable) చేర్చండి.",
      "మా team మీ request verify చేసి account మరియు associated personal data delete చేస్తుంది.",
      "తొలగింపు పూర్తైన తర్వాత మీకు confirmation email వస్తుంది.",
    ],
    deletedItems: [
      "మీ app account profile (name, email, phone number, login credentials)",
      "User preferences మరియు app settings",
      "మీ accountకు linked saved bookings, demo requests, enquiry history",
      "App notifications కోసం push notification tokens మరియు device identifiers",
      "మీ accountకు associated chat/support conversation history",
      "మీ user profileకు solely linked fleet/tractor monitoring data (where applicable)",
    ],
    retainedItems: [
      "Legal, tax, accounting compliance కోసం transaction, invoice, warranty records (typically up to 7 years)",
      "మిమ్మల్ని personally identify చేయలేని anonymised/aggregated analytics data",
      "Indian law లేదా valid court/regulatory order under legally retain చేయాల్సిన records",
      "Backup copies permanently remove కాకముందు deletion తర్వాత 90 days వరకు persist అవ్వచ్చు",
    ],
    sections: [
      {
        title: "In-app deletion (available అయితే)",
        body: "మీ AutoNxt app versionలో in-app account deletion option ఉంటే:\n\nApp → Profile / Settings → Account → Delete Account\n\nఈ option కనిపించకపోతే, పై email process ఉపయోగించండి.",
      },
      {
        title: "Identity verification",
        body: "Account protect చేయడానికి, deletion request process చేయడానికి ముందు registered email/phone ownership confirm చేయమని అడగవచ్చు.",
      },
      {
        title: "Processing timeline",
        body: "Verified account deletion requests 30 daysలో process అవుతాయి. Account immediately deactivate అవ్వవచ్చు, complete removal backups/systems నుండి 90 days పట్టవచ్చు.",
      },
      {
        title: "Contact us",
        body: "Account deletion requests లేదా personal data questions:\n\nAutoNxt Automation Pvt. Ltd.\n704 & 705, Amfotech IT Park, Rd 8, Wagle Estate Rd,\nPadwal Nagar, Thane West, Thane, Maharashtra 400604\nPhone: +91 9067404606\nEmail: software-admin@autonxt.in",
      },
    ],
  },
  // NotFound Page
  notFoundPage: {
    title: "404 పేజీ కనుగొనబడలేదు",
    desc: "మీరు రూటర్‌కు పేజీని జోడించడం మర్చిపోయారా?",
  },
  attachmentDetailPage: {
    availableNow: "ఇప్పుడు అందుబాటులో ఉంది",
    productNotFound: "ఉత్పత్తి కనుగొనబడలేదు",
    backToProducts: "ఉత్పత్తులకు తిరిగి వెళ్ళండి",
    interactiveModel: "ఇంటరాక్టివ్ మోడల్",
    preview3D: "3D ప్రివ్యూ",
    loadingModel: "3D మోడల్ లోడ్ అవుతోంది...",
    specifications: "స్పెసిఫికేషన్లు",
    technicalDetails: "సాంకేతిక వివరాలు",
    whyChoose: "ఈ ఉత్పత్తిని ఎందుకు ఎంచుకోవాలి",
    features: "ఫీచర్లు",
    quoteBtn: "ధర అభ్యర్థించండి",
    bookBtn: "డెమో బుక్ చేయండి",
    stats: {
      support: "మద్దతు",
      supportVal: "24/7",
      availability: "లభ్యత",
      availabilityVal: "భారతదేశం అంతటా",
      response: "ప్రతిస్పందన",
      responseVal: "< 24గం"
    },
    attachments: {
      bucket: {
        name: "18 అడుగుల గ్రాబర్ బకెట్",
        type: "భారీ డ్యూటీ పరికరం",
        badge: "హెవీ డ్యూటీ",
        tagline: "ఏ భూభాగంలోనైనా గరిష్ట తవ్వకం శక్తి",
        desc: "సమర్థవంతమైన మెటీరియల్ హ్యాండ్లింగ్ మరియు తవ్వకం పనుల కోసం రూపొందించబడిన హెవీ-డ్యూటీ 18 అడుగుల గ్రాబర్ బకెట్ అటాచ్‌మెంట్. డిమాండ్ ఉన్న నిర్మాణం మరియు వ్యవసాయ వాతావరణాలలో గరిష్ట మన్నిక మరియు పనితీరు కోసం ప్రీమియం మెటీరియల్స్ మరియు అధునాతన ఇంజనీరింగ్‌తో నిర్మించబడింది.",
        specs: {
          width: "18 అడుగులు",
          capacity: "0.8m³",
          material: "Hardox 450",
          weight: "480 కిలోలు",
          power: "45 kW",
          battery: "50 kWh",
          runtime: "6-8 గంటలు",
          charging: "4-5 గంటలు",
          widthLabel: "వెడల్పు",
          capacityLabel: "సామర్థ్యం",
          materialLabel: "మెటీరియల్",
          weightLabel: "బరువు",
          powerLabel: "శక్తి",
          batteryLabel: "బ్యాటరీ",
          runtimeLabel: "రన్ టైమ్",
          chargingLabel: "ఛార్జింగ్"
        },
        features: [
          { title: "హార్డాక్స్ స్టీల్", desc: "కఠినమైన వాతావరణంలో దీర్ఘకాలిక మన్నిక కోసం తీవ్రమైన దుస్తులు నిరోధకత." },
          { title: "యూనివర్సల్ హిచ్", desc: "అన్ని ఆటోనెక్స్ట్ ట్రాక్టర్ ప్లాట్‌ఫారమ్‌లతో అనుకూలమైనది." },
          { title: "త్వరిత విడుదల పళ్ళు", desc: "సులభమైన నిర్వహణ కోసం మార్చుకోగలిగిన పళ్ల వ్యవస్థ." }
        ],
        highlights: [
          "భారీ డ్యూటీ డిజైన్",
          "సున్నా ఉద్గారాల అనుకూలత",
          "3 పాయింట్ హిచ్",
          "పారిశ్రామిక గ్రేడ్ స్టీల్",
          "వేగవంతమైన నిర్వహణ",
          "భారత్ కోసం తయారు చేయబడింది"
        ]
      },
      catcher: {
        name: "18 అడుగుల క్యాచర్",
        type: "ఖచ్చితమైన పరికరం",
        badge: "ఖచ్చితత్వం",
        tagline: "సమర్థవంతమైన మెటీరియల్ సేకరణและ పంట కోత",
        desc: "సమర్థవంతమైన మెటీరియల్ సేకరణ మరియు నిర్వహణ పనుల కోసం ఖచ్చితంగా ఇంజనీర్ చేయబడిన 18 అడుగుల క్యాచర్ అటాచ్‌మెంట్. వ్యవసాయ మరియు పారిశ్రామిక అనువర్తనాలలో సరైన పనితీరు కోసం అధునాతన హైడ్రాలిక్ నియంత్రణలు మరియు మన్నికైన నిర్మాణాన్ని కలిగి ఉంది. మెరుగైన ఖచ్చితత్వం మరియు విశ్వసనీయతతో పంట కోత, మెటీరియల్ సార్టింగ్ మరియు ప్రత్యేక సేకరణ పనులకు అనువైనది. డిమాండ్ ఉన్న వాతావరణంలో స్థిరమైన పనితీరును అందించడానికి ప్రీమియం మెటీరియల్స్ మరియు అత్యాధునిక ఇంజనీరింగ్‌తో నిర్మించబడింది.",
        specs: {
          width: "18 అడుగులు",
          capacity: "0.75m³",
          material: "Hardox 400",
          weight: "450 కిలోలు",
          power: "40 kW",
          battery: "45 kWh",
          runtime: "5-7 గంటలు",
          charging: "3-4 గంటలు",
          widthLabel: "వెడల్పు",
          capacityLabel: "సామర్థ్యం",
          materialLabel: "మెటీరియల్",
          weightLabel: "బరువు",
          powerLabel: "శక్తి",
          batteryLabel: "బ్యాటరీ",
          runtimeLabel: "రన్ టైమ్",
          chargingLabel: "ఛార్జింగ్"
        },
        features: [
          { title: "ఖచ్చితమైన ఇంజనీరింగ్", desc: "ఖచ్చితమైన మెటీరియల్ సేకరణ మరియు కనీస వృధా కోసం ఆప్టిమైజ్ చేయబడిన డిజైన్." },
          { title: "యూనివర్సల్ హిచ్", desc: "అన్ని ఆటోనెక్స్ట్ ట్రాక్టర్ ప్లాట్‌ఫారమ్‌లతో అనుకూలమైనది." },
          { title: "సులభమైన నిర్వహణ", desc: "త్వరిత సర్వీసింగ్ కోసం సరళీకృత నిర్వహణ డిజైన్." }
        ],
        highlights: [
          "ఖచ్చితమైన డిజైన్",
          "సున్నా ఉద్గారాల అనుకూలత",
          "3 పాయింట్ హిచ్",
          "ఆప్టిమైజ్ చేయబడిన సామర్థ్యం",
          "సులభమైన నిర్వహణ",
          "భారత్ కోసం తయారు చేయబడింది"
        ]
      },
      loader: {
        name: "18 అడుగుల లోడర్ బకెట్",
        type: "గరిష్ట లోడ్ పరికరం",
        badge: "గరిష్ట లోడ్",
        tagline: "లోడింగ్ మరియు మెటీరియల్ రవాణాలో గరిష్ట సామర్థ్యం",
        desc: "లోడింగ్ మరియు మెటీరియల్ రవాణా పనులలో గరిష్ట సామర్థ్యం కోసం రూపొందించబడిన హెవీ-డ్యూటీ 18 అడుగుల లోడర్ బకెట్. అత్యంత డిమాండ్ ఉన్న నిర్మాణం, మైనింగ్ మరియు వ్యవసాయ పనులను నిర్వహించడానికి అత్యుత్తమ బలం కలిగిన మెటీరియల్స్ మరియు అధునాతన హైడ్రాలిక్ సిస్టమ్‌లతో నిర్మించబడింది. మెరుగైన మెటీరియల్ నిలుపుదల మరియు సమర్థవంతమైన లోడింగ్ సైకిల్స్ కోసం ఆప్టిమైజ్ చేయబడిన బకెట్ జ్యామితిని కలిగి ఉంది. గరిష్ట పనితీరు మరియు కార్యాచరణ విశ్వసనీయతను కొనసాగిస్తూ తీవ్రమైన పని పరిస్థితులను తట్టుకునేలా రూపొందించబడింది.",
        specs: {
          width: "18 అడుగులు",
          capacity: "0.9m³",
          material: "Hardox 500",
          weight: "520 కిలోలు",
          power: "50 kW",
          battery: "55 kWh",
          runtime: "7-9 గంటలు",
          charging: "4-6 గంటలు",
          widthLabel: "వెడల్పు",
          capacityLabel: "సామర్థ్యం",
          materialLabel: "మెటీరియల్",
          weightLabel: "బరువు",
          powerLabel: "శక్తి",
          batteryLabel: "బ్యాటరీ",
          runtimeLabel: "రన్ టైమ్",
          chargingLabel: "ఛార్జింగ్"
        },
        features: [
          { title: "గరిష్ట సామర్థ్యం", desc: "భారీ కార్యకలాపాలలో గరిష్ట లోడ్ సామర్థ్యం మరియు మన్నిక కోసం ఇంజనీర్ చేయబడింది." },
          { title: "యూనివర్సల్ హిచ్", desc: "అన్ని ఆటోనెక్స్ట్ ట్రాక్టర్ ప్లాట్‌ఫారమ్‌లతో అనుకూలమైనది." },
          { title: "బలపరచబడిన నిర్మాణం", desc: "గరిష్ట లోడ్‌లను సురక్షితంగా నిర్వహించడానికి అదనపు ఉపబలం." }
        ],
        highlights: [
          "గరిష్ట సామర్థ్యం",
          "సున్నా ఉద్గారాల అనుకూలత",
          "3 పాయింట్ హిచ్",
          "బలపరచబడిన స్టీల్",
          "భారీ డ్యూటీ డిజైన్",
          "భారత్ కోసం తయారు చేయబడింది"
        ]
      }
    }
  },
  aboutPage: {
    aboutAutoNxt: "ఆటోనెక్స్ట్ గురించి",
    foundedLabel: "స్థాపించబడింది",
    headquarteredLabel: "ప్రధాన కార్యాలయం",
    teamSizeLabel: "బృందం పరిమాణం",
    foundedInMumbai: "ముంబైలో స్థాపించబడింది",
    connectLinkedIn: "లింక్డ్‌ఇన్‌లో కనెక్ట్ అవ్వండి",
    ourJourney: "మా ప్రయాణం",
    fromConcept: "భావన నుండి మార్కెట్ లీడర్ వరకు.",
    team: [
      { name: "కౌస్తుభ్ ధోండే", role: "చీఫ్ ఎగ్జిక్యూటివ్ ఆఫీసర్", bio: "వినూత్న ఎలక్ట్రిక్ వాహన పరిష్కారాలతో వ్యవసాయంలో విప్లవాత్మక మార్పులు తీసుకురావాలనే ఆటోనెక్స్ట్ లక్ష్యాన్ని నడిపిస్తున్న దూరదృష్టి గల నాయకుడు." },

      { name: "పంకజ్ గోయల్", role: "సహ-వ్యవస్థాపకుడు & COO", bio: "రోజువారీ కార్యకలాపాలు మరియు భాగస్వామ్యాలను పర్యవేక్షిస్తూ, అతుకులు లేని అమలు మరియు వృద్ధిని నిర్ధారిస్తున్న కార్యాచరణ వ్యూహకర్త." },
      { name: "గౌరవ్ బోర్కర్", role: "చీఫ్ ఫైనాన్షియల్ ఆఫీసర్", bio: "ఆర్థిక వ్యూహం, నిధుల సేకరణ మరియు కార్పొరేట్ పాలనను నడిపిస్తున్న అనుభవజ్ఞుడైన ఫైనాన్స్ నిపుణుడు." },
      { name: "అమిత్ కుమార్ శివహరే", role: "హెడ్ – అకౌంట్స్", bio: "కార్పొరేట్ అకౌంటింగ్, టాక్సేషన్ మరియు చట్టబద్ధమైన నిబంధనల పాటించడంలో 16+ సంవత్సరాల అనుభవం కలిగిన సీనియర్ లీడర్." },
      { name: "హరి కిషన్", role: "ప్లాంట్ హెడ్", bio: "ఉత్పత్తి చేయబడిన ప్రతి ట్రాక్టర్‌లో నాణ్యత మరియు సామర్థ్యాన్ని నిర్ధారిస్తూ, ప్లాంట్ కార్యకలాపాలను పర్యవేక్షిస్తారు." },

      { name: "సుదీప్తో దేబ్", role: "లీడ్ పవర్ ట్రైన్ ఇంజనీర్", bio: "పవర్ ఎలక్ట్రానిక్స్ నిపుణుడు, మా ట్రాక్టర్లకు శక్తినిచ్చే విద్యుత్ వ్యవస్థల రూపకల్పన మరియు ఆప్టిమైజేషన్ బాధ్యత వహిస్తారు." },

      { name: "వంశీ అట్లూరి", role: "లీడ్ మెకానికల్ డిజైన్ ఇంజనీర్", bio: "మెకానికల్ డిజైన్ ఆవిష్కర్త, విభిన్న వ్యవసాయ అవసరాల కోసం బలమైన మరియు సమర్థవంతమైన ట్రాక్టర్ నిర్మాణాలను రూపొందిస్తారు." },

      { name: "డా. ధర్మతేజ అడపా", role: "లీడ్ రోబోటిక్స్ ఇంజనీర్", bio: "అతుకులు లేని మరియు విశ్వసనీయమైన ట్రాక్టర్ పనితీరు కోసం స్మార్ట్ టెక్నాలజీలను అనుసంధానించడంపై దృష్టి సారించిన ఆటోమేషన్ నిపుణుడు." },

      { name: "తేజేష్ మదిరెడ్డి", role: "లీడ్ ఎంబెడెడ్ ఇంజనీర్", bio: "విశ్వసనీయమైన మరియు సమర్థవంతమైన హార్డ్‌వేర్-సాఫ్ట్‌వేర్ అనుసంధానాన్ని నిర్ధారిస్తూ, ఎంబెడెడ్ సిస్టమ్స్ అభివృద్ధికి నాయకత్వం వహిస్తారు." },

      { name: "అస్వంత్ ములుపురి", role: "రోబోటిక్స్ & ఆటోమేషన్ ఇంజనీర్", bio: "ఆటోమేషన్ నిపుణుడు, స్వయంప్రతిపత్త ట్రాక్టర్ ఆపరేషన్ కోసం అధునాతన నియంత్రణ వ్యవస్థలను అభివృద్ధి చేస్తారు." },

      { name: "అజింక్యా డెల్వి", role: "పవర్ ట్రైన్ ఇంజనీర్", bio: "పనితీరు మరియు సామర్థ్యాన్ని ఆప్టిమైజ్ చేస్తూ, పవర్ ట్రైన్ సిస్టమ్స్‌పై పని చేస్తారు." },

      { name: "ఖుష్‌ప్రీత్ సింగ్", role: "టెస్టింగ్ & వాలిడేషన్ ఇంజనీర్", bio: "మా ఉత్పత్తుల యొక్క విశ్వసనీయత మరియు భద్రతకు హామీ ఇస్తూ, కఠినమైన పరీక్షలు మరియు ధృవీకరణ బాధ్యత వహిస్తారు." },

      { name: "స్వప్నేష్ జహాగీర్దార్", role: "బిజినెస్ డెవలప్‌మెంట్ మేనేజర్", bio: "కంపెనీ విస్తరణను వేగవంతం చేయడానికి కొత్త అవకాశాలను గుర్తించడం మరియు సంబంధాలను పెంపొందించడంపై దృష్టి సారించారు." }
    ],

    advisors: [
      {
        name: "ఐ.వి. రావు",
        role: "సీనియర్ సలహాదారు",
        bio: "కలిసి, మేము అర్థవంతమైన డిజైన్లు మరియు శాశ్వతమైన ప్రాముఖ్యత ద్వారా మెరుగైన రేపటి కోసం మనల్ని మనం సవాలు చేసుకుంటాము."
      },

      {
        name: "ఆశిష్ మెహతా",
        role: "ఆర్థిక సలహాదారు",
        bio: "సమకాలీన డిజైన్ మరియు అత్యుత్తమంగా రూపొందించబడిన ఉత్పత్తులు ప్రతి ఒక్కరికీ అందుబాటులో ఉండాలి — అదే మా పనికి ప్రేరణ."
      },

      {
        name: "స్వదీప్ పిల్లారిసెట్టి",
        role: "వ్యూహాత్మక సలహాదారు",
        bio: "మా కలెక్షన్ ఎల్లప్పుడూ అభివృద్ధి చెందుతూ ఉంటుంది మరియు ప్రజలతో అనుసంధానమై ఉంటుంది. మీకు కావలసిన రూపాన్ని ప్రదర్శించడంలో సహాయపడటం మా లక్ష్యం."
      }
    ],
    journey: [
      { year: "2016", title: "స్థాపన", desc: "ఎలక్ట్రిక్ మరియు స్వయంప్రతిపత్త ట్రాక్టర్ల ద్వారా వ్యవసాయం మరియు పారిశ్రామిక కార్యకలాపాలలో విప్లవాత్మక మార్పులు తీసుకురావాలనే విజన్‌తో ముంబైలో కౌస్తుభ్ ధోండే చేత ఆటోనెక్స్ట్ ఆటోమేషన్ ప్రైవేట్ లిమిటెడ్ స్థాపించబడింది." },
      { year: "2018–19", title: "పరిశోధన & ప్రారంభ నమూనాలు", desc: "అధిక-టార్క్ ఎలక్ట్రిక్ పవర్‌ట్రెయిన్‌లు మరియు ఇంటెలిజెంట్ కంట్రోల్ సిస్టమ్స్‌పై విస్తృతమైన R&D. డీజిల్‌ను ఎలక్ట్రిక్ టెక్నాలజీతో భర్తీ చేసే సాధ్యతను నిరూపిస్తూ ఆటోనెక్స్ట్ విజయవంతంగా ప్రారంభ నమూనాలను నిర్మించింది మరియు పరీక్షించింది." },
      { year: "2020–21", title: "ఆవిష్కరణ & అభివృద్ధి", desc: "స్మార్ట్ వెహికల్ కంట్రోల్ యూనిట్లు మరియు IoT-ఆధారిత పర్యవేక్షణతో నమూనాలను మెరుగుపరిచింది. ఇంజనీరింగ్ బృందాన్ని విస్తరించింది మరియు భాగాల అభివృద్ధి మరియు పరీక్షల కోసం భాగస్వామ్యాలను బలోపేతం చేసింది." },
      { year: "2022–23", title: "ధృవీకరణ & సర్టిఫికేషన్", desc: "ఎలక్ట్రిక్ ట్రాక్టర్లు కఠినమైన పనితీరు మరియు భద్రతా పరీక్షలకు గురయ్యాయి. iCAT (ఇంటర్నేషనల్ సెంటర్ ఫర్ ఆటోమోటివ్ టెక్నాలజీ) నుండి ధృవీకరణ పత్రాలను పొందింది, 20 HP, 35 HP మరియు 45 HP వేరియంట్‌లను ఖరారు చేసింది." },
      { year: "2024", title: "వాణిజ్య ప్రారంభం", desc: "ఆటోనెక్స్ట్ అధికారికంగా మహారాష్ట్రలోని థానేలో X45H2ని ప్రారంభించింది. జైవంత్ షుగర్స్ లిమిటెడ్‌కు మొదటి యూనిట్ డెలివరీ చేయబడింది — ఎలక్ట్రిక్ ట్రాక్టర్ పర్యావరణ వ్యవస్థలో ఆటోనెక్స్ట్‌ను భారతదేశపు మార్గదర్శకుడిగా నిలిపింది." },
      { year: "2025+", title: "వృద్ధి & విస్తరణ", desc: "వ్యవసాయ మరియు పారిశ్రామిక రంగాలలో ఉత్పాదక సామర్థ్యాలను మరియు కస్టమర్ బేస్‌ను విస్తరిస్తోంది. స్వయంప్రతిపత్త డ్రైవింగ్, స్మార్ట్ కనెక్టివిటీ మరియు తదుపరి తరం బ్యాటరీ వ్యవస్థలను అభివృద్ధి చేస్తోంది." }
    ],
    process: [
      { step: "01", title: "నిర్వచించండి", desc: "స్వీయ-డ్రైవింగ్ ఎలక్ట్రిక్ ట్రాక్టర్ల అవసరాలను నిర్వచించండి — క్షేత్ర పరిశీలనలను మరియు ఇంజనీరింగ్ పరిమితులను సేకరించడం." },
      { step: "02", title: "రూపకల్పన", desc: "3D మోడల్స్ మరియు స్కీమాటిక్స్‌ను సృష్టించండి, మోటార్, బ్యాటరీ మరియు సెన్సార్ల వంటి భాగాలను ఎంచుకోండి మరియు స్వయంప్రతిపత్త డ్రైవింగ్ సిస్టమ్‌ను రూపొందించండి." },
      { step: "03", title: "అభివృద్ధి", desc: "చాసిస్, మోటార్, బ్యాటరీ, సెన్సార్లు మరియు స్వయంప్రతిపత్త డ్రైవింగ్ సిస్టమ్‌తో సహా భౌతిక భాగాలను నిర్మించండి." },
      { step: "04", title: "పరీక్షించండి", desc: "వివిధ పరిస్థితులలో పనితీరును పరీక్షించండి — భారతదేశం వ్యాప్తంగా విభిన్న భూభాగాలు, వాతావరణ పరిస్థితులు మరియు డ్రైవింగ్ దృశ్యాలు." },
      { step: "05", title: "మెరుగుపరచండి", desc: "పరీక్ష ఫలితాల ఆధారంగా, భాగాలను సర్దుబాటు చేయండి, సాఫ్ట్‌వేర్ అల్గారిథమ్‌లను మెరుగుపరచండి లేదా యూజర్ ఇంటర్‌ఫేస్‌లో మార్పులు చేయండి." },
      { step: "06", title: "తయారు చేయండి", desc: "తయారీ ప్రక్రియను ఏర్పాటు చేయండి, భాగాలను సేకరించండి మరియు పెద్ద ఎత్తున పంపిణీ చేయడానికి పంపిణీ నెట్‌వర్క్‌ను అభివృద్ధి చేయండి." }
    ],
    values: [
      { title: "కస్టమర్ ఫస్ట్", desc: "మేము అన్నింటికంటే మా కస్టమర్ల అవసరాలకు మరియు సంతృప్తికి ప్రాధాన్యత ఇస్తాము." },
      { title: "ఆవిష్కరణ", desc: "ఎలక్ట్రిక్ వాహన సాంకేతికతలో నిరంతరం సరిహద్దులను విస్తరించడం." },
      { title: "అత్యుత్తమత", desc: "అత్యధిక నాణ్యత గల ఉత్పత్తులు మరియు సేవలను అందించడానికి కట్టుబడి ఉన్నాము." },
      { title: "స్థిరత్వం", desc: "వ్యవసాయం కోసం పచ్చని భవిష్యత్తును సృష్టించడానికి అంకితమయ్యాము." }
    ]
  },
  galleryPage: {
    galleryPhotos: "ఫోటోలు",
    galleryVideos: "వీడియోలు",
    galleryEvents: "ఈవెంట్‌లు",
    eventHandoverTitle: "అధికారిక ప్రభుత్వ హ్యాండోవర్ వేడుక",
    eventHandoverDesc: "జూన్ 29, 2025 — ప్రభుత్వ అధికారులు, పోలీసు ప్రతినిధులు మరియు మీడియా సమక్షంలో జరిగిన అధికారిక వేడుకలో ఆటోనెక్స్ట్ X45H2 ఎలక్ట్రిక్ ట్రాక్టర్‌ను అందజేసింది. భారతదేశ ప్రజా సంస్థలకు సేవ చేయాలనే ఆటోనెక్స్ట్ ప్రయాణంలో ఇది ఒక మైలురాయి క్షణం.",
    photos: [
      { alt: "వాణిజ్య రవాణా (డిస్పాచ్) కోసం సిద్ధం చేసిన ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్ల మొదటి సరుకు", label: "మొదటి సరుకు డిస్పాచ్", tag: "పొలంలో" },
      { alt: "డెలివరీ కోసం రవాణా ట్రక్కుపై లోడ్ చేసిన ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్లు", label: "డెలివరీ కోసం లోడ్ చేసిన ట్రాక్టర్లు", tag: "పొలంలో" },
      { alt: "రవాణాకు సిద్ధంగా ఉన్న ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్ల సరుకు", label: "రవాణాలో సరుకు", tag: "పొలంలో" },
      { alt: "నాశిక్‌లో కృషితాన్ 2023 ప్రదర్శనలో ప్రదర్శించబడిన ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్", label: "కృషితాన్ 2023 — నాశిక్ షోకేస్", tag: "పొలంలో" },
      { alt: "కృషితాన్ 2023లో ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్ లోడర్ ప్రదర్శన", label: "కృషితాన్ 2023 — లోడర్ డెమో", tag: "పొలంలో" },
      { alt: "వాణిజ్య ట్రైలర్‌తో ఆటోనెక్స్ట్ X45H2", label: "X45H2 — వాణిజ్య రవాణా", tag: "పారిశ్రామిక" }
    ],
    events: [
      { alt: "అధికారులు మరియు మీడియాతో ఆటోనెక్స్ట్ X45H2 ప్రారంభ వేడుక", label: "అధికారిక ప్రారంభ ప్రసంగం — జూన్ 29, 2025", tag: "ఈవెంట్" },
      { alt: "MOU సంతకం వేడుక — ఆటోనెక్స్ట్ ట్రాక్టర్ హ్యాండోవర్", label: "హ్యాండోవర్ వేడుక & MOU సంతకం", tag: "ఈవెంట్" },
      { alt: "ఆటోనెక్స్ట్ X45H2 ఎలక్ట్రిక్ ట్రాక్టర్‌ను ఆశీర్వదిస్తున్న అధికారులు", label: "X45H2 ప్రారంభోత్సవ వేడుక", tag: "ఈవెంట్" },
      { alt: "ఆటోనెక్స్ట్ X45H2 చుట్టూ గుమిగూడిన ప్రముఖులు మరియు బృందం", label: "X45H2 — అధికారిక ఆశీర్వాదం", tag: "ఈవెంట్" },
      { alt: "వేడుకలో అతిథుల మధ్య ఉన్న ఆటోనెక్స్ట్ X45H2 ట్రాక్టర్", label: "X45H2 — ఫ్లాగ్-ఆఫ్ వేడుక", tag: "ఈవెంట్" },
      { alt: "ఈవెంట్‌లో త్రివర్ణ బెలూన్ ఆర్చ్ మరియు X45H2 ప్రదర్శన", label: "త్రివర్ణ ప్రారంభ వేదిక — జూన్ 29, 2025", tag: "ఈవెంట్" },
      { alt: "ప్రారంభ ఈవెంట్‌లో ఆటోనెక్స్ట్ X45H2 ఎలక్ట్రిక్ ట్రాక్టర్ క్లోజప్", label: "ఆటోనెక్స్ట్ X45H2 — దగ్గరగా", tag: "ఉత్పత్తి" }
    ],
    videos: [
      { title: "ఆటోనెక్స్ట్ X45H2 ఎలక్ట్రిక్ ట్రాక్టర్ — ఉత్పత్తి వివరణ (ఇంగ్లీష్)", desc: "ఆటోనెక్స్ట్ యొక్క ప్రధాన 45HP ఎలక్ట్రిక్ ట్రాక్టర్ — X45H2 — యొక్క పూర్తి ఉత్పత్తి వివరణ, ఫీచర్లు మరియు సామర్థ్యాలు." },
      { title: "X45H2 — భారీ వర్షాలు & వరదలు ఉన్న పొలాల్లో రోటవేటర్ పడ్లింగ్", desc: "భారీ వర్షాల సీజన్ మరియు పూర్తిగా వరదలు ఉన్న పొలాల పరిస్థితుల్లో X45H2 రోటవేటర్ పడ్లింగ్ పనులను ఎలా నిర్వహిస్తుందో చూడండి." },
      { title: "మహారాష్ట్రలోనే మొట్టమొదటి ఎలక్ట్రిక్ ట్రాక్టర్ జైవంత్ షుగర్ మిల్‌కు పంపిణీ", desc: "జైవంత్ షుగర్ మిల్లు, కరాడ్, సతారాకు మొదటి ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్ యొక్క చారిత్రాత్మక డెలివరీ — భారతీయ అగ్రి-EV లో ఒక మైలురాయి." },
      { title: "ఆటోనెక్స్ట్ 45HP ఎలక్ట్రిక్ ట్రాక్టర్ — పూర్తి పవర్ డెమో", desc: "వివిధ క్షేత్ర కార్యకలాపాలలో X45H2 తన పూర్తి టార్క్ మరియు పనితీరు సామర్థ్యాలను ప్రదర్శించడాన్ని చూడండి." },
      { title: "X45H2 — రవాణా, టిల్లర్, రీపర్ & వాటర్ జెట్ వాష్", desc: "X45H2 రవాణా, దున్నడం, కోయడం మరియు క్షుణ్ణంగా వాటర్ జెట్ వాష్ చేయడాన్ని చూపే సమగ్ర క్షేత్ర ప్రదర్శన." },
      { title: "ఆటోనెక్స్ట్ X45H2 ఎలక్ట్రిక్ ట్రాక్టర్ — ఉత్పత్తి వివరణ (హిందీలో)", desc: "భారతీయ రైతుల కోసం ఆటోనెక్స్ట్ X45H2 ఎలక్ట్రిక్ ట్రాక్టర్ యొక్క పూర్తి ఉత్పత్తి వివరణ హిందీలో." }
    ]
  },
  blogPage: {
    postsLabel: "పోస్ట్‌లు",
    postsValue: "20+",
    authorsLabel: "రచయితలు",
    authorsValue: "6",
    topicsLabel: "అంశాలు",
    posts: [
      {
        tag: "సాంకేతికత",
        title: "భారతీయ వ్యవసాయంలో విప్లవం: ఆటోనెక్స్ట్ యొక్క ఎలక్ట్రిక్ ట్రాక్టర్లు రైతులకు లాభాలను తీసుకువస్తున్నాయి",
        author: "ది ఇండియా వైర్ నెట్‌వర్క్",
        date: "ఆగస్టు 2025",
        readTime: "4 నిమిషాల పఠనం",
        image: "/images/x45h2Image2.webp",
        summary: "ఆటోనెక్స్ట్ ఆటోమేషన్ వ్యవస్థాపకుడు మరియు CEO కౌస్తబ్ ధోండే, మరియు కో-ఫౌండర్ మరియు COO పంకజ్ గోయల్‌తో జరిగిన ప్రత్యేక ముఖాముఖిలో, వారి సంస్థ భారతదేశంలో ఎలక్ట్రిక్ ట్రాక్టర్ విప్లవానికి ఎలా నాయకత్వం వహిస్తుందో తెలుసుకోండి.",
        externalUrl: "https://theindiawire.com/india/revolutionizing-indian-agriculture-autonxts-electric-tractors-bring-intelligence-sustainability-and-profitability-to-farmers/",
        featured: true
      },
      {
        tag: "అటానమస్ టెక్నాలజీ",
        title: "భారతదేశపు మొట్టమొదటి సెల్ఫ్ డ్రైవింగ్ ట్రాక్టర్ తయారీ",
        author: "ఇన్‌సైడర్స్ టాక్",
        date: "డిసెంబర్ 2024",
        readTime: "6 నిమిషాల పఠనం",
        image: "/images/videos/driverless-tractor-thumbnail.webp",
        summary: "ఆటోనెక్స్ట్ స్వయంప్రతిపత్తి గల వ్యవసాయ సాంకేతిక పరిజ్ఞానాన్ని అభివృద్ధి చేయడంలో ముందంజలో ఉంది, భారతదేశపు మొట్టమొదటి సెల్ఫ్-డ్రైవింగ్ ట్రాక్టర్‌ను సృష్టిస్తోంది.",
        externalUrl: "https://insiderstalk.in/building-indias-first-ever-self-driving-tractor/",
        featured: false
      },
      {
        tag: "భవిష్యత్ సాంకేతికత",
        title: "వ్యవసాయ భవిష్యత్తు: భారతదేశపు మొదటి సెల్ఫ్ డ్రైవింగ్ ట్రాక్టర్",
        author: "ట్రాక్టర్ జంక్షన్",
        date: "నవంబర్ 2024",
        readTime: "8 నిమిషాల పఠనం",
        image: "/images/blog/future-of-farming.webp",
        summary: "ఆటోనెక్స్ట్ ఆటోమేషన్ భారతదేశపు మొదటి స్వయంప్రతిపత్త ఎలక్ట్రిక్ ట్రాక్టర్‌తో వ్యవసాయ భవిష్యత్తుకు మార్గదర్శకత్వం వహిస్తోంది.",
        externalUrl: "https://www.tractorjunction.com/tractor-news/future-of-farming-india-first-self-driving-tractor/",
        featured: false
      },
      {
        tag: "వ్యవసాయ సాంకేతికత",
        title: "ఆటోనెక్స్ట్ ట్రాక్టర్: ఎలక్ట్రిక్ మరియు అటానమస్ టెక్నాలజీతో వ్యవసాయంలో విప్లవం",
        author: "ట్రాక్టర్ గురు",
        date: "అక్టోబర్ 2024",
        readTime: "9 నిమిషాల పఠనం",
        image: "/images/blog/autonxt-tractor-revolutionizing-agriculture.webp",
        summary: "ఆటోనెక్స్ట్ యొక్క వినూత్న ట్రాక్టర్ పరిష్కారాల సమగ్ర కవరేజ్ — ఎలక్ట్రిక్ ట్రాక్టర్లు, అటానమస్ డ్రైవింగ్ సామర్థ్యాలు మరియు స్మార్ట్ ఫార్మింగ్ పరిష్కారాలు.",
        externalUrl: "https://tractorguru.in/blog/category/autonxt-tractor/",
        featured: false
      },
      {
        tag: "కంపెనీ ప్రొఫైల్",
        title: "ఆటోనెక్స్ట్ ఆటోమేషన్: పయనీరింగ్ ఎలక్ట్రిక్ మరియు అటానమస్ వ్యవసాయ పరిష్కారాలు",
        author: "ట్రాక్సన్ రీసెర్చ్ టీమ్",
        date: "సెప్టెంబర్ 2024",
        readTime: "7 నిమిషాల పఠనం",
        image: "/images/blog/game-changing-electric-tractor.webp",
        summary: "స్థిరమైన వ్యవసాయానికి ఆటోనెక్స్ట్ ఆటోమేషన్ యొక్క వినూత్న విధానం యొక్క వివరణాత్మక కంపెనీ ప్రొఫైల్ మరియు విశ్లేషణ.",
        externalUrl: "https://tracxn.com/d/companies/autonxt-automation/__ZSsZ4cr50wm63YgF4zOMI1CcYVW2V43yS-5Lojtdze0",
        featured: false
      },
      {
        tag: "కంపెనీ ప్రొఫైల్",
        title: "కౌస్తుభ్ ధోండే: ఆటోనెక్స్ట్ ఆటోమేషన్ కథ, ఎలక్ట్రిక్ మరియు అటానమస్ వ్యవసాయ పరిష్కారాలకు నాయకత్వం",
        author: "SugerMint",
        date: "మే 2024",
        readTime: "5 నిమిషాల పఠనం",
        image: "/images/blog/kaustubh-dhonde-story.webp",
        summary: "ఆటోనెక్స్ట్ ఆటోమేషన్ వ్యవస్థాపకుడు & CEO కౌస్తుభ్ ధోండేతో ఒక ఉత్తేజకరమైన ముఖాముఖి, ఇందులో ఆయన తన వ్యక్తిగత ప్రేరణలు, భారతదేశంలో EV బ్రాండ్‌ను ప్రారంభించడంలోని సవాళ్లు మరియు దేశంలోని మొట్టమొదటి అటానమస్ ఎలక్ట్రిక్ ట్రాక్టర్ అభివృద్ధిని పంచుకున్నారు.",
        externalUrl: "https://sugermint.com/kaustubh-dhonde/",
        featured: false
      },
      {
        tag: "పరిశ్రమ వార్తలు",
        title: "ఆటోనెక్స్ట్ ఆటోమేషన్ ఎలక్ట్రిక్ - సెల్ఫ్ డ్రైవింగ్ ట్రాక్టర్‌ను ప్రారంభించడానికి సిద్ధంగా ఉంది",
        author: "BW ఆన్‌లైన్ బ్యూరో",
        date: "ఆగస్టు 2022",
        readTime: "3 నిమిషాల పఠనం",
        image: "/images/blog/autonxt-bw-autoworld.webp",
        summary: "ఎలక్ట్రిక్ ట్రాక్టర్ స్టార్టప్ ఆటోనెక్స్ట్ ఆటోమేషన్ మార్కెట్లో తన 20HP, 35HP మరియు 45HP ఎలక్ట్రిక్ ట్రాక్టర్ వేరియంట్‌లను విడుదల చేయడానికి సిద్ధంగా ఉంది, ఇందులో ఉత్పత్తికి సిద్ధంగా ఉన్న హై-టార్క్ ఎలక్ట్రిక్ పవర్‌ట్రెయిన్ మరియు అటానమస్ డ్రైవింగ్ ఫీచర్లు ఉన్నాయి.",
        externalUrl: "https://bwautoworld.com/article/autonxt-automation-to-launch-an-electric-self-driving-tractor-442543",
        featured: false
      }
    ]
  },
  evBlogPage: {
    articlesLabel: "వ్యాసాలు",
    articlesValue: "7 టెక్ గైడ్‌లు",
    topicsLabel: "కీలక దృష్టి",
    topicsValue: "5 వర్గాలు",
    avgReadLabel: "సగటు పఠనం",
    avgReadValue: "6 నిమిషాలు",
    categories: ["All", "Battery Tech", "Policy & Incentives", "Market Trends", "Future Tech"],
    articles: [
      {
        cat: "స్థిరత్వం",
        title: "హరిత వృద్ధి కోసం భారతదేశ పుష్‌లో పర్యావరణ అనుకూల ట్రాక్టర్ల పెరుగుదల",
        date: "జనవరి 2025",
        readTime: "6 నిమిషాలు",
        image: "/images/blog/future-of-farming.webp",
        summary: "పర్యావరణ అనుకూల ఎలక్ట్రిక్ ట్రాక్టర్ల ఆవిర్భావంతో భారతదేశం తన వ్యవసాయ రంగంలో గణనీయమైన పరివర్తనను చూస్తోంది.",
        externalUrl: "https://www.theautomonitor.com/the-rise-of-eco-friendly-tractors-in-indias-push-for-green-growth/",
        featured: true
      },
      {
        cat: "ఆవిష్కరణ",
        title: "ఎలక్ట్రిక్ ట్రాక్టర్ టెక్నాలజీతో స్థిరత్వం మరియు ఉత్పాదకతను అనుసంధానించడం",
        date: "నవంబర్ 2025",
        readTime: "7 నిమిషాలు",
        image: "/images/blog/bridging-sustainability.webp",
        summary: "ఎలక్ట్రిక్ ట్రాక్టర్ టెక్నాలజీ మెరుగైన ఉత్పాదకతతో పర్యావరణ స్థిరత్వాన్ని మిళితం చేయడం ద్వారా వ్యవసాయంలో విప్లవాత్మక మార్పులు చేస్తోంది.",
        externalUrl: "https://emobilityplus.com/2025/11/17/opinion-bridging-sustainability-and-productivity-with-electric-tractor-technology/",
        featured: true
      },
      {
        cat: "విప్లవం",
        title: "భారతీయ వ్యవసాయంలో ఎలక్ట్రిక్ ట్రాక్టర్లు స్థిరమైన విప్లవాన్ని ఎలా నడిపిస్తున్నాయి",
        date: "జనవరి 2025",
        readTime: "5 నిమిషాలు",
        image: "/images/blog/sustainable-revolution.webp",
        summary: "ఎలక్ట్రిక్ ట్రాక్టర్లు భారతదేశం అంతటా స్థిరమైన వ్యవసాయ విప్లవాన్ని నడిపిస్తున్నాయి, సాంప్రదాయ డీజిల్ యంత్రాలకు ప్రత్యామ్నాయాన్ని అందిస్తున్నాయి.",
        externalUrl: "https://republicnewsindia.com/how-electric-tractors-are-powering-a-sustainable-revolution-in-indian-agriculture/",
        featured: false
      },
      {
        cat: "భవిష్యత్ సాంకేతికత",
        title: "పొగ లేకుండా వ్యవసాయం: ఎలక్ట్రిక్ ట్రాక్టర్లు భారతీయ వ్యవసాయ భవిష్యత్తు ఎందుకు",
        date: "ఫిబ్రవరి 2025",
        readTime: "8 నిమిషాలు",
        image: "/images/blog/farming-without-fumes.webp",
        summary: "ఎలక్ట్రిక్ ట్రాక్టర్లు భారతీయ వ్యవసాయం యొక్క భవిష్యత్తును సూచిస్తాయి, హానికరమైన ఉద్గారాలను తొలగించి ఉన్నతమైన పనితీరును అందిస్తాయి.",
        externalUrl: "https://www.thehindubusinessline.com/economy/agri-business/farming-without-fumes-why-electric-tractors-are-the-future-of-indian-agriculture/article70202273.ece",
        featured: false
      },
      {
        cat: "బ్యాటరీ టెక్నాలజీ",
        title: "ఎలక్ట్రిక్ ట్రాక్టర్ల తదుపరి తరానికి శక్తినిచ్చే వినూత్న బ్యాటరీ సాంకేతికతలు",
        date: "జూలై 2024",
        readTime: "6 నిమిషాలు",
        image: "/images/blog/innovative-battery-tech.webp",
        summary: "వినూత్న బ్యాటరీ సాంకేతికతలు, మాడ్యులర్ సిస్టమ్స్ మరియు హేడ్రోజన్ ఫ్యూయల్ సెల్స్ ద్వారా నడపబడే స్థిరమైన వ్యవసాయంలో ఎలక్ట్రిక్ ట్రాక్టర్లు ఎలా కీలకమైన పరిష్కారంగా ఎదుగుతున్నాయో అన్వేషిస్తుంది.",
        externalUrl: "https://www.theautomonitor.com/innovative-battery-technologies-powering-the-next-generation-of-electric-tractors/",
        featured: false
      },
      {
        cat: "విధానాలు & ప్రోత్సాహకాలు",
        title: "ఎలక్ట్రిక్ ట్రాక్టర్ల స్వీకరణను ప్రోత్సహిస్తున్న ప్రభుత్వ విధానాలు మరియు రాయితీలు",
        date: "జనవరి 2025",
        readTime: "6 నిమిషాలు",
        image: "/images/blog/government-policies.webp",
        summary: "ప్రభుత్వ విధానాలు, రాయితీలు మరియు గ్లోబల్ సస్టైనబిలిటీ కార్యక్రమాలు వ్యవసాయ రంగాన్ని పర్యావరణ అనుకూల ఎలక్ట్రిక్ ట్రాక్టర్ల వైపు ఎలా నడిపిస్తున్నాయో చర్చిస్తుంది.",
        externalUrl: "https://www.theautomonitor.com/government-policies-and-subsidies-driving-the-adoption-of-electric-tractors/",
        featured: false
      },
      {
        cat: "మార్కెట్ ధోరణులు",
        title: "భారతీయ వ్యవసాయంలో ఎలక్ట్రిక్ ట్రాక్టర్లకు 2026 ఎందుకు టర్నింగ్ పాయింట్ కావచ్చు",
        date: "జనవరి 2026",
        readTime: "4 నిమిషాలు",
        image: "/images/blog/why-2026-turning-point.webp",
        summary: "రాబోయే విధాన మార్పులు, బ్యాటరీ ధరల తగ్గింపు మరియు సాంకేతిక మెరుగుదలలు భారతదేశంలో ఎలక్ట్రిక్ ట్రాక్టర్ స్వీకరణకు 2026ని ఎలా ఒక మైలురాయిగా మార్చగలవో వివరిస్తుంది.",
        externalUrl: "https://www.theautomonitor.com/why-2026-could-be-the-turning-point-for-electric-tractors-in-indian-agriculture/",
        featured: false
      }
    ],
    authorRoleLabel: "Publication",
    stats: [
      { value: "38%", label: "మార్కెట్ CAGR 2024–27" },
      { value: "₹4,000 కోట్లు", label: "2027 నాటికి భారతదేశం EV ట్రాక్టర్ TAM" },
      { value: "70%", label: "డీజిల్ కంటే తక్కువ రన్నింగ్ ఖర్చులు" },
      { value: "0", label: "ప్రత్యక్ష CO₂ ఉద్గారాలు" }
    ]
  },
  newsPage: {
    storiesLabel: "కథనాలు",
    storiesValue: "50+",
    coverageLabel: "ప్రచురణకర్తలు",
    coverageValue: "National",
    milestonesLabel: "వర్గాలు",
    milestonesValue: "6 Key",
    readMore: "Read More",
    news: [
      {
        date: "6/18/2026",
        tag: "అవార్డు",
        title: "ITOTY 2026లో మొట్టమొదటి 'ఎలక్ట్రిక్ ట్రాక్టర్ ఆఫ్ ది ఇయర్' అవార్డును గెలుచుకున్న ఆటోనెక్స్ట్ ఆటోమేషన్",
        summary: "ఇండియన్ ట్రాక్టర్ ఆఫ్ ది ఇయర్ (ITOTY) అవార్డ్స్ 2026లో ఆటోనెక్స్ట్ ఆటోమేషన్ మొట్టమొదటి 'ఎలక్ట్రిక్ ట్రాక్టర్ ఆఫ్ ది ఇయర్' అవార్డును గెలుచుకుంది, ఇది భారతదేశపు ఎలక్ట్రిక్ వ్యవసాయ యంత్రాల పరిశ్రమలో ఒక చారిత్రాత్మక మైలురాయి.",
        author: "ఆటోనెక్స్ట్ టీమ్",
        readTime: "3 నిమిషాల పఠనం",
        image: "/images/linkedin/linkedin-post-1.webp",
        externalUrl: "https://www.linkedin.com/posts/autonxt-automation_autonxt-itoty2026-electrictractoroftheyear-activity-7473003691902451712-w4BZ?utm_source=share&utm_medium=member_desktop&rcm=ACoAACrujPEBnx6l4DUGYojLDsLzMTTIYS7FTxk"
      },
      {
        date: "11/10/2024",
        tag: "ఈవెంట్",
        title: "ఢిల్లీ ఈవీ ర్యాలీ 'BREATHE' లో ఎలక్ట్రిక్ ట్రాక్టర్‌ను ప్రదర్శించిన ఆటోనెక్స్ట్, ప్రశంసించిన మంత్రి మనోహర్ లాల్ ఖట్టర్",
        summary: "ఢిల్లీలో జరిగిన CESL ప్రతిష్టాత్మక EV ర్యాలీ, BREATHEలో పాల్గొన్న ఏకైక ఎలక్ట్రిక్ ట్రాక్టర్ ఆటోనెక్స్ట్. గౌరవనీయులైన విద్యుత్ శాఖ మంత్రి శ్రీ మనోహర్ లాల్ ఖట్టర్ మా ట్రాక్టర్‌పై ప్రయాణించి, దాని పనితీరును అభినందించారు.",
        author: "ఆటోనెక్స్ట్ టీమ్",
        readTime: "3 నిమిషాల పఠనం",
        image: "/images/events/event-1.webp",
        externalUrl: "https://www.linkedin.com/company/autonxt-automation"
      },
      {
        date: "4/10/2024",
        tag: "ఉత్పత్తి ప్రారంభం",
        title: "భారతదేశపు మొట్టమొదటి సెల్ఫ్ డ్రైవింగ్ ఎలక్ట్రిక్ ట్రాక్టర్‌ను లాంచ్ చేయనున్న ఆటోనెక్స్ట్ ఆటోమేషన్",
        summary: "ఆటోనెక్స్ట్ భారతదేశపు మొట్టమొదటి సెల్ఫ్-డ్రైవింగ్ ఎలక్ట్రిక్ ట్రాక్టర్‌ను ఆవిష్కరించింది, వినూత్న సాంకేతికత మరియు నిధుల మద్దతుతో స్థిరమైన వ్యవసాయాన్ని ముందుకు తీసుకెళ్తోంది.",
        author: "రాబిన్ కుమార్ అత్రి",
        readTime: "5 నిమిషాల పఠనం",
        externalUrl: "https://www.cmv360.com/tractors/news/autonxt-automation-launching-india-first-self-driving-electric-tractor"
      },
      {
        date: "4/9/2024",
        tag: "నిధులు",
        title: "ఆటోనెక్స్ట్ ఆటోమేషన్ Saama నేతృత్వంలో ప్రీ-సిరీస్ A నిధులను పొందింది",
        summary: "వివిధ రంగాలలో వాణిజ్య వినియోగం కోసం రూపొందించబడిన సెల్ఫ్ డ్రైవింగ్ ఎంపికలతో ఆటోనెక్స్ట్ భారతదేశపు మొట్టమొదటి ఎలక్ట్రిక్ ట్రాక్టర్‌ను విడుదల చేయడానికి సిద్ధంగా ఉంది.",
        author: "ఆన్‌లైన్ బ్యూరో",
        readTime: "2 నిమిషాల పఠనం",
        externalUrl: "https://auto.economictimes.indiatimes.com/news/automotive/autonxt-automation-secures-pre-series-a-funding-led-by-saama/109165048"
      },
      {
        date: "4/10/2024",
        tag: "నిధులు",
        title: "ఆటోనెక్స్ట్ భారతదేశపు మొదటి సెల్ఫ్ డ్రైవింగ్ ఎలక్ట్రిక్ ట్రాక్టర్‌ను పరిచయం చేస్తుంది, ప్రీ-సిరీస్ ఎ ఫండింగ్ పొందింది",
        summary: "ఆటోనెక్స్ట్ ఆటోమేషన్ Saama నేతృత్వంలోని దాని ప్రీ-సిరీస్ A ఫండింగ్ రౌండ్‌ను విజయవంతంగా ముగించింది.",
        author: "సునేహా మిశ్రా",
        readTime: "4 నిమిషాల పఠనం",
        externalUrl: "https://tractornews.in/news/autonxt-automation-to-introduce-india-s-first-self-driving-electric-tractor-secures-pre-series-a-funding/"
      },
      {
        date: "4/9/2024",
        tag: "నిధులు",
        title: "ఆటోనెక్స్ట్ ఆటోమేషన్ Saama నుండి ప్రీ-సిరీస్ A నిధులను పొందింది",
        summary: "వాణిజ్య అనువర్తనాల కోసం భారతదేశపు మొట్టమొదటి సెల్ఫ్-డ్రైవింగ్ ఎలక్ట్రిక్ ట్రాక్టర్ అభివృద్ధిని వేగవంతం చేయడానికి ఆటోనెక్స్ట్ ఆటోమేషన్ ముఖ్యమైన నిధులను పొందుతుంది.",
        author: "ట్రాక్టర్ జంక్షన్",
        readTime: "3 నిమిషాల పఠనం",
        externalUrl: "https://www.tractorjunction.com/tractor-news/autonxt-automation-secures-pre-series-a-funding-from-saama/"
      },
      {
        date: "4/9/2024",
        tag: "నిధులు",
        title: "ఎలక్ట్రిక్ అటానమస్ ట్రాక్టర్ డెవలప్‌మెంట్ కోసం ఆటోనెక్స్ట్ నిధులను పొందింది",
        summary: "ఆటోనెక్స్ట్ ఆటోమేషన్ వాణిజ్య మరియు వ్యవసాయ అనువర్తనాల కోసం ఎలక్ట్రిక్ అటానమస్ ట్రాక్టర్ల అభివృద్ధిని ముందుకు తీసుకురావడానికి నిధులను పొందింది.",
        author: "మెర్కామ్ ఇండియా",
        readTime: "3 నిమిషాల పఠనం",
        externalUrl: "https://www.mercomindia.com/autonxt-pre-series-a-funding"
      },
      {
        date: "4/10/2024",
        tag: "ఆవిష్కరణ",
        title: "ఆటోనెక్స్ట్ గేమ్-ఛేంజింగ్ ఎలక్ట్రిక్ ట్రాక్టర్ వ్యవసాయం మరియు పరిశ్రమను మార్చడానికి సెట్ చేయబడింది",
        summary: "సెల్ఫ్-డ్రైవింగ్ సామర్థ్యాలతో కూడిన ఆటోనెక్స్ట్ విప్లవాత్మక ఎలక్ట్రిక్ ట్రాక్టర్ భారతదేశం అంతటా వ్యవసాయం మరియు పారిశ్రామిక కార్యకలాపాలను మార్చడానికి సిద్ధంగా ఉంది.",
        author: "అహ్మదాబాద్ మిర్రర్",
        readTime: "4 నిమిషాల పఠనం",
        externalUrl: "https://www.ahmedabadmirror.com/autonxts-game-changing-electric-tractor-set-to-transform-farming-and-industry-in-india/81891265.html"
      },
      {
        date: "4/10/2024",
        tag: "వ్యవసాయం",
        title: "భారతీయ వ్యవసాయంలో విప్లవం: ఆటోనెక్స్ట్ ఎలక్ట్రిక్ ట్రాక్టర్లు రైతులకు స్థిరత్వాన్ని తెస్తున్నాయి",
        summary: "ఆటోనెక్స్ట్ యొక్క ఎలక్ట్రిక్ ట్రాక్టర్లు దేశవ్యాప్తంగా ఉన్న రైతులకు మేధస్సు, స్థిరత్వం మరియు లాభదాయకతను తీసుకురావడం ద్వారా భారతీయ వ్యవసాయంలో విప్లవాత్మక మార్పులు చేస్తున్నాయి.",
        author: "ఫస్ట్ ఇండియా",
        readTime: "5 నిమిషాల పఠనం",
        externalUrl: "https://firstindia.co.in/news/press-releases/revolutionizing-indian-agriculture-autonxts-electric-tractors-bring-intelligence-sustainability-and-profitability-to-farmers"
      },
      {
        date: "4/9/2024",
        tag: "నిధులు",
        title: "ఆటోనెక్స్ట్ ఆటోమేషన్ ఎలక్ట్రిక్ అటానమస్ ట్రాక్టర్ కోసం ప్రీ-సిరీస్ ఎ ఫండింగ్‌ను పొందింది",
        summary: "ఆటోనెక్స్ట్ ఆటోమేషన్ స్థిరమైన వ్యవసాయ పరిష్కారాల కోసం ఎలక్ట్రిక్ అటానమస్ ట్రాక్టర్ల అభివృద్ధిని ముందుకు తీసుకురావడానికి నిధులను పొందుతుంది.",
        author: "ఈవీ రిపోర్టర్",
        readTime: "3 నిమిషాల పఠనం",
        externalUrl: "https://evreporter.com/autonxt-automation-secures-pre-series-a-funding-for-electric-autonomous-tractor/"
      }
    ]
  },

  dealerPage: {
    metaTitle: "సేల్స్ పార్టనర్ & డీలర్ నెట్‌వర్క్ | AutoNxt ఎలక్ట్రిక్ ట్రాక్టర్లు",
    metaDescription: "భారతదేశ వ్యాప్తంగా AutoNxt అధీకృత సేల్స్ పార్టనర్లు, డీలర్ ప్రొఫైల్‌లు మరియు వారి పని తెలుసుకోండి.",
    badge: "సేల్స్ పార్టనర్ కార్యక్రమం",
    title: "AutoNxt సేల్స్",
    titleHighlight: "పార్టనర్ అవ్వండి",
    subtitle: "భారతదేశ అగ్రగామి ఎలక్ట్రిక్ ట్రాక్టర్ విప్లవంలో చేరండి. మా దేశవ్యాప్త సేల్స్ పార్టనర్ నెట్‌వర్క్, డీలర్ ప్రొఫైల్‌లు చూసి దరఖాస్తు చేయండి.",
    mapSection: {
      badge: "దేశవ్యాప్త నెట్‌వర్క్",
      title: "భారతదేశమంతటా AutoNxt మార్కెట్ ప్రెజెన్స్",
      subtitle: "మా అధీకృత సేల్స్ పార్టనర్లు, అనుభవ కేంద్రాలు మరియు 3S సేవా హబ్‌లు ప్రధాన వ్యవసాయ మరియు పారిశ్రామిక కేంద్రాలలో పనిచేస్తున్నాయి.",
      stats: [
        { value: "25+", label: "యాక్టివ్ డీలర్‌షిప్ అవుట్‌లెట్లు" },
        { value: "15+", label: "కవర్ చేయబడిన రాష్ట్రాలు" },
        { value: "100%", label: "3S సర్వీస్ సపోర్ట్" },
        { value: "500+", label: "చార్జింగ్ నెట్‌వర్క్ పాయింట్లు" }
      ]
    },
    profilesSection: {
      badge: "డీలర్ నెట్‌వర్క్",
      title: "మా అధీకృత సేల్స్ పార్టనర్లు & వారి పని",
      subtitle: "భారతీయ వ్యవసాయం మరియు పరిశ్రమలకు ఎలక్ట్రిక్ ట్రాక్టర్లు అందించే మా విశ్వసనీయ డీలర్‌షిప్ ప్రొఫైల్‌లు చూడండి.",
      searchPlaceholder: "డీలర్ పేరు, నగరం, రాష్ట్రం లేదా పని ద్వారా శోధించండి...",
      filterAll: "అన్ని రాష్ట్రాలు",
      contactDealer: "పార్టనర్‌ని సంప్రదించండి",
      viewWork: "విజయాలు చూడండి",
    },
    benefits: {
      title: "AutoNxt తో పార్టనర్ ఎందుకు అవ్వాలి?",
      subtitle: "ప్రత్యేక ప్రయోజనాలను అన్‌లాక్ చేయండి మరియు భారతదేశ అగ్రగామి ఎలక్ట్రిక్ ట్రాక్టర్ బ్రాండ్‌తో వృద్ధి చెందండి.",
      items: [
        { title: "ప్రత్యేక భూభాగ హక్కులు", description: "అతిక్రమణ డీలర్‌షిప్‌లు లేకుండా, మీ ప్రాంతంలో గరిష్ట మార్కెట్ సామర్థ్యాన్ని నిర్ధారించే అంకితమైన ప్రాంతీయ హక్కులు." },
        { title: "శిక్షణ & ధృవీకరణ", description: "మీ బృందాన్ని నిపుణుల-స్థాయి జ్ఞానంతో సన్నద్ధం చేయడానికి సమగ్ర ఉత్పత్తి, విక్రయాలు మరియు సేవా శిక్షణ." },
        { title: "మార్కెటింగ్ మద్దతు", description: "లీడ్‌లు మరియు బ్రాండ్ దృశ్యతను పెంచడానికి సహ-బ్రాండెడ్ మార్కెటింగ్ మెటీరియల్‌లు, డిజిటల్ ప్రచారాలు మరియు ఈవెంట్ మద్దతు." },
        { title: "పోటీ మార్జిన్లు", description: "ఆకర్షణీయ డీలర్ మార్జిన్లు మరియు వాల్యూమ్-ఆధారిత ప్రోత్సాహక కార్యక్రమాలు." }
      ]
    },
    form: {
      title: "సేల్స్ పార్టనర్ అవ్వడానికి దరఖాస్తు చేయండి",
      subtitle: "దిగువ ఫారమ్‌ను నింపండి మరియు మా బృందం 24–48 గంటల్లో మిమ్మల్ని సంప్రదిస్తుంది.",
      name: "పూర్తి పేరు",
      namePlaceholder: "మీ పూర్తి పేరు నమోదు చేయండి",
      email: "ఈమెయిల్ చిరునామా",
      emailPlaceholder: "you@company.com",
      phone: "ఫోన్ నంబర్",
      phonePlaceholder: "+91 98765 43210",
      company: "కంపెనీ / ఫర్మ్ పేరు",
      companyPlaceholder: "మీ వ్యాపారం లేదా ఫర్మ్ పేరు",
      city: "నగరం / జిల్లా",
      cityPlaceholder: "ఉదా. సతారా, నాసిక్, లూధియానా",
      state: "రాష్ట్రం",
      statePlaceholder: "మీ రాష్ట్రాన్ని ఎంచుకోండి",
      experience: "ప్రస్తుత వ్యాపారం / డీలర్‌షిప్ అనుభవం",
      experiencePlaceholder: "ఉదా. ఆటో / వ్యవసాయ యంత్రాల్లో 5+ సంవత్సరాలు",
      message: "మీరు AutoNxt సేల్స్ పార్టనర్ ఎందుకు అవ్వాలనుకుంటున్నారు?",
      messagePlaceholder: "మీ షోరూమ్/వర్క్‌షాప్ సౌకర్యాలు, టీమ్ సైజ్ మరియు EV ట్రాక్టర్ల పట్ల మీ దార్శనికత గురించి చెప్పండి...",
      submit: "సేల్స్ పార్టనర్ దరఖాస్తు సమర్పించండి",
      submitting: "సమర్పిస్తోంది...",
      successTitle: "సేల్స్ పార్టనర్ దరఖాస్తు సమర్పించబడింది!",
      successMessage: "AutoNxt తో భాగస్వామ్యం చేయడంలో మీ ఆసక్తికి ధన్యవాదాలు. మా బృందం త్వరలో మిమ్మల్ని సంప్రదిస్తుంది.",
      errorMessage: "ఏదో తప్పు జరిగింది. దయచేసి మళ్ళీ ప్రయత్నించండి.",
      submitAnother: "మరో దరఖాస్తు సమర్పించండి"
    },
    states: [
      "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
      "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
      "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
      "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
      "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
      "Uttar Pradesh", "Uttarakhand", "West Bengal",
      "Delhi", "Jammu & Kashmir", "Ladakh", "Puducherry", "Chandigarh"
    ],
    directory: {
      tag: "అధీకృత నెట్‌వర్క్",
      title: "అధీకృత డీలర్లు మరియు ప్రాంతాలు",
      subtitle: "భారతదేశవ్యాప్తంగా ఆటోనెక్స్ట్ తనిఖీ చేసిన అధీకృత డీలర్‌షిప్ కేంద్రాలు, విక్రయ భాగస్వాములు మరియు సేవా కేంద్రాల నెట్‌వర్క్‌ను అన్వేషించండి.",
      searchPlaceholder: "డీలర్ పేరు, నగరం, ఈమెయిల్, మొబైల్ లేదా చిరునామా శోధించండి...",
      allStates: "అన్ని రాష్ట్రాలు",
      dacNumber: "డీఏసీ సంఖ్య",
      dealerName: "డీలర్ పేరు",
      email: "డీలర్ ఈమెయిల్",
      mobile: "డీలర్ మొబైల్",
      gstNo: "డీలర్ జీఎస్‌టీ సంఖ్య",
      panNo: "డీలర్ పాన్ సంఖ్య",
      address: "చిరునామా",
      noResults: "మీ శోధనకు సరిపోలే అధీకృత డీలర్లు కనుగొనబడలేదు.",
      resetSearch: "ఫిల్టర్లు రీసెట్ చేయండి",
      dealers: [
        {
          id: "4",
          dealerName: "కాంపేజ్ ఆటోమేషన్ సిస్టమ్",
          address: "ప్లాట్ నం. 20-21, సెక్టార్ 12, న్యూ డిఎల్ఎఫ్ ఇండస్ట్రియల్ ఏరియా, హర్యానా, ఫరీదాబాద్, 121003",
          state: "హర్యానా"
        },
        {
          id: "5",
          dealerName: "కిసాన్ కళ్యాణ్ ఎంటర్‌ప్రైజెస్",
          address: "షాప్ 02, మోర్ హౌస్ గ్రౌండ్ ఫ్లోర్, కోర్ట్ ఏరియా, రేమండ్ ఎదురుగా, బార్, పాట్నా, బీహార్, 803213",
          state: "బీహార్"
        },
        {
          id: "6",
          dealerName: "ఎస్‌ఎస్ కార్పొరేషన్",
          address: "ఖతౌనీ నం 5152, ఖేవట్ నం 3262, ఎన్, నమస్తే చౌక్, కర్నాల్, హర్యానా, 132001",
          state: "హర్యానా"
        },
        {
          id: "7",
          dealerName: "సాయి సీమా ఆటోమోటివ్",
          address: "గట్ నం 579/580 సాయి సీమా ఆటోమోటివ్, కొకన్‌గావ్ నిఫాడ్, పింపల్‌గావ్ బస్వంత్, మహారాష్ట్ర, నాసిక్, 422209",
          state: "మహారాష్ట్ర"
        }
      ]
    }
  },

  // Team Page
  teamPage: {
    metaTitle: "మా బృందం మరియు నాయకత్వం | AutoNxt ఎలక్ట్రిక్ ట్రాక్టర్లు",
    metaDescription: "AutoNxt Automation లో భారతదేశపు మొట్టమొదటి ఎలక్ట్రిక్ మరియు స్వయంప్రతిపత్త ట్రాక్టర్ సాంకేతికతను నిర్మిస్తున్న ఇంజనీర్లు, ఆవిష్కర్తలు మరియు నాయకులను కలవండి.",
    badge: "మా ఆవిష్కర్తలు",
    title: "AutoNxt రూపకర్తలను",
    titleHighlight: "కలవండి",
    subtitle: "భారతీయ వ్యవసాయం మరియు పరిశ్రమలను విద్యుదీకరిస్తున్న దూరదృష్టిగల నాయకులు, మెకానికల్ ఇంజనీర్లు, పవర్‌ట్రైన్ నిపుణులు, రోబోటిక్స్ నిపుణులు మరియు వ్యవసాయ సాంకేతిక నిపుణుల బృందం.",
    stats: [
      { value: "150+", label: "ఉత్సాహభరిత ఆవిష్కర్తలు" },
      { value: "10+", label: "ఇంజనీరింగ్ విభాగాలు" },
      { value: "50+", label: "పేటెంట్లు & ధృవీకరణలు" },
      { value: "100%", label: "స్వదేశీ ఆవిష్కరణ" }
    ],
    categories: {
      all: "అందరూ సభ్యులు",
      leadership: "నాయకత్వం",
      finance: "ఫైనాన్స్ & స్ట్రాటజీ",
      sales: "సేల్స్ బృందం",
      powertrain: "పవర్‌ట్రైన్ & బ్యాటరీ",
      robotics: "రోబోటిక్స్ & సాఫ్ట్‌వేర్",
      manufacturing: "ప్లాంట్ & తయారీ",
      advisors: "సలహాదారుల బోర్డు"
    },
    leadershipTitle: "ఎగ్జిక్యూటివ్ లీడర్‌షిప్",
    leadershipSubtitle: "స్థిరమైన యాంత్రీకరణ మరియు స్వయంప్రతిపత్త భవిష్యత్తు కోసం AutoNxt కు మార్గదర్శకత్వం.",
    teamTitle: "కోర్ ఇంజనీరింగ్ & ఆపరేషన్స్",
    teamSubtitle: "అధిక టార్క్ కలిగిన ఎలక్ట్రిక్ ట్రాక్టర్లను రూపొందించి అభివృద్ధి చేస్తున్న ప్రపంచ స్థాయి ప్రతిభ.",
    advisorsTitle: "వ్యూహాత్మక సలహా మండలి",
    advisorsSubtitle: "AutoNxt ను గ్లోబల్ ఎక్సలెన్స్ వైపు నడిపిస్తున్న పరిశ్రమల ప్రముఖులు మరియు నిపుణులు.",
    connectLinkedIn: "లింక్డ్‌ఇన్‌లో కనెక్ట్ అవ్వండి",
    connect: "కనెక్ట్ అవ్వండి",
    ctaBadge: "AutoNxt లో కెరీర్",
    ctaTitle: "ఎలక్ట్రిక్ వ్యవసాయ భవిష్యత్తును నిర్మించాలనుకుంటున్నారా?",
    ctaDesc: "ఆవిష్కర్తలు మరియు సాంకేతిక నిపుణుల బృందంలో చేరండి. ఇంజనీరింగ్, ఆపరేషన్స్ మరియు సాఫ్ట్‌వేర్ ఉద్యోగ అవకాశాలను పరిశీలించండి.",
    ctaButton: "ఖాళీలను చూడండి",
    teamMembers: [
      {
        name: "కౌస్తుభ్ ధోండే",
        role: "చీఫ్ ఎగ్జిక్యూటివ్ ఆఫీసర్ (CEO)",
        category: "leadership",
        bio: "నూతన ఎలక్ట్రిక్ వాహన పరిష్కారాలతో వ్యవసాయంలో విప్లవాత్మక మార్పులు తీసుకురావాలనే లక్ష్యంతో AutoNxt ను నడిపిస్తున్న నాయకుడు.",
        featured: true
      },
      {
        name: "పంకజ్ గోయల్",
        role: "కో-ఫౌండర్ & COO",
        category: "leadership",
        bio: "వ్యూహాత్మక ఎదుగుదల, రోజువారీ కార్యకలాపాలు మరియు భాగస్వామ్యాలను పర్యవేక్షిస్తూ సంస్థను విజయవంతంగా నడుపుతున్న వ్యూహకర్త.",
        featured: true
      },
      {
        name: "గౌరవ్ బోర్కర్",
        role: "చీఫ్ ఫైనాన్షియల్ ఆఫీసర్ (CFO)",
        category: "finance",
        bio: "ఆర్థిక వ్యూహం, నిధుల సేకరణ మరియు కార్పొరేట్ పాలనను నడిపిస్తున్న అనుభవజ్ఞుడైన ఫైనాన్స్ నిపుణుడు.",
        featured: true
      },
      {
        name: "అమిత్ కుమార్ శివహరే",
        role: "హెడ్ – అకౌంట్స్",
        category: "finance",
        bio: "కార్పొరేట్ అకౌంటింగ్, టాక్సేషన్ మరియు చట్టబద్ధమైన నిబంధనల పాటించడంలో 16+ సంవత్సరాల అనుభవం కలిగిన సీనియర్ లీడర్."
      },
      {
        name: "హరి కిషన్",
        role: "ప్లాంట్ హెడ్",
        category: "manufacturing",
        bio: "ప్లాంట్ కార్యకలాపాలను పర్యవేక్షిస్తూ ప్రతి ట్రాక్టర్ నాణ్యత మరియు సామర్థ్యాన్ని నిర్ధారిస్తారు."
      },
      {
        name: "సుదీప్తో దేబ్",
        role: "లీడ్ పవర్ ట్రైన్ ఇంజనీర్",
        category: "powertrain",
        bio: "పవర్ ఎలక్ట్రానిక్స్ నిపుణుడు, మా ట్రాక్టర్లకు శక్తినిచ్చే ఎలక్ట్రికల్ సిస్టమ్స్‌ను డిజైన్ చేసి ఆప్టిమైజ్ చేస్తారు."
      },
      {
        name: "వాంశీ అట్లూరి",
        role: "లీడ్ మెకానికల్ డిజైన్ ఇంజనీర్",
        category: "powertrain",
        bio: "వివిధ వ్యవసాయ అవసరాల కోసం బలమైన మరియు సమర్థవంతమైన ట్రాక్టర్ నిర్మాణాలను రూపొందించే మెకానికల్ డిజైన్ ఇన్నోవేటర్."
      },
      {
        name: "డా. ధర్మతేజ అడపా",
        role: "లీడ్ రోబోటిక్స్ ఇంజనీర్",
        category: "robotics",
        bio: "ట్రాక్టర్ యొక్క అత్యుత్తమ పనితీరు కోసం స్మార్ట్ టెక్నాలజీలను ఏకీకృతం చేయడంలో ప్రత్యేకత కలిగిన ఆటోమేషన్ నిపుణుడు."
      },
      {
        name: "తేజేష్ మాదిరెడ్డి",
        role: "లీడ్ ఎంబెడెడ్ ఇంజనీర్",
        category: "robotics",
        bio: "విశ్వసనీయ హార్డ్‌వేర్-సాఫ్ట్‌వేర్ సమన్వయాన్ని నిర్ధారిస్తూ ఎంబెడెడ్ సిస్టమ్స్ అభివృద్ధిని నడిపిస్తారు."
      },
      {
        name: "అశ్వంత్ ములుపూరి",
        role: "రోబోటిక్స్ & ఆటోమేషన్ ఇంజనీర్",
        category: "robotics",
        bio: "స్వయంప్రతిపత్త ట్రాక్టర్ల నిర్వహణ కోసం అధునాతన నియంత్రణ వ్యవస్థలను అభివృద్ధి చేసే ఆటోమేషన్ స్పెషలిస్ట్."
      },
      {
        name: "అజింక్య దెల్వి",
        role: "పవర్ ట్రైన్ ఇంజనీర్",
        category: "powertrain",
        bio: "పవర్ ట్రైన్ సిస్టమ్స్‌పై పని చేస్తూ పనితీరు మరియు సామర్థ్యాన్ని మెరుగుపరుస్తారు."
      },
      {
        name: "ఖుష్‌ప్రీత్ సింగ్",
        role: "టెస్టింగ్ & వాలిడేషన్ ఇంజనీర్",
        category: "manufacturing",
        bio: "ఉత్పత్తుల విశ్వసనీయత మరియు భద్రతను నిర్ధారించడానికి కఠినమైన పరీక్షలు మరియు ధృవీకరణలను నిర్వహిస్తారు."
      },
      {
        name: "స్వప్నేష్ జహాగీర్దార్",
        role: "బిజినెస్ డెవలప్‌మెంట్ మేనేజర్",
        category: "sales",
        bio: "కంపెనీ విస్తరణను వేగవంతం చేయడానికి కొత్త వ్యాపార అవకాశాలను గుర్తించడం మరియు సంబంధాలను పెంపొందించడంపై దృష్టి సారిస్తారు."
      }
    ],
    advisorsList: [
      {
        name: "ఐవీ-రావు",
        role: "సీనియర్ సలహాదారు",
        bio: "మారుతి సుజుకి మాజీ ఎగ్జిక్యూటివ్ అడ్వైజర్ & ఇంజనీరింగ్ హెడ్. ఆటోమోటివ్ ఆర్కిటెక్చర్ మరియు సిస్టమ్స్ ఇంజనీరింగ్‌లో AutoNxt కు మార్గదర్శకత్వం."
      },
      {
        name: "ఆశిష్ మెహతా",
        role: "ఫైనాన్షియల్ అడ్వైజర్",
        bio: "మూలధన కేటాయింపు, వెంచర్ స్కేల్ మరియు స్థిరమైన వాణిజ్య విస్తరణపై సలహాలు అందించే సీనియర్ ఆర్థిక వ్యూహకర్త."
      },
      {
        name: "స్వాదీప్ పిల్లారిశెట్టి",
        role: "వ్యూహ సలహాదారు",
        bio: "ఉత్పత్తి-మార్కెట్ అనుకూలత, వ్యాపార విస్తరణ మరియు ప్రభావవంతమైన భాగస్వామ్యాలను వేగవంతం చేయడంలో అంతర్జాతీయ నిపుణుడు."
      }
    ]
  }
};
